/* @ts-self-types="./target_wasm.d.ts" */
import { contextStale, fetchViewForClipboard, getSavedViewport, importGraphTable, linksCreate, linksDelete, linksFetchForTable, linksFetchForTables, onFollowStateChanged, onParentModelUpdate, onSessionActive, onSessionAway, putIntoClipboard, requestRowGraphReexpand, saveViewport, setCanvasCommitState, setCanvasFocusPattern, setCanvasFocus, setCanvasInput, setCanvasMode, setCellActionIcon, setCursorMode, setFocusedCell, setFormulaPeek, setGraphExternal, setGraphOutsideTable, setNewRowCount, setOrnamentHint, setOverflowIcon, setPresenceHint, setRowGraphOverlay, setRowGraph, setSelectedRowCount, setSelectedRow, setZoomRange, showConflictDialog, showNotification, showTypeChangeConfirm, useSendClientDataRequest, useSetColumnSelection, useUpdateActiveUsers, useUpdateTableDeletionState } from '../react-client/src/exports.tsx';

export class AccessRevokedFromTableNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AccessRevokedFromTableNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_accessrevokedfromtablenotification_free(ptr, 0);
    }
}
if (Symbol.dispose) AccessRevokedFromTableNotification.prototype[Symbol.dispose] = AccessRevokedFromTableNotification.prototype.free;

/**
 * @enum {0 | 1 | 2}
 */
export const AccessTokenStatus = Object.freeze({
    Active: 0, "0": "Active",
    Revoked: 1, "1": "Revoked",
    Expired: 2, "2": "Expired",
});

export class AddCheckpointAlias {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AddCheckpointAlias.prototype);
        obj.__wbg_ptr = ptr;
        AddCheckpointAliasFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AddCheckpointAliasFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_addcheckpointalias_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    checkpoint_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_checkpoint_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} checkpoint_id
     * @param {string} new_alias
     * @returns {AddCheckpointAlias}
     */
    static new_js(table_id, checkpoint_id, new_alias) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(new_alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.addcheckpointalias_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddCheckpointAlias.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    table_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_table_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.addcheckpointalias_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) AddCheckpointAlias.prototype[Symbol.dispose] = AddCheckpointAlias.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7}
 */
export const AlignOption = Object.freeze({
    Top: 0, "0": "Top",
    Left: 1, "1": "Left",
    Right: 2, "2": "Right",
    Bottom: 3, "3": "Bottom",
    DistributeH: 4, "4": "DistributeH",
    DistributeV: 5, "5": "DistributeV",
    CenterH: 6, "6": "CenterH",
    CenterV: 7, "7": "CenterV",
});

export class AvailableTableForFilterJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AvailableTableForFilterJS.prototype);
        obj.__wbg_ptr = ptr;
        AvailableTableForFilterJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AvailableTableForFilterJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_availabletableforfilterjs_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get alias() {
        const ret = wasm.availabletableforfilterjs_alias(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {TableColumnMetadataJS[]}
     */
    get columns() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.availabletableforfilterjs_columns(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} table_name
     * @param {number} alias
     * @param {string} sql_alias
     * @param {TableColumnMetadataJS[]} columns
     * @returns {AvailableTableForFilterJS}
     */
    static new(table_id, table_name, alias, sql_alias, columns) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(table_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(sql_alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passArrayJsValueToWasm0(columns, wasm.__wbindgen_export);
        const len3 = WASM_VECTOR_LEN;
        const ret = wasm.availabletableforfilterjs_new(ptr0, len0, ptr1, len1, alias, ptr2, len2, ptr3, len3);
        return AvailableTableForFilterJS.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    get sqlAlias() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.availabletableforfilterjs_sqlAlias(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get tableId() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.availabletableforfilterjs_tableId(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get tableName() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.availabletableforfilterjs_tableName(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) AvailableTableForFilterJS.prototype[Symbol.dispose] = AvailableTableForFilterJS.prototype.free;

/**
 * JS-facing lineage info for a bucket-imported table. Provider / format
 * are passed as the wire-shape strings (`"gcs"`, `"csv"` / `"tsv"` /
 * `"parquet"`) so the React side can reuse the existing
 * `BucketProviderKind` / `BucketFormat` typings from `savedConnectionsApi`
 * / `bucketApi` without re-binding the Rust enums through wasm.
 */
export class BucketSourceInfoJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BucketSourceInfoJS.prototype);
        obj.__wbg_ptr = ptr;
        BucketSourceInfoJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BucketSourceInfoJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bucketsourceinfojs_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get bucket() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_bucket(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get format() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_format(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get object_path() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_object_path(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get provider() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_provider(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get saved_connection_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_saved_connection_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} arg0
     */
    set bucket(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_bucket(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set format(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_format(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set object_path(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_object_path(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set provider(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_provider(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set saved_connection_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_saved_connection_id(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) BucketSourceInfoJS.prototype[Symbol.dispose] = BucketSourceInfoJS.prototype.free;

/**
 * An arbitrary position in global canvas coordinates
 */
export class CanvasLocation {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CanvasLocationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_canvaslocation_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get x() {
        const ret = wasm.__wbg_get_canvaslocation_x(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get y() {
        const ret = wasm.__wbg_get_canvaslocation_y(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set x(arg0) {
        wasm.__wbg_set_canvaslocation_x(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set y(arg0) {
        wasm.__wbg_set_canvaslocation_y(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) CanvasLocation.prototype[Symbol.dispose] = CanvasLocation.prototype.free;

/**
 * How A and B rows match, labelled `A → B` (`OneToMany` = each A
 * matches many B).
 * @enum {0 | 1 | 2 | 3}
 */
export const Cardinality = Object.freeze({
    OneToOne: 0, "0": "OneToOne",
    OneToMany: 1, "1": "OneToMany",
    ManyToOne: 2, "2": "ManyToOne",
    ManyToMany: 3, "3": "ManyToMany",
});

/**
 * Classifies whether a cast from one `PhysicalKind` to another is meaningful
 * to offer in the UI, and whether it can silently null rows under
 * `CastMode::BestEffort`.
 *
 * Used by `PhysicalKind::cast_compatibility` to drive both the server-side
 * guard in `cast_column_op` and the client-side filter in the column cast
 * menu.
 * @enum {0 | 1 | 2}
 */
export const CastCompatibility = Object.freeze({
    /**
     * Cast always succeeds on well-formed input (e.g. `Int32 → Int64`).
     */
    Safe: 0, "0": "Safe",
    /**
     * Cast may null rows (BestEffort) or fail the whole action (Strict)
     * depending on actual data — e.g. `String → Int32` or numeric narrowing.
     */
    Lossy: 1, "1": "Lossy",
    /**
     * Cast is hidden in the UI and rejected server-side. Used for
     * semantically meaningless conversions (Bool↔Timestamp) or casts that
     * should only happen via a String intermediate.
     */
    Disallowed: 2, "2": "Disallowed",
});

/**
 * @enum {0 | 1}
 */
export const CastMode = Object.freeze({
    BestEffort: 0, "0": "BestEffort",
    Strict: 1, "1": "Strict",
});

export class Checkpoint {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Checkpoint.prototype);
        obj.__wbg_ptr = ptr;
        CheckpointFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CheckpointFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_checkpoint_free(ptr, 0);
    }
    /**
     * @returns {string[]}
     */
    aliases_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_aliases_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {bigint}
     */
    created_at_number() {
        const ret = wasm.checkpoint_created_at_number(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    created_by_email() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_created_by_email(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {any} value
     * @returns {Checkpoint}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Checkpoint.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @returns {string}
     */
    id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    table_version_number() {
        const ret = wasm.checkpoint_table_version_number(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.checkpoint_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) Checkpoint.prototype[Symbol.dispose] = Checkpoint.prototype.free;

/**
 * Clear a table's released version, reverting serving consumers to the
 * live latest version.
 */
export class ClearTableReleaseRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ClearTableReleaseRequest.prototype);
        obj.__wbg_ptr = ptr;
        ClearTableReleaseRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ClearTableReleaseRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cleartablereleaserequest_free(ptr, 0);
    }
    /**
     * @param {string} table_id
     * @returns {ClearTableReleaseRequest}
     */
    static new_js(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.cleartablereleaserequest_new_js(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ClearTableReleaseRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.cleartablereleaserequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) ClearTableReleaseRequest.prototype[Symbol.dispose] = ClearTableReleaseRequest.prototype.free;

export class ClientApp {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ClientApp.prototype);
        obj.__wbg_ptr = ptr;
        ClientAppFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ClientAppFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_clientapp_free(ptr, 0);
    }
    /**
     * A JSON string, not a `JsValue`: `serde_wasm_bindgen` emits a JS `Map`, on which
     * `result.postgres` is silently `undefined`.
     * @returns {string}
     */
    active_import_connection_ids() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_active_import_connection_ids(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Create the table's one Attachment column (or answer the existing one);
     * returns its id.
     * @param {string} table_id
     * @returns {string}
     */
    add_attachment_column(table_id) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_add_attachment_column(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Add a category to a categorical column.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} label
     * @param {string | null} [color]
     */
    add_category(table_id, column_id, label, color) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(label, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(color) ? 0 : passStringToWasm0(color, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len3 = WASM_VECTOR_LEN;
            wasm.clientapp_add_category(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} view_id
     * @param {string} column_id
     * @param {boolean} left
     */
    add_column_beside(view_id, column_id, left) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_add_column_beside(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, left);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {AlignOption} align
     */
    align_view_items(align) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_align_view_items(retptr, this.__wbg_ptr, align);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `false` means every animation (cursors, viewport follow) settled; the rAF loop may stop.
     * @param {number} timestamp
     * @returns {boolean}
     */
    animate(timestamp) {
        const ret = wasm.clientapp_animate(this.__wbg_ptr, timestamp);
        return ret !== 0;
    }
    /**
     * Confirm in the `showTypeChangeConfirm` dialog. Its Cancel calls
     * `keep_column_types`; × and Escape call nothing.
     * @param {string} view_id
     */
    apply_staged_commit(view_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_apply_staged_commit(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    arrange_view_items() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_arrange_view_items(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    attach_canvases() {
        wasm.clientapp_attach_canvases(this.__wbg_ptr);
    }
    /**
     * @param {string} item_id
     * @returns {boolean}
     */
    can_edit_item_name(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_can_edit_item_name(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * Whether a search can be opened on this column — an unmapped view and a
     * searchable column kind. Gates the affordance in React.
     * @param {string} view_id
     * @param {string} column_id
     * @returns {boolean}
     */
    can_search_column(view_id, column_id) {
        const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_can_search_column(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    can_zoom_in() {
        const ret = wasm.clientapp_can_zoom_in(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    can_zoom_out() {
        const ret = wasm.clientapp_can_zoom_out(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Discards the table's open manual commit — the ✕ ornament's path.
     * @param {string} table_id
     */
    cancel_commit(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_cancel_commit(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `[x, y]` in canvas coordinates, for callers that remember a spot across an async gap: a
     * screen point converted later drifts with every pan and zoom.
     * @param {number} offset_x
     * @param {number} offset_y
     * @returns {Float64Array}
     */
    canvas_point_at(offset_x, offset_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_canvas_point_at(retptr, this.__wbg_ptr, offset_x, offset_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayF64FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 8, 8);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {string} column_id
     * @returns {string | undefined}
     */
    cell_full_display_value(view_id, row_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_cell_full_display_value(retptr, this.__wbg_ptr, ptr0, len0, row_id, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v3;
            if (r0 !== 0) {
                v3 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Type-check a formula against `table_id`'s live schema (per keystroke).
     * Returns `{ result_type?: string, error?: string }`.
     * @param {string} table_id
     * @param {string} ast_json
     * @returns {any}
     */
    check_formula(table_id, ast_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(ast_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_check_formula(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    clear_column_reorder_hint() {
        wasm.clientapp_clear_column_reorder_hint(this.__wbg_ptr);
    }
    /**
     * Discard the whole investigation.
     */
    clear_row_graph() {
        wasm.clientapp_clear_row_graph(this.__wbg_ptr);
    }
    clear_staged_edits() {
        wasm.clientapp_clear_staged_edits(this.__wbg_ptr);
    }
    /**
     * Closes the input, KEEPING the term (Escape). The magnifier stays hot.
     * @param {string} view_id
     */
    close_column_search(view_id) {
        const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_close_column_search(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Drop the wizard state. Idempotent.
     */
    close_reference_matching_wizard() {
        wasm.clientapp_close_reference_matching_wizard(this.__wbg_ptr);
    }
    /**
     * @param {string} item_id
     */
    collapse_item(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_collapse_item(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Only `has_description` rides the column-list payload, so the overlay pulls the text here
     * for the one column it shows.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {string | undefined}
     */
    column_description(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_column_description(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v3;
            if (r0 !== 0) {
                v3 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Only the named columns of a table, in the order asked: a JS array like `table_columns`.
     * @param {string} table_id
     * @param {string[]} column_ids
     * @returns {any}
     */
    column_models(table_id, column_ids) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(column_ids, wasm.__wbindgen_export);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_column_models(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
     * Tab / Shift+Tab: with no adjacent column the value still commits and the overlay closes.
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {string} value
     * @param {boolean} forward
     */
    commit_cell_and_advance(column_id, view_id, row_id, value, forward) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_commit_cell_and_advance(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, ptr2, len2, forward);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Schema-derived health for a cached link. Returns `null` when the
     * link id is unknown; otherwise a `LinkHealthJS` tagged union.
     * @param {string} link_id
     * @returns {any}
     */
    compute_link_health(link_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(link_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_compute_link_health(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The computed columns a delete of `column_id` cascades to, transitively.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {string[]}
     */
    computed_dependents_of(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_computed_dependents_of(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The stored formula of a live computed column as `FormulaAstDto` JSON,
     * for re-opening the editor. `None` if not a live computed column.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {string | undefined}
     */
    computed_formula_of(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_computed_formula_of(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            let v3;
            if (r0 !== 0) {
                v3 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    confirm_waiting_action() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_confirm_waiting_action(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Returns the number of diff views that depend on this checkpoint.
     * Used by React to show a cascade warning before checkpoint deletion.
     * @param {string} table_id
     * @param {string} checkpoint_id
     * @returns {number}
     */
    count_dependent_diff_views(table_id, checkpoint_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_count_dependent_diff_views(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    current_memory() {
        const ret = wasm.clientapp_current_memory(this.__wbg_ptr);
        return takeObject(ret);
    }
    discard_waiting_action() {
        wasm.clientapp_discard_waiting_action(this.__wbg_ptr);
    }
    /**
     * Dismiss the read-only formula peek (Escape / click-outside from React).
     */
    dismiss_formula_peek() {
        wasm.clientapp_dismiss_formula_peek(this.__wbg_ptr);
    }
    /**
     * Debug-only: switch the canvas to the force-directed graph view of the
     * current model. Call from the browser console: `clientApp.enable_graph_debug()`.
     */
    enable_graph_debug() {
        wasm.clientapp_enable_graph_debug(this.__wbg_ptr);
    }
    /**
     * SWR refresh of the link cache for `table_id`. No-op if still
     * fresh; otherwise dispatches a background fetch.
     * @param {string} table_id
     */
    ensure_links_fresh(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_ensure_links_fresh(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} item_id
     * @param {string} initial
     */
    enter_item_name_staged_edit(item_id, initial) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(initial, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_enter_item_name_staged_edit(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Show the row-level graph: seeds from the current row selection, adds to a
     * running investigation, or re-opens it when nothing is selected.
     */
    enter_row_graph() {
        wasm.clientapp_enter_row_graph(this.__wbg_ptr);
    }
    exit_row_graph() {
        wasm.clientapp_exit_row_graph(this.__wbg_ptr);
    }
    /**
     * @param {string} item_id
     */
    expand_item(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_expand_item(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} request_id
     */
    fail_data_request(request_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(request_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_fail_data_request(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Fetches model permissions — triggers a WS request on cache miss.
     * Call from `useEffect` (side effects OK). Do NOT call from `useMemo`.
     */
    fetch_model_permissions() {
        wasm.clientapp_fetch_model_permissions(this.__wbg_ptr);
    }
    /**
     * Fetches table permissions — triggers a WS request on cache miss.
     * Call from `useEffect` (side effects OK). Do NOT call from `useMemo`.
     * @param {string} table_id
     */
    fetch_table_permissions(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_fetch_table_permissions(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} request_id
     */
    finalize_data_request_stream(request_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(request_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_finalize_data_request_stream(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} column_id
     */
    finish_column_reorder(column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_finish_column_reorder(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    flush_actions() {
        wasm.clientapp_flush_actions(this.__wbg_ptr);
    }
    /**
     * The editor's autocomplete + function-reference source: named functions
     * with a rendered signature + doc. Returns `[{ name, signature, doc }]`.
     * @returns {any}
     */
    formula_catalogue() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_formula_catalogue(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Minted client-side for instant UX: cross-client clock skew costs only ordering, which a
     * UUID PK doesn't promise, and index locality survives it.
     * @returns {string}
     */
    generate_uuid_v7() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_generate_uuid_v7(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {TableLinksGroupedJS[]}
     */
    get_all_table_links_grouped() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_all_table_links_grouped(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Bucket imports have no server-side metadata blob, so the lineage panel reads model state
     * here instead of `/api/tables/{id}/source`.
     * @param {string} table_id
     * @returns {BucketSourceInfoJS | undefined}
     */
    get_bucket_source_info(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_bucket_source_info(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : BucketSourceInfoJS.__wrap(ret);
    }
    /**
     * @param {string} item_id
     * @param {ModelItemInstanceJS} instance
     * @returns {DElement[]}
     */
    get_children(item_id, instance) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_children(retptr, this.__wbg_ptr, ptr0, len0, instance);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    get_client_id() {
        const ret = wasm.clientapp_get_client_id(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Get category definitions for a categorical column. Returns JSON array.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {any}
     */
    get_column_categories(table_id, column_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_column_categories(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
     * @param {string} table_id
     * @returns {string[]}
     */
    get_columns_used_in_filters(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_columns_used_in_filters(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} view_id
     * @returns {string[]}
     */
    get_columns_used_in_view_filter(view_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_columns_used_in_view_filter(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {TableDetails[]}
     */
    get_deleted_tables() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_deleted_tables(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    get_keyboard_shortcut_groups() {
        const ret = wasm.clientapp_get_keyboard_shortcut_groups(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {string} table_id
     * @returns {TableLinkJS[]}
     */
    get_links_for_table(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_links_for_table(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Every link is oriented so `first_table_id == table_id` and grouped by the OTHER table;
     * self-links form one group keyed on `table_id`, which React labels "(this table)".
     * @param {string} table_id
     * @returns {TableLinksGroupedJS[]}
     */
    get_links_for_table_grouped(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_links_for_table_grouped(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Deduplicated, so the freshness store fires one hash check per source file on model open.
     * @returns {string[]}
     */
    get_local_sqlite_saved_connection_ids() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_local_sqlite_saved_connection_ids(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Lineage comes from model state alone; the freshness check uses `saved_connection_id` to
     * find the device-local FSA handle in IDB.
     * @param {string} table_id
     * @returns {LocalSqliteSourceInfoJS | undefined}
     */
    get_local_sqlite_source_info(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_local_sqlite_source_info(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : LocalSqliteSourceInfoJS.__wrap(ret);
    }
    /**
     * @returns {ModelDetails | undefined}
     */
    get_model_details() {
        const ret = wasm.clientapp_get_model_details(this.__wbg_ptr);
        return ret === 0 ? undefined : ModelDetails.__wrap(ret);
    }
    /**
     * @returns {string[]}
     */
    get_model_table_ids() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_model_table_ids(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `null` means a WS request was sent; its response triggers `onParentModelUpdate` on the
     * JS side.
     * @param {string} table_id
     * @returns {any}
     */
    get_parent_model(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_parent_model(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * @returns {string}
     */
    get_root_id() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_root_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get_selected_n_views() {
        const ret = wasm.clientapp_get_selected_n_views(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string[]}
     */
    get_selected_table_ids() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_get_selected_table_ids(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    get_session_id() {
        const ret = wasm.clientapp_get_session_id(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * The columns of the table whose own item is `item_id`; its details carry only their count.
     * @param {string} item_id
     * @returns {TableColumns}
     */
    get_table_columns(item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_table_columns(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableColumns.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} item_id
     * @returns {TableDetails}
     */
    get_table_details(item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_table_details(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} item_id
     * @returns {TableDiffViewDetails | undefined}
     */
    get_table_diff_view_details(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_table_diff_view_details(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : TableDiffViewDetails.__wrap(ret);
    }
    /**
     * @param {string} table_link_id
     * @returns {TableLink}
     */
    get_table_link(table_link_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_link_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_table_link(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableLink.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string[]} table_ids
     * @returns {TableMetadataJS[]}
     */
    get_table_metadata(table_ids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(table_ids, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_table_metadata(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The view's columns in its order, and the ones it hides; `None` when `item_id` is no view.
     * @param {string} item_id
     * @returns {TableViewColumns | undefined}
     */
    get_table_view_columns(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_table_view_columns(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : TableViewColumns.__wrap(ret);
    }
    /**
     * @param {string} item_id
     * @returns {TableViewDetails | undefined}
     */
    get_table_view_details(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_get_table_view_details(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : TableViewDetails.__wrap(ret);
    }
    /**
     * @param {string} item_id
     * @returns {string | undefined}
     */
    get_table_view_serialized(item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_get_table_view_serialized(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v2;
            if (r0 !== 0) {
                v2 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Gather the selected node's exclusive leaves back around it (the `R`
     * keybind), then let the layout separate them.
     */
    graph_refocus_leaves() {
        wasm.clientapp_graph_refocus_leaves(this.__wbg_ptr);
    }
    graph_reset() {
        wasm.clientapp_graph_reset(this.__wbg_ptr);
    }
    /**
     * Expand or collapse the selected table (the `Enter` keybind).
     */
    graph_toggle_selected() {
        wasm.clientapp_graph_toggle_selected(this.__wbg_ptr);
    }
    /**
     * @param {string[]} column_ids
     * @param {string} item_id
     */
    handle_add_columns_to_table_view(column_ids, item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(column_ids, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_add_columns_to_table_view(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `source_json` is the import response's `BucketObject` as JSON, sparing a 7-field
     * wasm_bindgen constructor. `at_x`/`at_y`: see [`Self::handle_gsheets_load`].
     * @param {string} table_id
     * @param {string} source_json
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_bucket_load(table_id, source_json, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(source_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_bucket_load(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `source_json` is the sync response's refreshed `BucketObject`, as JSON for the same reason
     * as `handle_bucket_load`.
     * @param {string} table_snapshot
     * @param {string} source_json
     * @param {boolean} schema_update
     * @param {boolean} meta_update
     * @param {bigint | null} [data_version]
     */
    handle_bucket_sync(table_snapshot, source_json, schema_update, meta_update, data_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_snapshot, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(source_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_bucket_sync(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, schema_update, meta_update, !isLikeNone(data_version), isLikeNone(data_version) ? BigInt(0) : data_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {PhysicalKind} target_data_type
     * @param {CastMode} mode
     * @param {string | null} [new_name]
     */
    handle_cast_table_column(table_id, column_id, target_data_type, mode, new_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(new_name) ? 0 : passStringToWasm0(new_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len2 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_cast_table_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, target_data_type, mode, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} first_table_id
     * @param {string} second_table_id
     * @param {string[]} first_column_ids
     * @param {string[]} second_column_ids
     */
    handle_create_table_link(first_table_id, second_table_id, first_column_ids, second_column_ids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(first_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(second_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passArrayJsValueToWasm0(first_column_ids, wasm.__wbindgen_export);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passArrayJsValueToWasm0(second_column_ids, wasm.__wbindgen_export);
            const len3 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_create_table_link(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Dispatches only when no link with these endpoints exists (the FK resolvers re-run on every
     * sync) and editing isn't restricted; returns whether it did.
     * @param {string} first_table_id
     * @param {string} second_table_id
     * @param {string[]} first_column_ids
     * @param {string[]} second_column_ids
     * @returns {boolean}
     */
    handle_create_table_link_if_absent(first_table_id, second_table_id, first_column_ids, second_column_ids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(first_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(second_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passArrayJsValueToWasm0(first_column_ids, wasm.__wbindgen_export);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passArrayJsValueToWasm0(second_column_ids, wasm.__wbindgen_export);
            const len3 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_create_table_link_if_absent(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_link_id
     */
    handle_delete_table_link(table_link_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_link_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_delete_table_link(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {boolean} hard_delete
     */
    handle_delete_table_ui(table_id, hard_delete) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_delete_table_ui(retptr, this.__wbg_ptr, ptr0, len0, hard_delete);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} item_id
     */
    handle_delete_table_view_ui(item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_delete_table_view_ui(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The actor runs the copy atomically: a Succeeded ACK means every server-side step committed,
     * and a failure rolls back, so callers never handle partial state.
     * @param {string} source_table_id
     * @param {string} target_model_id
     * @param {bigint | null} [source_version]
     */
    handle_detach_table_ui(source_table_id, target_model_id, source_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(source_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(target_model_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_detach_table_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, !isLikeNone(source_version), isLikeNone(source_version) ? BigInt(0) : source_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {any} column_ids
     */
    handle_extract_unique_values(table_id, column_ids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_extract_unique_values(retptr, this.__wbg_ptr, ptr0, len0, addHeapObject(column_ids));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Without a point the table lands like a sync arrival.
     * @param {string} table_id
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_file_load(table_id, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_file_load(retptr, this.__wbg_ptr, ptr0, len0, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_snapshot
     * @param {GoogleSheet} gsheets_config
     * @param {boolean} schema_update
     * @param {boolean} meta_update
     * @param {bigint | null} [data_version]
     */
    handle_gsheet_sync(table_snapshot, gsheets_config, schema_update, meta_update, data_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_snapshot, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(gsheets_config, GoogleSheet);
            var ptr1 = gsheets_config.__destroy_into_raw();
            wasm.clientapp_handle_gsheet_sync(retptr, this.__wbg_ptr, ptr0, len0, ptr1, schema_update, meta_update, !isLikeNone(data_version), isLikeNone(data_version) ? BigInt(0) : data_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `at_x`/`at_y`: canvas-space drop point, taken at drop time ([`Self::canvas_point_at`]);
     * absent for button imports, which join the existing content like a sync arrival.
     * @param {string} table_id
     * @param {GoogleSheet} gsheets_config
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_gsheets_load(table_id, gsheets_config, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(gsheets_config, GoogleSheet);
            var ptr1 = gsheets_config.__destroy_into_raw();
            wasm.clientapp_handle_gsheets_load(retptr, this.__wbg_ptr, ptr0, len0, ptr1, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     */
    handle_hard_delete_column(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_hard_delete_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {ImportedTable} import_config
     * @param {boolean} conditional_import
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_import_table(table_id, import_config, conditional_import, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(import_config, ImportedTable);
            var ptr1 = import_config.__destroy_into_raw();
            wasm.clientapp_handle_import_table(retptr, this.__wbg_ptr, ptr0, len0, ptr1, conditional_import, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {KeyboardEvent} event
     * @param {boolean} keydown
     */
    handle_keyboard_event(event, keydown) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_handle_keyboard_event(retptr, this.__wbg_ptr, addHeapObject(event), keydown);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `at_x`/`at_y`: see [`Self::handle_gsheets_load`].
     * @param {string} table_id
     * @param {LocalSqliteDatabase} sqlite_config
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_local_sqlite_load(table_id, sqlite_config, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(sqlite_config, LocalSqliteDatabase);
            var ptr1 = sqlite_config.__destroy_into_raw();
            wasm.clientapp_handle_local_sqlite_load(retptr, this.__wbg_ptr, ptr0, len0, ptr1, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_snapshot
     * @param {LocalSqliteDatabase} sqlite_config
     * @param {boolean} schema_update
     * @param {boolean} meta_update
     * @param {bigint | null} [data_version]
     */
    handle_local_sqlite_sync(table_snapshot, sqlite_config, schema_update, meta_update, data_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_snapshot, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(sqlite_config, LocalSqliteDatabase);
            var ptr1 = sqlite_config.__destroy_into_raw();
            wasm.clientapp_handle_local_sqlite_sync(retptr, this.__wbg_ptr, ptr0, len0, ptr1, schema_update, meta_update, !isLikeNone(data_version), isLikeNone(data_version) ? BigInt(0) : data_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {MouseEvent} event
     */
    handle_mouse_down(event) {
        wasm.clientapp_handle_mouse_down(this.__wbg_ptr, addHeapObject(event));
    }
    /**
     * @param {MouseEvent} event
     */
    handle_mouse_move(event) {
        wasm.clientapp_handle_mouse_move(this.__wbg_ptr, addHeapObject(event));
    }
    /**
     * @param {MouseEvent} event
     */
    handle_mouse_out(event) {
        wasm.clientapp_handle_mouse_out(this.__wbg_ptr, addHeapObject(event));
    }
    /**
     * @param {MouseEvent} event
     */
    handle_mouse_up(event) {
        wasm.clientapp_handle_mouse_up(this.__wbg_ptr, addHeapObject(event));
    }
    /**
     * Write one cell by row id — the row inspector's door.
     * @param {string} table_id
     * @param {string} column_id
     * @param {bigint} row_id
     * @param {string} value
     */
    handle_new_cell_value_by_row(table_id, column_id, row_id, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_cell_value_by_row(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {string} value
     */
    handle_new_cell_value_ui(column_id, view_id, row_id, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_cell_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} name
     * @param {string} item_id
     * @returns {boolean}
     */
    handle_new_column_name_ui_by_view(table_id, column_id, name, item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_column_name_ui_by_view(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Days since the UNIX epoch, matching Date32's unit so `parse_to_target` won't reinterpret it.
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {number} days
     */
    handle_new_date_value_ui(column_id, view_id, row_id, days) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_date_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, days);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} model_item_id
     * @param {string} name
     */
    handle_new_item_name_ui(model_item_id, name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(model_item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_item_name_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The new view's id, so the UI can glide onto it (placement may tuck it outside the
     * viewport); `None` when nothing was created (editing restricted).
     * @returns {string | undefined}
     */
    handle_new_table_ui() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_handle_new_table_ui(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The new view's id, so the UI can glide onto it; `None` when nothing was created (editing
     * restricted, terminal imported table).
     * @param {string} table_id
     * @returns {string | undefined}
     */
    handle_new_table_view_ui(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_table_view_ui(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            let v2;
            if (r0 !== 0) {
                v2 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Takes µs, not seconds: `parse_to_target` reads the integer in the column's unit, so a
     * seconds value would land in ~1970.
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {bigint} utc_micros
     */
    handle_new_timestamp_micros_value_ui(column_id, view_id, row_id, utc_micros) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_timestamp_micros_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, utc_micros);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * i64 nanos cap the instant at ~1677-09-21..2262-04-11: React catches the overflow before
     * building the BigInt, and wasm-bindgen rejects an out-of-i64 one at the boundary.
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {bigint} utc_nanos
     */
    handle_new_timestamp_nanos_value_ui(column_id, view_id, row_id, utc_nanos) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_timestamp_nanos_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, utc_nanos);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Type-safe timestamp cell commit. JS sends UTC seconds as i64 instead of a string.
     * Validates the timestamp is in a reasonable range (year ~1000–9999).
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {bigint} utc_seconds
     */
    handle_new_timestamp_value_ui(column_id, view_id, row_id, utc_seconds) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_timestamp_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, utc_seconds);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The value is parsed AS `staged_type`, so an untyped (ND) column self-types to it in the same
     * action — the non-eager counterpart to `handle_set_empty_column_data_type`.
     * @param {string} column_id
     * @param {string} view_id
     * @param {bigint} row_id
     * @param {string} value
     * @param {PhysicalKind} staged_type
     */
    handle_new_typed_cell_value_ui(column_id, view_id, row_id, value, staged_type) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_new_typed_cell_value_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, ptr2, len2, staged_type);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} input
     * @param {string | null} [mycorr_meta]
     */
    handle_paste(input, mycorr_meta) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(mycorr_meta) ? 0 : passStringToWasm0(mycorr_meta, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_paste(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `kind` follows the saved connection's `connection_type`. `at_x`/`at_y`: see
     * [`Self::handle_gsheets_load`].
     * @param {string} table_id
     * @param {PostgresDatabase} postgres_config
     * @param {PostgresKindJS} kind
     * @param {number | null} [at_x]
     * @param {number | null} [at_y]
     */
    handle_postgres_load(table_id, postgres_config, kind, at_x, at_y) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(postgres_config, PostgresDatabase);
            var ptr1 = postgres_config.__destroy_into_raw();
            wasm.clientapp_handle_postgres_load(retptr, this.__wbg_ptr, ptr0, len0, ptr1, kind, !isLikeNone(at_x), isLikeNone(at_x) ? 0 : at_x, !isLikeNone(at_y), isLikeNone(at_y) ? 0 : at_y);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_snapshot
     * @param {PostgresDatabase} postgres_config
     * @param {boolean} schema_update
     * @param {boolean} meta_update
     * @param {bigint | null | undefined} data_version
     * @param {PostgresKindJS} kind
     */
    handle_postgres_sync(table_snapshot, postgres_config, schema_update, meta_update, data_version, kind) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_snapshot, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(postgres_config, PostgresDatabase);
            var ptr1 = postgres_config.__destroy_into_raw();
            wasm.clientapp_handle_postgres_sync(retptr, this.__wbg_ptr, ptr0, len0, ptr1, schema_update, meta_update, !isLikeNone(data_version), isLikeNone(data_version) ? BigInt(0) : data_version, kind);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string[]} column_ids
     * @param {string} item_id
     */
    handle_remove_columns_from_table_view(column_ids, item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(column_ids, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_remove_columns_from_table_view(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     */
    handle_restore_column(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_restore_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     */
    handle_restore_table_ui(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_restore_table_ui(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `row_identity_json` is the restore prompt's answer for a connector table
     * (`{"kind": ...}`); empty keeps the key that version had.
     * @param {string} table_id
     * @param {bigint} version
     * @param {string} row_identity_json
     */
    handle_restore_table_version(table_id, version, row_identity_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(row_identity_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_restore_table_version(retptr, this.__wbg_ptr, ptr0, len0, version, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {PhysicalKind} data_type
     * @param {boolean} lock
     */
    handle_set_empty_column_data_type(table_id, column_id, data_type, lock) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_set_empty_column_data_type(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, data_type, lock);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     */
    handle_soft_delete_table_column(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_soft_delete_table_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} model_item_id
     * @param {string} name
     * @param {boolean} trigger_details_update
     */
    handle_staged_item_name_update_ui(model_item_id, name, trigger_details_update) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(model_item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_staged_item_name_update_ui(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, trigger_details_update);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} request_id
     * @param {StreamedDataResponseHeader} header
     * @param {Uint8Array} data
     */
    handle_streamed_data_response(request_id, header, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(request_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(header, StreamedDataResponseHeader);
            var ptr1 = header.__destroy_into_raw();
            wasm.clientapp_handle_streamed_data_response(retptr, this.__wbg_ptr, ptr0, len0, ptr1, addHeapObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {DElement} element
     * @param {boolean} shift
     * @param {boolean} meta
     */
    handle_ui_directory_select(element, shift, meta) {
        _assertClass(element, DElement);
        wasm.clientapp_handle_ui_directory_select(this.__wbg_ptr, element.__wbg_ptr, shift, meta);
    }
    /**
     * @param {DElement} element
     */
    handle_ui_single_select(element) {
        _assertClass(element, DElement);
        wasm.clientapp_handle_ui_single_select(this.__wbg_ptr, element.__wbg_ptr);
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {bigint} row_id
     * @param {string} value
     */
    handle_ui_staged_cell_value_update(table_id, column_id, row_id, value) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        wasm.clientapp_handle_ui_staged_cell_value_update(this.__wbg_ptr, ptr0, len0, ptr1, len1, row_id, ptr2, len2);
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} name
     */
    handle_ui_staged_column_name_update(table_id, column_id, name) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        wasm.clientapp_handle_ui_staged_column_name_update(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
    }
    /**
     * @param {string} table_id
     */
    handle_update_table_to_latest(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_handle_update_table_to_latest(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `delta_x`/`delta_y` are summed since the last dispatch: React coalesces wheel events to one
     * call per rAF (each can re-render every visible cell), passing the LAST event.
     * @param {WheelEvent} event
     * @param {number} delta_x
     * @param {number} delta_y
     */
    handle_wheel(event, delta_x, delta_y) {
        wasm.clientapp_handle_wheel(this.__wbg_ptr, addHeapObject(event), delta_x, delta_y);
    }
    /**
     * Handles an incoming WebSocket message from the browser
     * @param {MessageEvent} e
     * @returns {Promise<void>}
     */
    handle_ws_message(e) {
        const ret = wasm.clientapp_handle_ws_message(this.__wbg_ptr, addHeapObject(e));
        return takeObject(ret);
    }
    /**
     * @returns {boolean}
     */
    has_staged_edit() {
        const ret = wasm.clientapp_has_staged_edit(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * True when there are applied-but-not-yet-saved edits (in-flight actions or
     * the applied version is ahead of the server's durable watermark).
     * @returns {boolean}
     */
    has_unsaved_changes() {
        const ret = wasm.clientapp_has_unsaved_changes(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} item_id
     * @param {string | null} [after_column_id]
     */
    hint_column_reorder_target(item_id, after_column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(after_column_id) ? 0 : passStringToWasm0(after_column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            wasm.clientapp_hint_column_reorder_target(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * JSON for the same `Map`-vs-object reason as `active_import_connection_ids`.
     * @returns {string}
     */
    imported_sources() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_imported_sources(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Promise<void>}
     */
    initialize_state() {
        const ret = wasm.clientapp_initialize_state(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Whether `column_id` is a live computed (formula) column — gates the
     * "Edit formula" affordance and the `ƒ` header badge.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {boolean}
     */
    is_computed_column(table_id, column_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_is_computed_column(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_editing_restricted() {
        const ret = wasm.clientapp_is_editing_restricted(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Either graph mode — lets the React keyboard handler gate graph-only keys.
     * @returns {boolean}
     */
    is_graph_like() {
        const ret = wasm.clientapp_is_graph_like(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_graph_view() {
        const ret = wasm.clientapp_is_graph_view(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Returns true when model snapshot + permissions are loaded.
     * Safe to call from React render (immutable, no side effects).
     * @returns {boolean}
     */
    is_model_ready() {
        const ret = wasm.clientapp_is_model_ready(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * True when a new WASM version is available but the reload is being held
     * because local edits aren't saved yet.
     * @returns {boolean}
     */
    is_new_version_pending() {
        const ret = wasm.clientapp_is_new_version_pending(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_row_graph_view() {
        const ret = wasm.clientapp_is_row_graph_view(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * "Keep as <type>": the type-change dialog's other answer.
     * @param {string} view_id
     */
    keep_column_types(view_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_keep_column_types(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Local cache only: the caller triggers a TTL refresh first if freshness matters.
     * @param {string} table_id
     * @param {string} column_id
     * @returns {TableLinkJS[]}
     */
    links_for_column(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_links_for_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `true` once the link list has loaded at least once this session.
     * @param {string} table_id
     * @returns {boolean}
     */
    links_loaded_for_table(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_links_loaded_for_table(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `[{table_id, table_name, table_version, column_id, column_name}]` for every `String` column
     * outside `except_table_id`.
     * @param {string} except_table_id
     * @returns {any}
     */
    list_string_columns_for_mapping(except_table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(except_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_list_string_columns_for_mapping(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * The data door answered `values_not_readable` (D37) — blank the table
     * and stop re-requesting its chunks.
     * @param {string} table_id
     */
    mark_table_values_blanked(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_mark_table_values_blanked(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    model_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_model_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    model_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_model_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {bigint}
     */
    model_state_version() {
        const ret = wasm.clientapp_model_state_version(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @param {string} client_id
     * @param {string} model_id
     * @returns {ClientApp}
     */
    static new(client_id, model_id) {
        const ptr0 = passStringToWasm0(client_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(model_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_new(ptr0, len0, ptr1, len1);
        return ClientApp.__wrap(ret);
    }
    /**
     * Generate the next default table name ("Table N+1") for pasted data.
     * @returns {string}
     */
    next_default_table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_next_default_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * JS callback after `POST /server/action/links` returns 200; converting the `LinkDto` mints
     * fresh `JoinPartID`s, which are runtime-only and meaningless on the wire.
     * @param {string} link_json
     */
    on_link_created(link_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(link_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_on_link_created(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * JS callback after `DELETE /server/action/links/{id}` returns 204.
     * @param {string} link_id
     */
    on_link_deleted(link_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(link_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_on_link_deleted(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * JS callback when a link fetch for `table_ids_csv` failed or was refused,
     * so the tables stop counting as in flight.
     * @param {string} table_ids_csv
     */
    on_link_fetch_failed(table_ids_csv) {
        const ptr0 = passStringToWasm0(table_ids_csv, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_on_link_fetch_failed(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * JS callback after `GET /server/action/links?for_table=…` returns 200: evicts the table's
     * cached links missing from the response, then merges the rest.
     * @param {string} table_id
     * @param {string} links_json
     */
    on_link_list_received_for_table(table_id, links_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(links_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_on_link_list_received_for_table(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `response_json` is `{tables, links}`; `tables` echoes the ids the server actually answered
     * for, which is what marks each one cached.
     * @param {string} response_json
     */
    on_link_list_received_for_tables(response_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(response_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_on_link_list_received_for_tables(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Stored node-label defaults, fetched by React. `entries_json` is
     * `[{table_id, label?, sublabel?}]`.
     * @param {string} entries_json
     */
    on_node_labels_received(entries_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(entries_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_on_node_labels_received(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Merge a closure response into the row-graph (edges only, idempotent).
     * @param {string} response
     */
    on_row_graph_close_received(response) {
        const ptr0 = passStringToWasm0(response, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_on_row_graph_close_received(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Merge an expansion response (from the data-service) into the row-graph.
     * @param {string} source_node
     * @param {string} target_table_id
     * @param {string} response_json
     */
    on_row_graph_expansion_received(source_node, target_table_id, response_json) {
        const ptr0 = passStringToWasm0(source_node, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(target_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(response_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        wasm.clientapp_on_row_graph_expansion_received(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
    }
    /**
     * Opens the input over a column — the magnifier click path, also callable from
     * React so a hot magnifier can be reopened.
     * @param {string} view_id
     * @param {string} column_id
     */
    open_column_search(view_id, column_id) {
        const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.clientapp_open_column_search(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * Open the formula magic bar for a computed column from the header peek's
     * Edit button (rowless — no cell context).
     * @param {string} table_id
     * @param {string} view_id
     * @param {string} column_id
     */
    open_formula_editor(table_id, view_id, column_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        wasm.clientapp_open_formula_editor(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
    }
    /**
     * @param {string[]} item_ids
     */
    open_only_tables(item_ids) {
        const ptr0 = passArrayJsValueToWasm0(item_ids, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_open_only_tables(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Open the wizard. Returns the first `request_id` to use for the
     * initial discover-mapping POST.
     * @param {string} source_table_id
     * @param {string} source_column_id
     * @param {bigint} source_version
     * @param {string} reference_table_id
     * @param {string} reference_column_id
     * @param {bigint} reference_version
     * @param {number} score_cutoff
     * @param {boolean} normalize
     * @returns {bigint}
     */
    open_reference_matching_wizard(source_table_id, source_column_id, source_version, reference_table_id, reference_column_id, reference_version, score_cutoff, normalize) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(source_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(source_column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(reference_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(reference_column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            wasm.clientapp_open_reference_matching_wizard(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, source_version, ptr2, len2, ptr3, len3, reference_version, score_cutoff, normalize);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Re-open the live investigation without adding the selection to it.
     */
    open_row_graph() {
        wasm.clientapp_open_row_graph(this.__wbg_ptr);
    }
    /**
     * Reads cached model permissions without triggering a WS request.
     * Safe to call from `useMemo` (pure, no side effects).
     * @returns {any}
     */
    peek_model_permissions() {
        const ret = wasm.clientapp_peek_model_permissions(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Reads cached table permissions without triggering a WS request.
     * Safe to call from `useMemo` (pure, no side effects).
     * @param {string} table_id
     * @returns {any}
     */
    peek_table_permissions(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_peek_table_permissions(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * @returns {number}
     */
    pending_action_count() {
        const ret = wasm.clientapp_pending_action_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Pinned version of `table_id` in the current model. `null` if the
     * model isn't loaded or the table isn't pinned here.
     * @param {string} table_id
     * @returns {any}
     */
    pinned_version_for_table(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_pinned_version_for_table(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `{ version_a, version_b }` for the audit request body, or `null` when the audit doesn't
     * apply here.
     * @param {string} link_id
     * @returns {any}
     */
    pinned_versions_for_link(link_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(link_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_pinned_versions_for_link(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} value
     * @returns {any}
     */
    predict_cell_parse_effect(table_id, column_id, value) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_predict_cell_parse_effect(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return takeObject(ret);
    }
    /**
     * The value is judged AS `staged_type`, so type errors surface while typing on a still-untyped
     * column (see `handle_new_typed_cell_value_ui`).
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} value
     * @param {PhysicalKind} staged_type
     * @returns {any}
     */
    predict_cell_parse_effect_staged(table_id, column_id, value, staged_type) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_predict_cell_parse_effect_staged(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, staged_type);
        return takeObject(ret);
    }
    /**
     * The action bar's Commit, under ↑'s rule. Errors under a conflict, which
     * the UI toasts.
     * @param {string} view_id
     */
    press_commit(view_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_press_commit(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {MouseEvent} event
     * @returns {boolean}
     */
    press_on_edited_target(event) {
        const ret = wasm.clientapp_press_on_edited_target(this.__wbg_ptr, addHeapObject(event));
        return ret !== 0;
    }
    /**
     * The column's own Rust formatter, so the Display picker's preview is byte-exact; ISO 8601
     * when `date_format` is None.
     * @param {number} days
     * @param {string | null} [date_format]
     * @returns {string}
     */
    preview_date_format(days, date_format) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(date_format) ? 0 : passStringToWasm0(date_format, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len0 = WASM_VECTOR_LEN;
            wasm.clientapp_preview_date_format(retptr, this.__wbg_ptr, days, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred2_0 = r0;
            deferred2_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * `{ micros: string|null, formatted: string|null, unit_label }`. A bare number reads in the
     * column's display unit, an explicit one (`5 ms`) overrides; `micros` is what to commit.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} input
     * @returns {any}
     */
    preview_duration_cell_input(table_id, column_id, input) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(input, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_preview_duration_cell_input(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return takeObject(ret);
    }
    /**
     * Seconds when `unit` is None; `decimal_places` None keeps the trimmed rendering.
     * @param {bigint} micros
     * @param {string | null} [unit]
     * @param {number | null} [decimal_places]
     * @returns {string}
     */
    preview_duration_unit(micros, unit, decimal_places) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(unit) ? 0 : passStringToWasm0(unit, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len0 = WASM_VECTOR_LEN;
            wasm.clientapp_preview_duration_unit(retptr, this.__wbg_ptr, micros, ptr0, len0, isLikeNone(decimal_places) ? 0xFFFFFF : decimal_places);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred2_0 = r0;
            deferred2_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * The column's own Rust formatter, so the Display picker's preview is byte-exact; the
     * canonical render when `timestamp_format` is None.
     * @param {bigint} ts
     * @param {string | null} [timezone]
     * @param {string | null} [timestamp_format]
     * @returns {string}
     */
    preview_timestamp_format(ts, timezone, timestamp_format) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(timezone) ? 0 : passStringToWasm0(timezone, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(timestamp_format) ? 0 : passStringToWasm0(timestamp_format, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            wasm.clientapp_preview_timestamp_format(retptr, this.__wbg_ptr, ts, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred3_0 = r0;
            deferred3_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Change a category's color.
     * @param {string} table_id
     * @param {string} column_id
     * @param {number} category_id
     * @param {string} new_color
     */
    recolor_category(table_id, column_id, category_id, new_color) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(new_color, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_recolor_category(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, category_id, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Bypasses the TTL: clears the freshness entry and fetches at once.
     * @param {string} table_id
     */
    refresh_links_for_table(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_refresh_links_for_table(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Only `LocalSqliteDatabase` and `Bucket` sources rebind here; Postgres / Supabase rebind
     * through a server-side metadata endpoint.
     * @param {string} table_id
     * @param {string} new_saved_connection_id_str
     */
    relink_saved_connection(table_id, new_saved_connection_id_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(new_saved_connection_id_str, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_relink_saved_connection(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Remove a category.
     * @param {string} table_id
     * @param {string} column_id
     * @param {number} category_id
     */
    remove_category(table_id, column_id, category_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_remove_category(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, category_id);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Close/remove a diff view and trigger cleanup of its temporary Lance table.
     * @param {string} item_id
     */
    remove_table_diff_view(item_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_remove_table_diff_view(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Rename a category.
     * @param {string} table_id
     * @param {string} column_id
     * @param {number} category_id
     * @param {string} new_label
     */
    rename_category(table_id, column_id, category_id, new_label) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(new_label, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_rename_category(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, category_id, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} name
     */
    rename_model(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rename_model(this.__wbg_ptr, ptr0, len0);
    }
    render_canvas() {
        wasm.clientapp_render_canvas(this.__wbg_ptr);
    }
    /**
     * Request checkpoint removal via model action (server-side expansion).
     * Deletes the checkpoint and cascade-removes dependent diff views.
     * @param {string} table_id
     * @param {string} checkpoint_id
     */
    request_checkpoint_removal(table_id, checkpoint_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_request_checkpoint_removal(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `version_ref_a`/`version_ref_b`: `{ version: 5, checkpoint_id: "cp-xxx" }`.
     * @param {string} table_id
     * @param {any} version_ref_a
     * @param {any} version_ref_b
     */
    request_table_diff(table_id, version_ref_a, version_ref_b) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_request_table_diff(retptr, this.__wbg_ptr, ptr0, len0, addHeapObject(version_ref_a), addHeapObject(version_ref_b));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * JSON `ProposedLinkResult[]`, each for `handle_create_table_link_if_absent`. The child's
     * identity and column mapping are passed in: on import its snapshot isn't in model state yet.
     * @param {string} child_table_id
     * @param {string} saved_connection_id
     * @param {string} schema
     * @param {string} table
     * @param {string} column_mapping_json
     * @param {string} foreign_keys_json
     * @returns {string}
     */
    resolve_source_fk_links(child_table_id, saved_connection_id, schema, table, column_mapping_json, foreign_keys_json) {
        let deferred8_0;
        let deferred8_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(child_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(saved_connection_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(schema, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(table, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(column_mapping_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            const ptr5 = passStringToWasm0(foreign_keys_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len5 = WASM_VECTOR_LEN;
            wasm.clientapp_resolve_source_fk_links(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr7 = r0;
            var len7 = r1;
            if (r3) {
                ptr7 = 0; len7 = 0;
                throw takeObject(r2);
            }
            deferred8_0 = ptr7;
            deferred8_1 = len7;
            return getStringFromWasm0(ptr7, len7);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred8_0, deferred8_1, 1);
        }
    }
    /**
     * The inspector's Retry after a failed chunk load: re-request the `columns` it shows now.
     * @param {string} table_id
     * @param {bigint} row_id
     * @param {string[]} columns
     */
    retry_row_data(table_id, row_id, columns) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(columns, wasm.__wbindgen_export);
        const len1 = WASM_VECTOR_LEN;
        wasm.clientapp_retry_row_data(this.__wbg_ptr, ptr0, len0, row_id, ptr1, len1);
    }
    /**
     * @param {string} item_id
     */
    reveal_item(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_reveal_item(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * JSON of the row's Attachment cell, or `"null"` when its table has none.
     * @param {string} table_id
     * @param {bigint} row_id
     * @returns {string}
     */
    row_attachment(table_id, row_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_row_attachment(retptr, this.__wbg_ptr, ptr0, len0, row_id);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred2_0 = r0;
            deferred2_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * How many more rows the investigation can hold before it's full.
     * @returns {number}
     */
    row_graph_headroom() {
        const ret = wasm.clientapp_row_graph_headroom(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * JSON of one row's record, or `"null"`; see `CoreClientApp::row_inspector`. With
     * `fetch_columns`, only the first `mounted` fields and `active_column` are built and only
     * `fetch_columns` requested; without it, nothing is requested.
     * @param {string} table_id
     * @param {bigint} row_id
     * @param {string | null} [item_id]
     * @param {string[] | null} [fetch_columns]
     * @param {number | null} [mounted]
     * @param {string | null} [active_column]
     * @returns {string}
     */
    row_inspector(table_id, row_id, item_id, fetch_columns, mounted, active_column) {
        let deferred5_0;
        let deferred5_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(item_id) ? 0 : passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(fetch_columns) ? 0 : passArrayJsValueToWasm0(fetch_columns, wasm.__wbindgen_export);
            var len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(active_column) ? 0 : passStringToWasm0(active_column, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len3 = WASM_VECTOR_LEN;
            wasm.clientapp_row_inspector(retptr, this.__wbg_ptr, ptr0, len0, row_id, ptr1, len1, ptr2, len2, isLikeNone(mounted) ? 0x100000001 : (mounted) >>> 0, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred5_0 = r0;
            deferred5_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred5_0, deferred5_1, 1);
        }
    }
    /**
     * JSON body for `POST /data-service/row-graph/close` (edges among resident nodes), or
     * `"null"` when there is nothing to close.
     * @returns {string}
     */
    rowgraph_close_request() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_rowgraph_close_request(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Collapse `source_node`'s expansion into `target_table_id`.
     * @param {string} source_node
     * @param {string} target_table_id
     * @param {boolean} bulk
     */
    rowgraph_collapse(source_node, target_table_id, bulk) {
        const ptr0 = passStringToWasm0(source_node, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(target_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_collapse(this.__wbg_ptr, ptr0, len0, ptr1, len1, bulk);
    }
    /**
     * JSON `{ "source_node", "bulk", "body" }` (POST `body` to the data-service) or "null" when
     * not expandable. `bulk` expands from every resident row of the source table.
     * @param {string} source_node
     * @param {string} target_table_id
     * @param {boolean} bulk
     * @returns {string}
     */
    rowgraph_expand_request(source_node, target_table_id, bulk) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(source_node, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(target_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_rowgraph_expand_request(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, bulk);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred3_0 = r0;
            deferred3_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Lights the focused row's rows in `table_id` on the row graph, or clears the light with
     * `None`.
     * @param {string | null} [table_id]
     */
    rowgraph_light_linked(table_id) {
        var ptr0 = isLikeNone(table_id) ? 0 : passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_light_linked(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Lights the focused row and `node_id`, or clears the light with `None`.
     * @param {string | null} [node_id]
     */
    rowgraph_light_node(node_id) {
        var ptr0 = isLikeNone(node_id) ? 0 : passStringToWasm0(node_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_light_node(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * A schema mutation (+1 version, broadcast to collaborators); a no-op unless the caller may
     * edit an owned in-model table.
     */
    rowgraph_promote_label_default() {
        wasm.clientapp_rowgraph_promote_label_default(this.__wbg_ptr);
    }
    /**
     * Driven by a close/expand 403, the only revocation signal a never-imported foreign table
     * has. `table_ids_json` is a JSON array of table ids.
     * @param {string} table_ids_json
     */
    rowgraph_revoke_tables(table_ids_json) {
        const ptr0 = passStringToWasm0(table_ids_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_revoke_tables(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Selects a row node, as clicking it would.
     * @param {string} node_id
     */
    rowgraph_select_node(node_id) {
        const ptr0 = passStringToWasm0(node_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_select_node(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Set the node-label column for the focused row's table (the "Node label"
     * picker), relabelling that table's nodes live.
     * @param {string} column_id
     */
    rowgraph_set_label_column(column_id) {
        const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_set_label_column(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Set (or clear, when `column_id` is empty) the secondary-label column for
     * the focused row's table — the node's muted second line.
     * @param {string} column_id
     */
    rowgraph_set_sublabel_column(column_id) {
        const ptr0 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_rowgraph_set_sublabel_column(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Distinct table ids the row graph holds nodes for — React reads this to
     * know whose stored label defaults to fetch.
     * @returns {string[]}
     */
    rowgraph_table_ids() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_rowgraph_table_ids(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    save_viewport() {
        wasm.clientapp_save_viewport(this.__wbg_ptr);
    }
    /**
     * `spec`: `{query, replacement, match_case, whole_word, is_regex}`. `at_version` is what the
     * preview was computed against; the action rejects on drift so the user can re-preview.
     * @param {string} table_id
     * @param {string} column_id
     * @param {any} spec
     * @param {bigint} at_version
     */
    search_replace_in_place(table_id, column_id, spec, at_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_search_replace_in_place(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, addHeapObject(spec), at_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Apply a search & replace into a new String column next to the source.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} new_column_name
     * @param {any} spec
     * @param {bigint} at_version
     */
    search_replace_new_column(table_id, column_id, new_column_name, spec, at_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(new_column_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_search_replace_new_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, addHeapObject(spec), at_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Empty `ids_json` (`"[]"`) deselects. Call on the click only: `set_dataset_highlight` is
     * re-pushed on theme changes, this must not be.
     * @param {string} ids_json
     */
    select_dataset_tables(ids_json) {
        const ptr0 = passStringToWasm0(ids_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_select_dataset_tables(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} table_id
     */
    select_table(table_id) {
        const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_select_table(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} view_item
     * @param {string[]} column_ids
     */
    select_view_columns(view_item, column_ids) {
        const ptr0 = passStringToWasm0(view_item, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(column_ids, wasm.__wbindgen_export);
        const len1 = WASM_VECTOR_LEN;
        wasm.clientapp_select_view_columns(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * Makes an empty (ND) column a *pending* formula column; its formula is authored later in the
     * formula magic bar.
     * @param {string} table_id
     * @param {string} column_id
     */
    set_column_as_formula(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_as_formula(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `None` (JS `null`/`undefined`) or an empty string clears it; anything over the character
     * cap is rejected.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string | null} [description]
     */
    set_column_description(table_id, column_id, description) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(description) ? 0 : passStringToWasm0(description, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len2 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_description(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @param {string | null | undefined} timezone
     * @param {number | null | undefined} decimal_places
     * @param {string | null | undefined} thousand_separator
     * @param {string | null | undefined} timestamp_format
     * @param {string | null | undefined} date_format
     * @param {string | null | undefined} duration_display_unit
     * @param {boolean} link_enabled
     */
    set_column_display_settings(table_id, column_id, timezone, decimal_places, thousand_separator, timestamp_format, date_format, duration_display_unit, link_enabled) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(timezone) ? 0 : passStringToWasm0(timezone, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(thousand_separator) ? 0 : passStringToWasm0(thousand_separator, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len3 = WASM_VECTOR_LEN;
            var ptr4 = isLikeNone(timestamp_format) ? 0 : passStringToWasm0(timestamp_format, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len4 = WASM_VECTOR_LEN;
            var ptr5 = isLikeNone(date_format) ? 0 : passStringToWasm0(date_format, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len5 = WASM_VECTOR_LEN;
            var ptr6 = isLikeNone(duration_display_unit) ? 0 : passStringToWasm0(duration_display_unit, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len6 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_display_settings(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, isLikeNone(decimal_places) ? 0xFFFFFF : decimal_places, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, link_enabled);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Exact widens int⊔float to Decimal128 instead of the approximate F64, on the next autocast
     * only, never existing data.
     * @param {string} table_id
     * @param {string} column_id
     * @param {boolean} is_exact
     */
    set_column_exact(table_id, column_id, is_exact) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_exact(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, is_exact);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Sets or clears one column's search term. Returns whether that column now
     * carries a term, so the bar knows if it is showing a live search.
     * @param {string} view_id
     * @param {string} column_id
     * @param {string} term
     * @returns {boolean}
     */
    set_column_search(view_id, column_id, term) {
        const ptr0 = passStringToWasm0(view_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(term, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.clientapp_set_column_search(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return ret !== 0;
    }
    /**
     * The UI offers distinct / primary-key only on eligible types (`supports_distinct_intent`).
     * @param {string} table_id
     * @param {string} column_id
     * @param {boolean} nullable
     * @param {boolean} distinct
     * @param {boolean} primary_key_member
     */
    set_column_semantic_intents(table_id, column_id, nullable, distinct, primary_key_member) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_semantic_intents(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, nullable, distinct, primary_key_member);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `assignment`: `null` clears, else a `UnitAssignment` (`stored_unit_uri`,
     * `stored_unit_source`, `scale_exponent`).
     * @param {string} table_id
     * @param {string} column_id
     * @param {any} assignment
     */
    set_column_unit_assignment(table_id, column_id, assignment) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_set_column_unit_assignment(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, addHeapObject(assignment));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `ast_json` is the editor's lowered `FormulaAst`; the result type is derived from it, since
     * client and server run the same engine.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} ast_json
     */
    set_computed_formula(table_id, column_id, ast_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(ast_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_set_computed_formula(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Locks the pointer tool. Errors on an unknown name.
     * @param {CursorModeJS} mode
     */
    set_cursor_mode(mode) {
        wasm.clientapp_set_cursor_mode(this.__wbg_ptr, (__wbindgen_enum_CursorModeJS.indexOf(mode) + 1 || 3) - 1);
    }
    /**
     * Per-table dataset dot colors: JSON `{ "<tableId>": ["#hex", …], … }`.
     * @param {string} json
     */
    set_dataset_dots(json) {
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_set_dataset_dots(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Ring a dataset's nodes + recolor links between them. Empty `ids_json`
     * (`"[]"`) or empty `color` clears the highlight.
     * @param {string} ids_json
     * @param {string} color
     */
    set_dataset_highlight(ids_json, color) {
        const ptr0 = passStringToWasm0(ids_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(color, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.clientapp_set_dataset_highlight(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * @param {boolean} restricted
     */
    set_editing_restricted(restricted) {
        wasm.clientapp_set_editing_restricted(this.__wbg_ptr, restricted);
    }
    /**
     * @param {boolean} online
     */
    set_online(online) {
        wasm.clientapp_set_online(this.__wbg_ptr, online);
    }
    /**
     * The browser's `prefers-reduced-motion`.
     * @param {boolean} reduced
     */
    set_reduced_motion(reduced) {
        wasm.clientapp_set_reduced_motion(this.__wbg_ptr, reduced);
    }
    /**
     * Change a connector table's row-identity strategy (a model action every
     * client sees). `row_identity_json` empty ⇒ back to the source default.
     * @param {string} table_id
     * @param {string} row_identity_json
     */
    set_row_identity(table_id, row_identity_json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(row_identity_json, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_set_row_identity(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {number} left
     * @param {number} top
     * @param {number} width
     * @param {number} height
     * @param {number} dpr
     */
    set_screen_rect(left, top, width, height, dpr) {
        wasm.clientapp_set_screen_rect(this.__wbg_ptr, left, top, width, height, dpr);
    }
    /**
     * Switches the canvas color theme (`"light"` or `"dark"`).
     * @param {string} name
     */
    set_theme(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_set_theme(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * True when no single cell is focused, so a plain-text paste goes to the import worker as a
     * new table.
     * @returns {boolean}
     */
    should_paste_create_table() {
        const ret = wasm.clientapp_should_paste_create_table(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `spec`: `{delimiter, is_regex, trim_parts, drop_empty_parts, output}`, with `output`
     * `"List"` or `{Part: {index}}` (0-based). `at_version` as in `search_replace_in_place`.
     * @param {string} table_id
     * @param {string} column_id
     * @param {string} new_column_name
     * @param {any} spec
     * @param {bigint} at_version
     */
    split_new_column(table_id, column_id, new_column_name, spec, at_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(new_column_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.clientapp_split_new_column(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, addHeapObject(spec), at_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} user_id
     */
    start_following_user(user_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_start_following_user(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    stop_following_user() {
        wasm.clientapp_stop_following_user(this.__wbg_ptr);
    }
    /**
     * The table's Attachment column id, or `None` when it has none yet.
     * @param {string} table_id
     * @returns {string | undefined}
     */
    table_attachment_column_id(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_attachment_column_id(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v2;
            if (r0 !== 0) {
                v2 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @returns {TableColumns}
     */
    table_columns_by_table_id(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_columns_by_table_id(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableColumns.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @returns {bigint}
     */
    table_current_version(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_current_version(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @returns {TableDetails}
     */
    table_details_by_table_id(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_details_by_table_id(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `false` when the table is unknown locally; the UI should fail closed (hide) anyway, since
     * the server-side guard is the canonical answer.
     * @param {string} table_id
     * @returns {boolean}
     */
    table_is_locked_to_parent(table_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_is_locked_to_parent(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * By `LinkKey`: the same pairs in any order, from either side. A pair shared with another
     * link is not a duplicate.
     * @param {string} first_table_id
     * @param {string} second_table_id
     * @param {string[]} first_column_ids
     * @param {string[]} second_column_ids
     * @returns {boolean}
     */
    table_link_exists(first_table_id, second_table_id, first_column_ids, second_column_ids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(first_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(second_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passArrayJsValueToWasm0(first_column_ids, wasm.__wbindgen_export);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passArrayJsValueToWasm0(second_column_ids, wasm.__wbindgen_export);
            const len3 = WASM_VECTOR_LEN;
            wasm.clientapp_table_link_exists(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * JSON `RowIdentity` stored on a connector table, empty when unset.
     * @param {string} table_id
     * @returns {string}
     */
    table_row_identity_json(table_id) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_table_row_identity_json(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {string} colum_id
     * @param {string} table_id
     * @param {boolean} set_to_locked
     */
    toggle_column_dtype_lock(colum_id, table_id, set_to_locked) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(colum_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_toggle_column_dtype_lock(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, set_to_locked);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} item_id
     * @param {Filter | null} [filter]
     */
    update_table_view_filter(table_id, item_id, filter) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            let ptr2 = 0;
            if (!isLikeNone(filter)) {
                _assertClass(filter, Filter);
                ptr2 = filter.__destroy_into_raw();
            }
            wasm.clientapp_update_table_view_filter(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {UserModelRole}
     */
    user_role() {
        const ret = wasm.clientapp_user_role(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */
    wants_pointer_capture() {
        const ret = wasm.clientapp_wants_pointer_capture(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} raw
     */
    wizard_accept_suggestion(raw) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(raw, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_wizard_accept_suggestion(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Dispatch the final `AddMappedColumn` action. Closes the wizard on
     * success.
     * @param {string} new_column_name
     */
    wizard_apply(new_column_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(new_column_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_wizard_apply(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Apply a fulfillment response (parsed from JSON on the JS side).
     * Returns true if applied, false if dropped as stale.
     * @param {any} fulfillment
     * @returns {boolean}
     */
    wizard_apply_fulfillment(fulfillment) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_wizard_apply_fulfillment(retptr, this.__wbg_ptr, addHeapObject(fulfillment));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} raw
     */
    wizard_clear_user_decision(raw) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(raw, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_wizard_clear_user_decision(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Reserve the next `request_id` for a discover-mapping POST.
     * @returns {bigint}
     */
    wizard_mark_request_in_flight() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.clientapp_wizard_mark_request_in_flight(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} raw
     * @param {string} canonical
     */
    wizard_set_user_decision(raw, canonical) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(raw, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(canonical, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.clientapp_wizard_set_user_decision(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} raw
     */
    wizard_skip(raw) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(raw, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.clientapp_wizard_skip(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * `{ decisions, reference_values, settings, counts, is_loaded, last_applied_request_id }`, or
     * `null` when the wizard isn't open.
     * @returns {any}
     */
    wizard_state_snapshot() {
        const ret = wasm.clientapp_wizard_state_snapshot(this.__wbg_ptr);
        return takeObject(ret);
    }
    zoom_in_step() {
        wasm.clientapp_zoom_in_step(this.__wbg_ptr);
    }
    zoom_out_step() {
        wasm.clientapp_zoom_out_step(this.__wbg_ptr);
    }
    zoom_to_content() {
        wasm.clientapp_zoom_to_content(this.__wbg_ptr);
    }
    /**
     * @param {string} item_id
     */
    zoom_to_item(item_id) {
        const ptr0 = passStringToWasm0(item_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.clientapp_zoom_to_item(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) ClientApp.prototype[Symbol.dispose] = ClientApp.prototype.free;

export class ColumnID {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ColumnIDFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_columnid_free(ptr, 0);
    }
}
if (Symbol.dispose) ColumnID.prototype[Symbol.dispose] = ColumnID.prototype.free;

export class ColumnModel {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ColumnModelFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_columnmodel_free(ptr, 0);
    }
    /**
     * @returns {bigint}
     */
    get created_at() {
        const ret = wasm.__wbg_get_columnmodel_created_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {PhysicalKind}
     */
    get data_type() {
        const ret = wasm.__wbg_get_columnmodel_data_type(this.__wbg_ptr);
        return ret;
    }
    /**
     * DateDisplayFormat preset name, see common_core::table::
     * column_display_settings::DateDisplayFormat::as_wire_str().
     * @returns {string | undefined}
     */
    get date_format() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_date_format(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number | undefined}
     */
    get decimal_places() {
        const ret = wasm.__wbg_get_columnmodel_decimal_places(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * @returns {string}
     */
    get dependency_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_dependency_type(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get display_timezone() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_display_timezone(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * DurationDisplayUnit wire name (e.g. "Days"). None ⇒ default (seconds).
     * @returns {string | undefined}
     */
    get duration_display_unit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_duration_display_unit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get index() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_index(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */
    get is_deleted() {
        const ret = wasm.__wbg_get_columnmodel_is_deleted(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_distinct() {
        const ret = wasm.__wbg_get_columnmodel_is_distinct(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_empty() {
        const ret = wasm.__wbg_get_columnmodel_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Exactness bit (Number columns): int⊔float widens to Decimal128, not F64.
     * @returns {boolean}
     */
    get is_exact() {
        const ret = wasm.__wbg_get_columnmodel_is_exact(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Semantic-intent flags (hints, not enforced).
     * @returns {boolean}
     */
    get is_nullable() {
        const ret = wasm.__wbg_get_columnmodel_is_nullable(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_primary_key_member() {
        const ret = wasm.__wbg_get_columnmodel_is_primary_key_member(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_type_locked() {
        const ret = wasm.__wbg_get_columnmodel_is_type_locked(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {bigint}
     */
    get last_modified() {
        const ret = wasm.__wbg_get_columnmodel_last_modified(this.__wbg_ptr);
        return ret;
    }
    /**
     * True when this column should be rendered as an external URL link.
     * @returns {boolean}
     */
    get link_enabled() {
        const ret = wasm.__wbg_get_columnmodel_link_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string | undefined}
     */
    get name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get thousand_separator() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_thousand_separator(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * TimestampDisplayFormat preset name, see common_core::table::
     * column_display_settings::TimestampDisplayFormat::as_wire_str().
     * @returns {string | undefined}
     */
    get timestamp_format() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_timestamp_format(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {bigint} arg0
     */
    set created_at(arg0) {
        wasm.__wbg_set_columnmodel_created_at(this.__wbg_ptr, arg0);
    }
    /**
     * @param {PhysicalKind} arg0
     */
    set data_type(arg0) {
        wasm.__wbg_set_columnmodel_data_type(this.__wbg_ptr, arg0);
    }
    /**
     * DateDisplayFormat preset name, see common_core::table::
     * column_display_settings::DateDisplayFormat::as_wire_str().
     * @param {string | null} [arg0]
     */
    set date_format(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_date_format(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number | null} [arg0]
     */
    set decimal_places(arg0) {
        wasm.__wbg_set_columnmodel_decimal_places(this.__wbg_ptr, isLikeNone(arg0) ? 0xFFFFFF : arg0);
    }
    /**
     * @param {string} arg0
     */
    set dependency_type(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_dependency_type(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set display_timezone(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_display_timezone(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * DurationDisplayUnit wire name (e.g. "Days"). None ⇒ default (seconds).
     * @param {string | null} [arg0]
     */
    set duration_display_unit(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_duration_display_unit(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set index(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_index(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_deleted(arg0) {
        wasm.__wbg_set_columnmodel_is_deleted(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_distinct(arg0) {
        wasm.__wbg_set_columnmodel_is_distinct(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_empty(arg0) {
        wasm.__wbg_set_columnmodel_is_empty(this.__wbg_ptr, arg0);
    }
    /**
     * Exactness bit (Number columns): int⊔float widens to Decimal128, not F64.
     * @param {boolean} arg0
     */
    set is_exact(arg0) {
        wasm.__wbg_set_columnmodel_is_exact(this.__wbg_ptr, arg0);
    }
    /**
     * Semantic-intent flags (hints, not enforced).
     * @param {boolean} arg0
     */
    set is_nullable(arg0) {
        wasm.__wbg_set_columnmodel_is_nullable(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_primary_key_member(arg0) {
        wasm.__wbg_set_columnmodel_is_primary_key_member(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_type_locked(arg0) {
        wasm.__wbg_set_columnmodel_is_type_locked(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set last_modified(arg0) {
        wasm.__wbg_set_columnmodel_last_modified(this.__wbg_ptr, arg0);
    }
    /**
     * True when this column should be rendered as an external URL link.
     * @param {boolean} arg0
     */
    set link_enabled(arg0) {
        wasm.__wbg_set_columnmodel_link_enabled(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set name(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set thousand_separator(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_thousand_separator(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * TimestampDisplayFormat preset name, see common_core::table::
     * column_display_settings::TimestampDisplayFormat::as_wire_str().
     * @param {string | null} [arg0]
     */
    set timestamp_format(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_timestamp_format(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) ColumnModel.prototype[Symbol.dispose] = ColumnModel.prototype.free;

export class CreateCheckpointRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CreateCheckpointRequest.prototype);
        obj.__wbg_ptr = ptr;
        CreateCheckpointRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CreateCheckpointRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_createcheckpointrequest_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    created_by_email() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.createcheckpointrequest_created_by_email(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} alias
     * @param {bigint} table_version
     * @param {string} created_by
     * @returns {CreateCheckpointRequest}
     */
    static new_js(table_id, alias, table_version, created_by) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(created_by, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.createcheckpointrequest_new_js(retptr, ptr0, len0, ptr1, len1, table_version, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CreateCheckpointRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    table_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.createcheckpointrequest_table_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    table_version_number() {
        const ret = wasm.createcheckpointrequest_table_version_number(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.createcheckpointrequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) CreateCheckpointRequest.prototype[Symbol.dispose] = CreateCheckpointRequest.prototype.free;

export class DElement {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DElement.prototype);
        obj.__wbg_ptr = ptr;
        DElementFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DElementFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_delement_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_provider(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */
    get inherited_name() {
        const ret = wasm.__wbg_get_delement_inherited_name(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {ModelItemInstanceJS}
     */
    get instance() {
        const ret = wasm.__wbg_get_delement_instance(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */
    get is_collapsed() {
        const ret = wasm.__wbg_get_delement_is_collapsed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_leaf() {
        const ret = wasm.__wbg_get_delement_is_leaf(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */
    get n_children() {
        const ret = wasm.__wbg_get_delement_n_children(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_object_path(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */
    get of_forgeign_model() {
        const ret = wasm.__wbg_get_delement_of_forgeign_model(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    get parent_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_bucket(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_provider(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {boolean} arg0
     */
    set inherited_name(arg0) {
        wasm.__wbg_set_delement_inherited_name(this.__wbg_ptr, arg0);
    }
    /**
     * @param {ModelItemInstanceJS} arg0
     */
    set instance(arg0) {
        wasm.__wbg_set_delement_instance(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_collapsed(arg0) {
        wasm.__wbg_set_delement_is_collapsed(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_leaf(arg0) {
        wasm.__wbg_set_delement_is_leaf(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set n_children(arg0) {
        wasm.__wbg_set_delement_n_children(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_object_path(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {boolean} arg0
     */
    set of_forgeign_model(arg0) {
        wasm.__wbg_set_delement_of_forgeign_model(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set parent_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_bucket(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) DElement.prototype[Symbol.dispose] = DElement.prototype.free;

export class DeleteCheckpointRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DeleteCheckpointRequest.prototype);
        obj.__wbg_ptr = ptr;
        DeleteCheckpointRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DeleteCheckpointRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_deletecheckpointrequest_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    checkpoint_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.deletecheckpointrequest_checkpoint_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} checkpoint_id
     * @returns {DeleteCheckpointRequest}
     */
    static new_js(table_id, checkpoint_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.deletecheckpointrequest_new_js(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DeleteCheckpointRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    table_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.deletecheckpointrequest_table_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.deletecheckpointrequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) DeleteCheckpointRequest.prototype[Symbol.dispose] = DeleteCheckpointRequest.prototype.free;

export class DisplayCondition {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DisplayCondition.prototype);
        obj.__wbg_ptr = ptr;
        DisplayConditionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DisplayConditionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_displaycondition_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    get case_sensitive() {
        const ret = wasm.displaycondition_case_sensitive(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string | undefined}
     */
    get column_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_column_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get field() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_field(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {FilterOperator | undefined}
     */
    get operator() {
        const ret = wasm.displaycondition_operator(this.__wbg_ptr);
        return ret === 12 ? undefined : ret;
    }
    /**
     * @returns {string[] | undefined}
     */
    get string_array() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_string_array(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getArrayJsValueFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 4, 4);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get table_alias() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_table_alias(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get table_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaycondition_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {PhysicalKind | undefined}
     */
    get value_type() {
        const ret = wasm.displaycondition_value_type(this.__wbg_ptr);
        return ret === 20 ? undefined : ret;
    }
}
if (Symbol.dispose) DisplayCondition.prototype[Symbol.dispose] = DisplayCondition.prototype.free;

export class DisplayGroup {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DisplayGroup.prototype);
        obj.__wbg_ptr = ptr;
        DisplayGroupFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DisplayGroupFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_displaygroup_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    conditions() {
        const ret = wasm.displaygroup_conditions(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    groups() {
        const ret = wasm.displaygroup_groups(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaygroup_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {DisplayItemJS[]}
     */
    get items() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaygroup_items(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {LogicalOperator}
     */
    get operator() {
        const ret = wasm.displaygroup_operator(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get to_string() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.displaygroup_to_string(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) DisplayGroup.prototype[Symbol.dispose] = DisplayGroup.prototype.free;

export class DisplayItemJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DisplayItemJS.prototype);
        obj.__wbg_ptr = ptr;
        DisplayItemJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DisplayItemJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_displayitemjs_free(ptr, 0);
    }
    /**
     * @returns {DisplayCondition | undefined}
     */
    as_condition() {
        const ret = wasm.displayitemjs_as_condition(this.__wbg_ptr);
        return ret === 0 ? undefined : DisplayCondition.__wrap(ret);
    }
    /**
     * @returns {DisplayGroup | undefined}
     */
    as_group() {
        const ret = wasm.displayitemjs_as_group(this.__wbg_ptr);
        return ret === 0 ? undefined : DisplayGroup.__wrap(ret);
    }
    /**
     * @returns {boolean}
     */
    is_condition() {
        const ret = wasm.displayitemjs_is_condition(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_group() {
        const ret = wasm.displayitemjs_is_group(this.__wbg_ptr);
        return ret !== 0;
    }
}
if (Symbol.dispose) DisplayItemJS.prototype[Symbol.dispose] = DisplayItemJS.prototype.free;

export class DisplayStructure {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DisplayStructureFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_displaystructure_free(ptr, 0);
    }
    /**
     * @returns {DisplayGroup}
     */
    get root() {
        const ret = wasm.displaystructure_root(this.__wbg_ptr);
        return DisplayGroup.__wrap(ret);
    }
}
if (Symbol.dispose) DisplayStructure.prototype[Symbol.dispose] = DisplayStructure.prototype.free;

export class EnsureCheckpointRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(EnsureCheckpointRequest.prototype);
        obj.__wbg_ptr = ptr;
        EnsureCheckpointRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EnsureCheckpointRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ensurecheckpointrequest_free(ptr, 0);
    }
    /**
     * @param {string} table_id
     * @param {bigint} table_version
     * @returns {EnsureCheckpointRequest}
     */
    static new_js(table_id, table_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.ensurecheckpointrequest_new_js(retptr, ptr0, len0, table_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return EnsureCheckpointRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.ensurecheckpointrequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) EnsureCheckpointRequest.prototype[Symbol.dispose] = EnsureCheckpointRequest.prototype.free;

export class Filter {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Filter.prototype);
        obj.__wbg_ptr = ptr;
        FilterFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilterFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filter_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    toJsValue() {
        const ret = wasm.filter_toJsValue(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {boolean}
     */
    get valid() {
        const ret = wasm.filter_valid(this.__wbg_ptr);
        return ret !== 0;
    }
}
if (Symbol.dispose) Filter.prototype[Symbol.dispose] = Filter.prototype.free;

export class FilterCondition {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilterConditionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filtercondition_free(ptr, 0);
    }
}
if (Symbol.dispose) FilterCondition.prototype[Symbol.dispose] = FilterCondition.prototype.free;

export class FilterConditionBuilder {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilterConditionBuilderFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filterconditionbuilder_free(ptr, 0);
    }
}
if (Symbol.dispose) FilterConditionBuilder.prototype[Symbol.dispose] = FilterConditionBuilder.prototype.free;

export class FilterGroup {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilterGroupFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filtergroup_free(ptr, 0);
    }
}
if (Symbol.dispose) FilterGroup.prototype[Symbol.dispose] = FilterGroup.prototype.free;

export class FilterGroupBuilder {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FilterGroupBuilder.prototype);
        obj.__wbg_ptr = ptr;
        FilterGroupBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilterGroupBuilderFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filtergroupbuilder_free(ptr, 0);
    }
    /**
     * @param {string | null} [parent_group_id]
     */
    add_empty_condition(parent_group_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(parent_group_id) ? 0 : passStringToWasm0(parent_group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len0 = WASM_VECTOR_LEN;
            wasm.filtergroupbuilder_add_empty_condition(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string | null} [parent_group_id]
     * @returns {FilterGroupBuilder}
     */
    add_empty_conditionjs(parent_group_id) {
        const ptr = this.__destroy_into_raw();
        var ptr0 = isLikeNone(parent_group_id) ? 0 : passStringToWasm0(parent_group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_add_empty_conditionjs(ptr, ptr0, len0);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * Add empty nested group to specific parent group by parent group ID (None = current)
     * @param {string | null} [parent_group_id]
     * @returns {FilterGroupBuilder}
     */
    add_empty_nested_group(parent_group_id) {
        const ptr = this.__destroy_into_raw();
        var ptr0 = isLikeNone(parent_group_id) ? 0 : passStringToWasm0(parent_group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_add_empty_nested_group(ptr, ptr0, len0);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @returns {FilterGroupBuilder}
     */
    cloneBuilder() {
        const ret = wasm.filtergroupbuilder_cloneBuilder(this.__wbg_ptr);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} condition_id
     * @returns {DisplayCondition | undefined}
     */
    get_condition(condition_id) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_get_condition(this.__wbg_ptr, ptr0, len0);
        return ret === 0 ? undefined : DisplayCondition.__wrap(ret);
    }
    /**
     * @param {string} group_id
     * @returns {string | undefined}
     */
    get_newly_created_item_id(group_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.filtergroupbuilder_get_newly_created_item_id(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v2;
            if (r0 !== 0) {
                v2 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {DisplayGroup}
     */
    get_structure() {
        const ret = wasm.filtergroupbuilder_get_structure(this.__wbg_ptr);
        return DisplayGroup.__wrap(ret);
    }
    /**
     * Checks if the filter is complete and ready for submission.
     * @returns {boolean}
     */
    isFilterComplete() {
        const ret = wasm.filtergroupbuilder_isFilterComplete(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Check if this is a real filter or just a placeholder.
     * @returns {boolean}
     */
    isPlaceholder() {
        const ret = wasm.filtergroupbuilder_isPlaceholder(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} condition_id
     * @param {string | null | undefined} target_group_id
     * @param {number} position
     * @returns {FilterGroupBuilder}
     */
    move_condition(condition_id, target_group_id, position) {
        const ptr = this.__destroy_into_raw();
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(target_group_id) ? 0 : passStringToWasm0(target_group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_move_condition(ptr, ptr0, len0, ptr1, len1, position);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {LogicalOperator} operator
     * @returns {FilterGroupBuilder}
     */
    static newJoinJs(operator) {
        const ret = wasm.filtergroupbuilder_newJoinJs(operator);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {Filter} filter
     * @param {DisplayGroup} display
     * @returns {FilterGroupBuilder}
     */
    static newWithFilterAndDisplay(filter, display) {
        _assertClass(filter, Filter);
        _assertClass(display, DisplayGroup);
        const ret = wasm.filtergroupbuilder_newWithFilterAndDisplay(filter.__wbg_ptr, display.__wbg_ptr);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {Filter} filter
     * @returns {FilterGroupBuilder}
     */
    static new_with_filter(filter) {
        _assertClass(filter, Filter);
        const ret = wasm.filtergroupbuilder_new_with_filter(filter.__wbg_ptr);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {LogicalOperator} operator
     * @returns {FilterGroupBuilder}
     */
    static newjs(operator) {
        const ret = wasm.filtergroupbuilder_newjs(operator);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * Creates a placeholder builder that represents "no filter".
     * Use this when calling functions that require a FilterGroupBuilder but you don't have one.
     * @returns {FilterGroupBuilder}
     */
    static placeholder() {
        const ret = wasm.filtergroupbuilder_placeholder();
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} condition_id
     * @returns {FilterGroupBuilder}
     */
    remove_conditionjs(condition_id) {
        const ptr = this.__destroy_into_raw();
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_remove_conditionjs(ptr, ptr0, len0);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} group_id
     * @returns {FilterGroupBuilder}
     */
    remove_groupjs(group_id) {
        const ptr = this.__destroy_into_raw();
        const ptr0 = passStringToWasm0(group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_remove_groupjs(ptr, ptr0, len0);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} condition_id
     * @param {number} index
     * @returns {FilterGroupBuilder}
     */
    remove_item_from_string_array_by_index(condition_id, index) {
        const ptr = this.__destroy_into_raw();
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_remove_item_from_string_array_by_index(ptr, ptr0, len0, index);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} condition_id
     * @param {string} column_name
     */
    setConditionColumnName(condition_id, column_name) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(column_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_setConditionColumnName(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * @param {string} condition_id
     * @param {PhysicalKind} data_type
     */
    setConditionFieldDataType(condition_id, data_type) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_setConditionFieldDataType(this.__wbg_ptr, ptr0, len0, data_type);
    }
    /**
     * @param {string} condition_id
     * @param {string} table_name
     */
    setConditionTableName(condition_id, table_name) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(table_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_setConditionTableName(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * @param {string} parent_group_id
     * @param {LogicalOperator} operator
     * @returns {FilterGroupBuilder}
     */
    set_group_operator(parent_group_id, operator) {
        const ptr = this.__destroy_into_raw();
        const ptr0 = passStringToWasm0(parent_group_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.filtergroupbuilder_set_group_operator(ptr, ptr0, len0, operator);
        return FilterGroupBuilder.__wrap(ret);
    }
    /**
     * @param {string} condition_id
     * @param {string} new_field
     * @param {string | null} [column_name]
     * @param {PhysicalKind | null} [field_data_type]
     */
    updateConditionFieldWithName(condition_id, new_field, column_name, field_data_type) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(new_field, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(column_name) ? 0 : passStringToWasm0(column_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len2 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_updateConditionFieldWithName(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, isLikeNone(field_data_type) ? 20 : field_data_type);
    }
    /**
     * Updates a condition's table alias (required for join filters).
     * The table_alias should be in format "{table_id}_{alias}" for join queries.
     * @param {string} condition_id
     * @param {string} table_alias
     * @param {string | null} [table_name]
     */
    updateConditionTableAlias(condition_id, table_alias, table_name) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(table_alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(table_name) ? 0 : passStringToWasm0(table_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len2 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_updateConditionTableAlias(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
    }
    /**
     * @param {string} condition_id
     * @param {boolean} case_sensitive
     */
    update_condition_case_sensitive(condition_id, case_sensitive) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.filtergroupbuilder_update_condition_case_sensitive(retptr, this.__wbg_ptr, ptr0, len0, case_sensitive);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} condition_id
     * @param {string} new_field
     */
    update_condition_field(condition_id, new_field) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(new_field, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_update_condition_field(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * @param {string} condition_id
     * @param {FilterOperator} new_operator
     */
    update_condition_operator(condition_id, new_operator) {
        const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.filtergroupbuilder_update_condition_operator(this.__wbg_ptr, ptr0, len0, new_operator);
    }
    /**
     * @param {string} condition_id
     * @param {PhysicalKind | null} [value_type]
     * @param {string | null} [value_raw]
     */
    update_condition_value_raw(condition_id, value_type, value_raw) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(condition_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(value_raw) ? 0 : passStringToWasm0(value_raw, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            wasm.filtergroupbuilder_update_condition_value_raw(retptr, this.__wbg_ptr, ptr0, len0, isLikeNone(value_type) ? 20 : value_type, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {Filter | undefined}
     */
    wasm_build() {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.filtergroupbuilder_wasm_build(retptr, ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 === 0 ? undefined : Filter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) FilterGroupBuilder.prototype[Symbol.dispose] = FilterGroupBuilder.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11}
 */
export const FilterOperator = Object.freeze({
    Equal: 0, "0": "Equal",
    NotEqual: 1, "1": "NotEqual",
    GreaterThan: 2, "2": "GreaterThan",
    GreaterThanOrEqual: 3, "3": "GreaterThanOrEqual",
    LessThan: 4, "4": "LessThan",
    LessThanOrEqual: 5, "5": "LessThanOrEqual",
    Contains: 6, "6": "Contains",
    NotContains: 7, "7": "NotContains",
    IsNull: 8, "8": "IsNull",
    IsNotNull: 9, "9": "IsNotNull",
    In: 10, "10": "In",
    NotIn: 11, "11": "NotIn",
});

/**
 * Specifies the type of filter - either for a single table or for a join query
 * @enum {0 | 1}
 */
export const FilterType = Object.freeze({
    /**
     * Filter for a single table - table_alias in conditions should be None
     */
    Table: 0, "0": "Table",
    /**
     * Filter for a join query - table_alias in conditions must be set
     */
    Join: 1, "1": "Join",
});

export class GetStorageProfileResponse {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GetStorageProfileResponseFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_getstorageprofileresponse_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get message() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.getstorageprofileresponse_message(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} data
     */
    constructor(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(data, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.getstorageprofileresponse_new_js(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            GetStorageProfileResponseFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {bigint}
     */
    get quota_bytes() {
        const ret = wasm.getstorageprofileresponse_quota_bytes(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    get quota_human_readable() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.getstorageprofileresponse_quota_human_readable(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {ResponseStatus}
     */
    get status() {
        const ret = wasm.getstorageprofileresponse_status(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {SubscriptionTier}
     */
    get subscription_tier() {
        const ret = wasm.getstorageprofileresponse_subscription_tier(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {bigint}
     */
    get usage_bytes() {
        const ret = wasm.getstorageprofileresponse_usage_bytes(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    get usage_human_readable() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.getstorageprofileresponse_usage_human_readable(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) GetStorageProfileResponse.prototype[Symbol.dispose] = GetStorageProfileResponse.prototype.free;

/**
 * v1.2.3+ source-identity mirror: `saved_connection_id` + per-variant
 * trailing fields let the React drilldown answer "is this imported?"
 * from in-model state alone. Sync still routes through the connector's
 * `Stored*Metadata`; these are forward-looking forensic fields and are
 * `None` on pre-v1.2.3 snapshots.
 */
export class GoogleSheet {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GoogleSheetFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_googlesheet_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get column_mapping_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_column_mapping_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} connection_id
     * @param {string} column_mapping
     * @param {string} saved_connection_id_str
     * @param {string} spreadsheet_id
     * @param {string} sheet_name
     */
    constructor(connection_id, column_mapping, saved_connection_id_str, spreadsheet_id, sheet_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(connection_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_mapping, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(saved_connection_id_str, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(spreadsheet_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(sheet_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            wasm.googlesheet_newjs(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            GoogleSheetFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get saved_connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_saved_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get sheet_name_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_sheet_name_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get spreadsheet_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_spreadsheet_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) GoogleSheet.prototype[Symbol.dispose] = GoogleSheet.prototype.free;

export class ImportedTable {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ImportedTableFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_importedtable_free(ptr, 0);
    }
    /**
     * @param {number} latest_version
     */
    constructor(latest_version) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.importedtable_newjs(retptr, latest_version);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            ImportedTableFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) ImportedTable.prototype[Symbol.dispose] = ImportedTable.prototype.free;

export class LinkDisplayJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LinkDisplayJS.prototype);
        obj.__wbg_ptr = ptr;
        LinkDisplayJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LinkDisplayJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_linkdisplayjs_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get source_column() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.linkdisplayjs_source_column(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get target_alias() {
        const ret = wasm.linkdisplayjs_target_alias(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get target_column() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.linkdisplayjs_target_column(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get target_table_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.linkdisplayjs_target_table_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get target_table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.linkdisplayjs_target_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) LinkDisplayJS.prototype[Symbol.dispose] = LinkDisplayJS.prototype.free;

/**
 * Wasm-facing mirror of `common_core::table::link_kind::LinkKind` for a
 * single column pair (the payload-free shape the picker needs).
 * @enum {0 | 1 | 2}
 */
export const LinkPairKind = Object.freeze({
    Equality: 0, "0": "Equality",
    Membership: 1, "1": "Membership",
    Incompatible: 2, "2": "Incompatible",
});

/**
 * Provenance payload for a Local SQLite-sourced table. `sqlite_table_name`
 * is empty when pre-v1.2.1 snapshots lack it (sync unavailable until
 * re-import). `source_sha256` is `None` pre-v1.2.2 (orphan-relink UI
 * falls back to a manual picker). JSON encodes the hash as 64-char
 * lowercase hex; Lance/proto keep it raw 32 bytes.
 */
export class LocalSqliteDatabase {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LocalSqliteDatabaseFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_localsqlitedatabase_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get column_mapping_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.localsqlitedatabase_column_mapping_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.localsqlitedatabase_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} connection_id
     * @param {string} column_mapping
     * @param {string} saved_connection_id
     * @param {string} sqlite_table_name
     * @param {string} source_sha256_hex
     */
    constructor(connection_id, column_mapping, saved_connection_id, sqlite_table_name, source_sha256_hex) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(connection_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_mapping, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(saved_connection_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(sqlite_table_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(source_sha256_hex, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            wasm.localsqlitedatabase_newjs(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            LocalSqliteDatabaseFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get saved_connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.localsqlitedatabase_saved_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get source_sha256_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.localsqlitedatabase_source_sha256_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get sqlite_table_name_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.localsqlitedatabase_sqlite_table_name_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) LocalSqliteDatabase.prototype[Symbol.dispose] = LocalSqliteDatabase.prototype.free;

/**
 * JS-facing lineage info for a LocalSqlite-imported table. The React
 * freshness check (v1.2.1) reads `saved_connection_id` to drive the
 * IDB lookup. `None` here means the snapshot pre-dates v1.2.1 and
 * the freshness check should be skipped (the Connections page
 * re-attach prompt handles those rows instead).
 */
export class LocalSqliteSourceInfoJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LocalSqliteSourceInfoJS.prototype);
        obj.__wbg_ptr = ptr;
        LocalSqliteSourceInfoJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LocalSqliteSourceInfoJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_localsqlitesourceinfojs_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get connection_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_provider(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get saved_connection_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_localsqlitesourceinfojs_saved_connection_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Lowercase-hex 64-char SHA-256 of the source file (v1.2.2+).
     * Empty for pre-v1.2.2 snapshots. The orphan-relink chip uses
     * this to suggest a re-added saved connection that carries the
     * same hash.
     * @returns {string}
     */
    get source_sha256_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_object_path(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Source SQLite table/view name (v1.2.1+). Empty string for
     * pre-v1.2.1 snapshots; the React Sync action treats empty as
     * "sync unavailable, re-import to enable."
     * @returns {string}
     */
    get sqlite_table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_bucketsourceinfojs_bucket(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} arg0
     */
    set connection_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_provider(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set saved_connection_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_localsqlitesourceinfojs_saved_connection_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Lowercase-hex 64-char SHA-256 of the source file (v1.2.2+).
     * Empty for pre-v1.2.2 snapshots. The orphan-relink chip uses
     * this to suggest a re-added saved connection that carries the
     * same hash.
     * @param {string} arg0
     */
    set source_sha256_hex(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_object_path(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Source SQLite table/view name (v1.2.1+). Empty string for
     * pre-v1.2.1 snapshots; the React Sync action treats empty as
     * "sync unavailable, re-import to enable."
     * @param {string} arg0
     */
    set sqlite_table_name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_bucketsourceinfojs_bucket(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) LocalSqliteSourceInfoJS.prototype[Symbol.dispose] = LocalSqliteSourceInfoJS.prototype.free;

/**
 * @enum {0 | 1}
 */
export const LogicalOperator = Object.freeze({
    And: 0, "0": "And",
    Or: 1, "1": "Or",
});

export class ModelActionsNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ModelActionsNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_modelactionsnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) ModelActionsNotification.prototype[Symbol.dispose] = ModelActionsNotification.prototype.free;

export class ModelDeletionAnalysis {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ModelDeletionAnalysis.prototype);
        obj.__wbg_ptr = ptr;
        ModelDeletionAnalysisFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ModelDeletionAnalysisFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_modeldeletionanalysis_free(ptr, 0);
    }
    /**
     * @param {any} value
     * @returns {ModelDeletionAnalysis}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.modeldeletionanalysis_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ModelDeletionAnalysis.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {TrashModel} trash_model
     * @returns {ModelDeletionAnalysis}
     */
    static from_trash_model(trash_model) {
        _assertClass(trash_model, TrashModel);
        const ret = wasm.modeldeletionanalysis_from_trash_model(trash_model.__wbg_ptr);
        return ModelDeletionAnalysis.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    get model_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.modeldeletionanalysis_model_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    get owned_models_js() {
        const ret = wasm.modeldeletionanalysis_owned_models_js(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {TableDeletionInfo[]}
     */
    get tables_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.modeldeletionanalysis_tables_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) ModelDeletionAnalysis.prototype[Symbol.dispose] = ModelDeletionAnalysis.prototype.free;

export class ModelDetails {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ModelDetails.prototype);
        obj.__wbg_ptr = ptr;
        ModelDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ModelDetailsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_modeldetails_free(ptr, 0);
    }
    /**
     * @returns {bigint}
     */
    get created_at() {
        const ret = wasm.__wbg_get_columnmodel_created_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_modeldetails_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get n_imported() {
        const ret = wasm.__wbg_get_modeldetails_n_imported(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get n_tables() {
        const ret = wasm.__wbg_get_modeldetails_n_tables(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_modeldetails_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {bigint} arg0
     */
    set created_at(arg0) {
        wasm.__wbg_set_columnmodel_created_at(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_modeldetails_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set n_imported(arg0) {
        wasm.__wbg_set_modeldetails_n_imported(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set n_tables(arg0) {
        wasm.__wbg_set_modeldetails_n_tables(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_modeldetails_name(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) ModelDetails.prototype[Symbol.dispose] = ModelDetails.prototype.free;

export class ModelID {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ModelIDFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_modelid_free(ptr, 0);
    }
}
if (Symbol.dispose) ModelID.prototype[Symbol.dispose] = ModelID.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3}
 */
export const ModelItemInstanceJS = Object.freeze({
    Table: 0, "0": "Table",
    TableView: 1, "1": "TableView",
    TableDiffView: 2, "2": "TableDiffView",
    ItemGroup: 3, "3": "ItemGroup",
});

/**
 * @enum {0 | 1 | 2}
 */
export const ModelItemNameEditJS = Object.freeze({
    TableView: 0, "0": "TableView",
    ModelItem: 1, "1": "ModelItem",
    Table: 2, "2": "Table",
});

export class ModelNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ModelNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_modelnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) ModelNotification.prototype[Symbol.dispose] = ModelNotification.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3}
 */
export const ModelRelation = Object.freeze({
    Owner: 0, "0": "Owner",
    Collaborator: 1, "1": "Collaborator",
    Viewer: 2, "2": "Viewer",
    Parent: 3, "3": "Parent",
});

export class Notification {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Notification.prototype);
        obj.__wbg_ptr = ptr;
        NotificationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_notification_free(ptr, 0);
    }
    /**
     * @returns {bigint}
     */
    created_at_js() {
        const ret = wasm.notification_created_at_js(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {any}
     */
    get_data_js() {
        const ret = wasm.notification_get_data_js(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {string} value
     * @returns {Notification[]}
     */
    static new_from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(value, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.notification_new_from_js(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    notification_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.notification_notification_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {NotificationTypeJS}
     */
    notification_type_js() {
        const ret = wasm.notification_notification_type_js(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {NotificationStatus}
     */
    status_js() {
        const ret = wasm.notification_status_js(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) Notification.prototype[Symbol.dispose] = Notification.prototype.free;

/**
 * Preferences for notifications for a user can be set by the user or by default.
 */
export class NotificationPreferences {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NotificationPreferences.prototype);
        obj.__wbg_ptr = ptr;
        NotificationPreferencesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NotificationPreferencesFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_notificationpreferences_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    get enabled() {
        const ret = wasm.__wbg_get_notificationpreferences_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get in_email_notification() {
        const ret = wasm.__wbg_get_notificationpreferences_in_email_notification(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} user_id
     * @param {boolean} in_email_notification
     * @param {boolean} enabled
     * @returns {NotificationPreferences}
     */
    static new_js(user_id, in_email_notification, enabled) {
        const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.notificationpreferences_new_js(ptr0, len0, in_email_notification, enabled);
        return NotificationPreferences.__wrap(ret);
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.notificationpreferences_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {string}
     */
    user_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.notificationpreferences_user_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {boolean} arg0
     */
    set enabled(arg0) {
        wasm.__wbg_set_notificationpreferences_enabled(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set in_email_notification(arg0) {
        wasm.__wbg_set_notificationpreferences_in_email_notification(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) NotificationPreferences.prototype[Symbol.dispose] = NotificationPreferences.prototype.free;

/**
 * @enum {0 | 1}
 */
export const NotificationStatus = Object.freeze({
    Pending: 0, "0": "Pending",
    Seen: 1, "1": "Seen",
});

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19}
 */
export const NotificationTypeJS = Object.freeze({
    TableShared: 0, "0": "TableShared",
    AccessRevokedFromTable: 1, "1": "AccessRevokedFromTable",
    TableOwnershipTransferRequest: 2, "2": "TableOwnershipTransferRequest",
    AccessRevokedFromModel: 3, "3": "AccessRevokedFromModel",
    ModelShared: 4, "4": "ModelShared",
    ModelDeleted: 5, "5": "ModelDeleted",
    TableRequest: 6, "6": "TableRequest",
    TableAccessResponse: 7, "7": "TableAccessResponse",
    TableOwnershipTransferResponse: 8, "8": "TableOwnershipTransferResponse",
    TableScheduledForDeletion: 9, "9": "TableScheduledForDeletion",
    OrgScheduledForDeletion: 10, "10": "OrgScheduledForDeletion",
    OrgOwnerGranted: 11, "11": "OrgOwnerGranted",
    OrgSoleOwner: 12, "12": "OrgSoleOwner",
    OrgBillingAttention: 13, "13": "OrgBillingAttention",
    OrgBillingPayerChanged: 14, "14": "OrgBillingPayerChanged",
    SpaceScheduledForDeletion: 15, "15": "SpaceScheduledForDeletion",
    SpaceManagerNeeded: 16, "16": "SpaceManagerNeeded",
    OrgInvite: 17, "17": "OrgInvite",
    OrgAccessRevoked: 18, "18": "OrgAccessRevoked",
    SpaceAccess: 19, "19": "SpaceAccess",
});

/**
 * The three org notices share a shape: who, which org, and — for a scheduled
 * deletion — when the work goes. `purge_at` is a unix timestamp the client
 * renders as a date; the server owns the real deadline.
 */
export class OrgActionNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OrgActionNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_orgactionnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) OrgActionNotification.prototype[Symbol.dispose] = OrgActionNotification.prototype.free;

export class OrgMembershipNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OrgMembershipNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_orgmembershipnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) OrgMembershipNotification.prototype[Symbol.dispose] = OrgMembershipNotification.prototype.free;

export class OrgNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OrgNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_orgnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) OrgNotification.prototype[Symbol.dispose] = OrgNotification.prototype.free;

/**
 * Direct relations on an `Organization` FGA object. The composed verbs
 * (`can_manage_members` / `can_manage_admins` / `can_delete` /
 * `can_manage_spaces`) are derived in the .fga model, never assigned
 * directly. Membership derives NO content access anywhere — an Organization
 * relation is governance only.
 * @enum {0 | 1 | 2}
 */
export const OrganizationRelation = Object.freeze({
    Owner: 0, "0": "Owner",
    OrgAdmin: 1, "1": "OrgAdmin",
    Member: 2, "2": "Member",
});

export class PersonalAccessToken {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PersonalAccessTokenFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_personalaccesstoken_free(ptr, 0);
    }
    /**
     * @returns {bigint}
     */
    get get_created_at() {
        const ret = wasm.personalaccesstoken_get_created_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get get_description() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.personalaccesstoken_get_description(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get get_expires_at() {
        const ret = wasm.personalaccesstoken_get_expires_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * The org the token is bound to; `None` for tokens predating org-gating.
     * @returns {string | undefined}
     */
    get get_org_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.personalaccesstoken_get_org_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get get_scope() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.personalaccesstoken_get_scope(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get get_status() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.personalaccesstoken_get_status(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get get_token_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.personalaccesstoken_get_token_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} id
     * @param {string} status
     * @param {bigint} expires_at
     * @param {string} scope
     * @param {string} description
     * @param {bigint} created_at
     * @param {string | null} [org_id]
     */
    constructor(id, status, expires_at, scope, description, created_at, org_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(status, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(scope, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(description, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            var ptr4 = isLikeNone(org_id) ? 0 : passStringToWasm0(org_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len4 = WASM_VECTOR_LEN;
            wasm.personalaccesstoken_new_js(retptr, ptr0, len0, ptr1, len1, expires_at, ptr2, len2, ptr3, len3, created_at, ptr4, len4);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            PersonalAccessTokenFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) PersonalAccessToken.prototype[Symbol.dispose] = PersonalAccessToken.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19}
 */
export const PhysicalKind = Object.freeze({
    U32: 0, "0": "U32",
    U64: 1, "1": "U64",
    I32: 2, "2": "I32",
    I64: 3, "3": "I64",
    F32: 4, "4": "F32",
    F64: 5, "5": "F64",
    Bool: 6, "6": "Bool",
    TimestampUTCSeconds: 7, "7": "TimestampUTCSeconds",
    String: 8, "8": "String",
    Json: 9, "9": "Json",
    Categorical: 10, "10": "Categorical",
    ListString: 11, "11": "ListString",
    Date: 12, "12": "Date",
    TimestampUTCMicroseconds: 13, "13": "TimestampUTCMicroseconds",
    TimestampUTCNanoseconds: 14, "14": "TimestampUTCNanoseconds",
    Uuid: 15, "15": "Uuid",
    Duration: 16, "16": "Duration",
    ND: 17, "17": "ND",
    /**
     * Exact decimal. Fieldless kind — precision/scale ride in `PhysicalParams`
     * (`ColumnMetadata`); the Arrow type is `Decimal128(p,s)`, derived via
     * `Column::physical_type()`, NOT `From<&PhysicalKind>` alone. Appended last so
     * existing discriminants (incl. `ND` = 17) are unchanged.
     */
    Decimal: 18, "18": "Decimal",
    /**
     * Files on a row: a `List<Utf8>` of JSON descriptors (`docs/Attachments.md`). Same Arrow type
     * as `ListString`, distinguished by the column kind — the `Json`/`Uuid` pattern.
     */
    Attachment: 19, "19": "Attachment",
});

export class PostgresDatabase {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PostgresDatabaseFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_postgresdatabase_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get column_mapping_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_column_mapping_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} connection_id
     * @param {string} column_mapping
     * @param {string} saved_connection_id_str
     * @param {string} schema_name
     * @param {string} table_name
     */
    constructor(connection_id, column_mapping, saved_connection_id_str, schema_name, table_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(connection_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_mapping, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(saved_connection_id_str, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(schema_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(table_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            wasm.googlesheet_newjs(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            PostgresDatabaseFinalization.register(this, this.__wbg_ptr, this);
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get saved_connection_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_saved_connection_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get schema_name_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_spreadsheet_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_name_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.googlesheet_sheet_name_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) PostgresDatabase.prototype[Symbol.dispose] = PostgresDatabase.prototype.free;

/**
 * Selects which postgres-protocol source variant the React client wants
 * when importing or syncing. The Rust side never derives this from the
 * saved connection — it's an explicit parameter so callers (which know
 * the user's `SavedConnection.connection_type`) make the choice.
 * @enum {0 | 1}
 */
export const PostgresKindJS = Object.freeze({
    Postgres: 0, "0": "Postgres",
    Supabase: 1, "1": "Supabase",
});

export class RemoveCheckpointAlias {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RemoveCheckpointAlias.prototype);
        obj.__wbg_ptr = ptr;
        RemoveCheckpointAliasFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RemoveCheckpointAliasFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_removecheckpointalias_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    checkpoint_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_checkpoint_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} checkpoint_id
     * @param {string} alias
     * @returns {RemoveCheckpointAlias}
     */
    static new_js(table_id, checkpoint_id, alias) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.addcheckpointalias_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RemoveCheckpointAlias.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    table_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_table_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.removecheckpointalias_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) RemoveCheckpointAlias.prototype[Symbol.dispose] = RemoveCheckpointAlias.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4}
 */
export const RequestStatus = Object.freeze({
    Pending: 0, "0": "Pending",
    Accepted: 1, "1": "Accepted",
    Rejected: 2, "2": "Rejected",
    Cancelled: 3, "3": "Cancelled",
    Deleted: 4, "4": "Deleted",
});

/**
 * Enumeration of different types of permissions for different resources (Model or Table).
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15}
 */
export const ResourcePermission = Object.freeze({
    CanView: 0, "0": "CanView",
    CanEdit: 1, "1": "CanEdit",
    CanShare: 2, "2": "CanShare",
    CanManageAccess: 3, "3": "CanManageAccess",
    CanDelete: 4, "4": "CanDelete",
    CanImport: 5, "5": "CanImport",
    CanConditionallyImport: 6, "6": "CanConditionallyImport",
    CanHardDelete: 7, "7": "CanHardDelete",
    CanShareWithReshare: 8, "8": "CanShareWithReshare",
    CanSeeSharedWithList: 9, "9": "CanSeeSharedWithList",
    CanRevokeTableAccess: 10, "10": "CanRevokeTableAccess",
    /**
     * Broad "this table should appear somewhere in the user's UI"
     * visibility relation. Unions direct view, direct shares, parent-model
     * view, and importer-model collaborator view (`can_view from
     * imported_in_model`). Used by every read path that needs the
     * caller's encounterable-tables scope: link list filters, link audit,
     * the per-user access cache, and (planned) MCP `search`. Mutation
     * gates use `CanImport`, not this.
     */
    CanDiscover: 11, "11": "CanDiscover",
    /**
     * The strict twin of `CanDiscover` for VALUES: identical in every arm
     * except imports, where it reaches through `reshared_in_model` — an
     * import made without the right to pass the table on grants presence
     * (schema, links) but not cells. Every door that serves cell data gates
     * on this; listings and schema stay on `CanDiscover`.
     */
    CanReadValues: 12, "12": "CanReadValues",
    /**
     * Cross-user table ownership transfer. The composed FGA rule
     * `can_transfer = owner from parent and can_propagate from
     * parent_connection` parent-locks connector tables: they fail
     * because their parent_connection points at `Connection:{sconn_id}`
     * or `Connection:orphan`, neither of which has `can_propagate`
     * tuples (only the wildcard `Connection:mycorr` does).
     */
    CanTransfer: 13, "13": "CanTransfer",
    /**
     * Create a checkpoint on a specific version of a table. Composed
     * FGA rule: `can_checkpoint = can_edit and can_propagate from
     * parent_connection`. Requires edit access on the parent model
     * AND an Owned-source table — the next connector sync would
     * invalidate any tag at a prior version, so connector tables are
     * structurally locked.
     */
    CanCheckpoint: 14, "14": "CanCheckpoint",
    /**
     * Whether a TABLE's data may propagate at all — `can_propagate from
     * parent_connection`, with no identity half. True for ordinary MyCorr
     * tables, false for connector- and orphan-anchored ones, and the same
     * answer for every subject. The share door's release gate asks it
     * because "can this be released" is a fact about the table, while
     * `CanCheckpoint` is a fact about a person.
     */
    CanPropagate: 15, "15": "CanPropagate",
});

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5}
 */
export const ResponseMessage = Object.freeze({
    Unauthorized: 0, "0": "Unauthorized",
    StorageProfileExists: 1, "1": "StorageProfileExists",
    StorageProfileCreated: 2, "2": "StorageProfileCreated",
    StorageProfileNotFound: 3, "3": "StorageProfileNotFound",
    StorageProfileError: 4, "4": "StorageProfileError",
    QuotaUpdated: 5, "5": "QuotaUpdated",
});

/**
 * @enum {0 | 1}
 */
export const ResponseStatus = Object.freeze({
    Success: 0, "0": "Success",
    Fail: 1, "1": "Fail",
});

export class RevokeAccessRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RevokeAccessRequest.prototype);
        obj.__wbg_ptr = ptr;
        RevokeAccessRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RevokeAccessRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_revokeaccessrequest_free(ptr, 0);
    }
    /**
     * @param {string} users_or_teams
     * @param {string} element_id
     * @param {string} old_access_level
     * @param {string} element_name
     * @returns {RevokeAccessRequest}
     */
    static new_js(users_or_teams, element_id, old_access_level, element_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(users_or_teams, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(element_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(old_access_level, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(element_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            wasm.revokeaccessrequest_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RevokeAccessRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.revokeaccessrequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) RevokeAccessRequest.prototype[Symbol.dispose] = RevokeAccessRequest.prototype.free;

/**
 * Layer A — the user-facing SEMANTIC catalog: a friendly label over the physical
 * [`PhysicalKind`]. Fieldless (wasm/proto-friendly); the only type users pick.
 * Derived from the physical kind via [`data_type_semantic`] — currently a pure
 * projection, not stored state. `Number` and `Text` are first-class; the rest
 * are 1:1 labels for now.
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11}
 */
export const SemanticType = Object.freeze({
    Number: 0, "0": "Number",
    Text: 1, "1": "Text",
    Boolean: 2, "2": "Boolean",
    DateTime: 3, "3": "DateTime",
    Date: 4, "4": "Date",
    Duration: 5, "5": "Duration",
    Select: 6, "6": "Select",
    List: 7, "7": "List",
    Json: 8, "8": "Json",
    Uuid: 9, "9": "Uuid",
    Empty: 10, "10": "Empty",
    /**
     * Appended after `Empty` so discriminants 0–10 stay pinned.
     */
    Attachment: 11, "11": "Attachment",
});

export class SendInEmailDetails {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SendInEmailDetailsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sendinemaildetails_free(ptr, 0);
    }
}
if (Symbol.dispose) SendInEmailDetails.prototype[Symbol.dispose] = SendInEmailDetails.prototype.free;

export class SetCheckpointAliasAsDefault {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SetCheckpointAliasAsDefault.prototype);
        obj.__wbg_ptr = ptr;
        SetCheckpointAliasAsDefaultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SetCheckpointAliasAsDefaultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_setcheckpointaliasasdefault_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    checkpoint_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_checkpoint_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} table_id
     * @param {string} checkpoint_id
     * @param {string} alias
     * @returns {SetCheckpointAliasAsDefault}
     */
    static new_js(table_id, checkpoint_id, alias) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(checkpoint_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(alias, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.addcheckpointalias_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SetCheckpointAliasAsDefault.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    table_id_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addcheckpointalias_table_id_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.setcheckpointaliasasdefault_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) SetCheckpointAliasAsDefault.prototype[Symbol.dispose] = SetCheckpointAliasAsDefault.prototype.free;

export class SetTableReleaseRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SetTableReleaseRequest.prototype);
        obj.__wbg_ptr = ptr;
        SetTableReleaseRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SetTableReleaseRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_settablereleaserequest_free(ptr, 0);
    }
    /**
     * @param {string} table_id
     * @param {bigint} table_version
     * @param {string} released_by
     * @returns {SetTableReleaseRequest}
     */
    static new_js(table_id, table_version, released_by) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(released_by, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.settablereleaserequest_new_js(retptr, ptr0, len0, table_version, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SetTableReleaseRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.settablereleaserequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) SetTableReleaseRequest.prototype[Symbol.dispose] = SetTableReleaseRequest.prototype.free;

export class ShareModelRequest {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ShareModelRequest.prototype);
        obj.__wbg_ptr = ptr;
        ShareModelRequestFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ShareModelRequestFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sharemodelrequest_free(ptr, 0);
    }
    /**
     * @param {string[]} user_or_group
     * @param {string} access_level
     * @param {string} model_id
     * @param {string} inviter_name
     * @param {string} model_name
     * @param {string} inviter_email
     * @returns {ShareModelRequest}
     */
    static new_js(user_or_group, access_level, model_id, inviter_name, model_name, inviter_email) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(user_or_group, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(access_level, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(model_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(inviter_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(model_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            const ptr5 = passStringToWasm0(inviter_email, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len5 = WASM_VECTOR_LEN;
            wasm.sharemodelrequest_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ShareModelRequest.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.sharemodelrequest_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) ShareModelRequest.prototype[Symbol.dispose] = ShareModelRequest.prototype.free;

export class SharedAccess {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SharedAccess.prototype);
        obj.__wbg_ptr = ptr;
        SharedAccessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SharedAccessFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sharedaccess_free(ptr, 0);
    }
    /**
     * @param {any} value
     * @returns {SharedAccess}
     */
    add_users_js(value) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sharedaccess_add_users_js(retptr, ptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SharedAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {any} value
     * @returns {SharedAccess}
     */
    extend_js(value) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sharedaccess_extend_js(retptr, ptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SharedAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {any} value
     * @returns {SharedAccess}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sharedaccess_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SharedAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} email
     * @returns {SharedAccess}
     */
    remove_user_by_email(email) {
        const ptr0 = passStringToWasm0(email, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.sharedaccess_remove_user_by_email(this.__wbg_ptr, ptr0, len0);
        return SharedAccess.__wrap(ret);
    }
    /**
     * @param {any} value
     * @returns {SharedAccess}
     */
    replace_users_js(value) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sharedaccess_replace_users_js(retptr, ptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SharedAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} email
     * @param {string} new_role
     * @returns {SharedAccess}
     */
    update_user_role_by_email(email, new_role) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(email, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(new_role, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.sharedaccess_update_user_role_by_email(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SharedAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {UserAccess[]}
     */
    users() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sharedaccess_users(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) SharedAccess.prototype[Symbol.dispose] = SharedAccess.prototype.free;

/**
 * One space-access change, as the recipient's bell carries it. `change` is
 * what happened (`granted` / `revoked` / `deleted` / `reclassified`); `role`
 * and `classification` are empty on the changes they do not describe.
 */
export class SpaceAccessNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SpaceAccessNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_spaceaccessnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) SpaceAccessNotification.prototype[Symbol.dispose] = SpaceAccessNotification.prototype.free;

/**
 * The space pair mirrors the org pair one level down: who, which space in
 * which org, and — for a scheduled deletion — when the work goes. The org is
 * carried so the notice can say where the space lives after the row is gone.
 */
export class SpaceActionNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SpaceActionNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_spaceactionnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) SpaceActionNotification.prototype[Symbol.dispose] = SpaceActionNotification.prototype.free;

export class StorageResponse {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StorageResponseFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_storageresponse_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    get message() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.storageresponse_message(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} data
     */
    constructor(data) {
        const ptr0 = passStringToWasm0(data, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.storageresponse_new_js(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        StorageResponseFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {ResponseStatus}
     */
    get status() {
        const ret = wasm.storageresponse_status(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) StorageResponse.prototype[Symbol.dispose] = StorageResponse.prototype.free;

/**
 * @enum {0 | 1 | 2}
 */
export const StorageUpdateMode = Object.freeze({
    Increment: 0, "0": "Increment",
    Decrement: 1, "1": "Decrement",
    Reconcile: 2, "2": "Reconcile",
});

export class StreamedDataResponseHeader {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StreamedDataResponseHeader.prototype);
        obj.__wbg_ptr = ptr;
        StreamedDataResponseHeaderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StreamedDataResponseHeaderFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_streameddataresponseheader_free(ptr, 0);
    }
    /**
     * @param {any} value
     * @returns {StreamedDataResponseHeader}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.streameddataresponseheader_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StreamedDataResponseHeader.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
}
if (Symbol.dispose) StreamedDataResponseHeader.prototype[Symbol.dispose] = StreamedDataResponseHeader.prototype.free;

/**
 * @enum {0 | 1}
 */
export const SubscriptionTier = Object.freeze({
    Free: 0, "0": "Free",
    Premium: 1, "1": "Premium",
});

/**
 * Server-computed per-(table, user) booleans that gate React UI. Lets the
 * client drop its `isTableLockedToParent(source)` and
 * `source === TableSourceJS.X` checks — every outbound affordance reads
 * from the matching boolean here. Hydrated by
 * `common_api_helpers::hydrate_table_affordances` from FGA's composed
 * `can_share` / `can_import` / `can_transfer` / `can_checkpoint` /
 * `can_revoke_access` permissions. `can_import` and `can_transfer` are
 * gated by `can_propagate from parent_connection`, which closes the
 * parent-lock invariant structurally — only `Connection:mycorr` has the
 * wildcard `can_propagate@user:*` tuple.
 *
 * All booleans default to `false` — a fresh `TableAffordances::denied()`
 * is safe to use as a placeholder when hydration is skipped or fails;
 * React renders disabled affordances.
 */
export class TableAffordances {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableAffordances.prototype);
        obj.__wbg_ptr = ptr;
        TableAffordancesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableAffordancesFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableaffordances_free(ptr, 0);
    }
    /**
     * `can_checkpoint` — FGA `can_edit`. Any editor, connector tables
     * included: a sync commits a delta over stable `_row_id`s, so a tag at
     * a prior version survives it.
     * @returns {boolean}
     */
    get can_checkpoint() {
        const ret = wasm.__wbg_get_tableaffordances_can_checkpoint(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `can_import` — composed FGA rule `shared_for_import and
     * can_propagate from parent_connection`. Cross-model import.
     * @returns {boolean}
     */
    get can_import() {
        const ret = wasm.__wbg_get_tableaffordances_can_import(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `can_revoke_access` — FGA `can_revoke_access` (which is just
     * `owner from parent`, intentionally NOT gated by
     * parent_connection so revocation continues to work after a
     * connection is deleted).
     * @returns {boolean}
     */
    get can_revoke_access() {
        const ret = wasm.__wbg_get_tableaffordances_can_revoke_access(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `can_share` — FGA rule `owner from parent or shared_with_reshare`.
     * Intentionally NOT gated
     * on `can_propagate from parent_connection`: sharing a connector
     * table grants the recipient discovery (table appears in MCP search
     * and shared-with-me lists) but not data view, which still requires
     * either model access or a completed import — and `can_import` is
     * the gated rule, so propagation stays blocked.
     * @returns {boolean}
     */
    get can_share() {
        const ret = wasm.__wbg_get_tableaffordances_can_share(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `can_transfer` — FGA `owner from parent` cut by the wall. Gates the
     * Move action; the destination picker narrows WHERE (a connector table
     * stays inside its connection's org, D24).
     * @returns {boolean}
     */
    get can_transfer() {
        const ret = wasm.__wbg_get_tableaffordances_can_transfer(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * FGA `Table#in_walled_space` (D27): the reason the propagation
     * affordances above are false. An attribute, not a capability — the UI
     * shows the sealed tooltip instead of the connector parent-lock one.
     * `default` so a payload from a pre-D27 server still decodes.
     * @returns {boolean}
     */
    get sealed() {
        const ret = wasm.__wbg_get_tableaffordances_sealed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `can_checkpoint` — FGA `can_edit`. Any editor, connector tables
     * included: a sync commits a delta over stable `_row_id`s, so a tag at
     * a prior version survives it.
     * @param {boolean} arg0
     */
    set can_checkpoint(arg0) {
        wasm.__wbg_set_tableaffordances_can_checkpoint(this.__wbg_ptr, arg0);
    }
    /**
     * `can_import` — composed FGA rule `shared_for_import and
     * can_propagate from parent_connection`. Cross-model import.
     * @param {boolean} arg0
     */
    set can_import(arg0) {
        wasm.__wbg_set_tableaffordances_can_import(this.__wbg_ptr, arg0);
    }
    /**
     * `can_revoke_access` — FGA `can_revoke_access` (which is just
     * `owner from parent`, intentionally NOT gated by
     * parent_connection so revocation continues to work after a
     * connection is deleted).
     * @param {boolean} arg0
     */
    set can_revoke_access(arg0) {
        wasm.__wbg_set_tableaffordances_can_revoke_access(this.__wbg_ptr, arg0);
    }
    /**
     * `can_share` — FGA rule `owner from parent or shared_with_reshare`.
     * Intentionally NOT gated
     * on `can_propagate from parent_connection`: sharing a connector
     * table grants the recipient discovery (table appears in MCP search
     * and shared-with-me lists) but not data view, which still requires
     * either model access or a completed import — and `can_import` is
     * the gated rule, so propagation stays blocked.
     * @param {boolean} arg0
     */
    set can_share(arg0) {
        wasm.__wbg_set_tableaffordances_can_share(this.__wbg_ptr, arg0);
    }
    /**
     * `can_transfer` — FGA `owner from parent` cut by the wall. Gates the
     * Move action; the destination picker narrows WHERE (a connector table
     * stays inside its connection's org, D24).
     * @param {boolean} arg0
     */
    set can_transfer(arg0) {
        wasm.__wbg_set_tableaffordances_can_transfer(this.__wbg_ptr, arg0);
    }
    /**
     * FGA `Table#in_walled_space` (D27): the reason the propagation
     * affordances above are false. An attribute, not a capability — the UI
     * shows the sealed tooltip instead of the connector parent-lock one.
     * `default` so a payload from a pre-D27 server still decodes.
     * @param {boolean} arg0
     */
    set sealed(arg0) {
        wasm.__wbg_set_tableaffordances_sealed(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) TableAffordances.prototype[Symbol.dispose] = TableAffordances.prototype.free;

export class TableColumnMetadataJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableColumnMetadataJS.prototype);
        obj.__wbg_ptr = ptr;
        TableColumnMetadataJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    static __unwrap(jsValue) {
        if (!(jsValue instanceof TableColumnMetadataJS)) {
            return 0;
        }
        return jsValue.__destroy_into_raw();
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableColumnMetadataJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablecolumnmetadatajs_free(ptr, 0);
    }
    /**
     * @returns {PhysicalKind}
     */
    get dataType() {
        const ret = wasm.tablecolumnmetadatajs_dataType(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablecolumnmetadatajs_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablecolumnmetadatajs_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} name
     * @param {string} id
     * @param {PhysicalKind} data_type
     */
    constructor(name, id, data_type) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.tablecolumnmetadatajs_new(ptr0, len0, ptr1, len1, data_type);
        this.__wbg_ptr = ret >>> 0;
        TableColumnMetadataJSFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) TableColumnMetadataJS.prototype[Symbol.dispose] = TableColumnMetadataJS.prototype.free;

/**
 * One endpoint of a [`TableLink`] — a table plus the ordered list of columns
 * that participate in the join key on this side.
 *
 * `column_ids` holds 1..N columns. A single-column link is the degenerate
 * `len() == 1` case. Pairing across the two endpoints is positional and lives
 * on `TableLink::pairs()` — **never index `column_ids` directly against the
 * other side**; the equal-length invariant is enforced only at construction
 * of the link, not here.
 */
export class TableColumnRef {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableColumnRef.prototype);
        obj.__wbg_ptr = ptr;
        TableColumnRefFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableColumnRefFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablecolumnref_free(ptr, 0);
    }
    /**
     * @param {string} table_id
     * @param {string} column_id
     * @returns {TableColumnRef}
     */
    static new_js(table_id, column_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(column_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.tablecolumnref_new_js(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableColumnRef.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) TableColumnRef.prototype[Symbol.dispose] = TableColumnRef.prototype.free;

/**
 * A table's live and soft-deleted columns — plain JS arrays, serialized once.
 */
export class TableColumns {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableColumns.prototype);
        obj.__wbg_ptr = ptr;
        TableColumnsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableColumnsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablecolumns_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    get deleted_columns() {
        const ret = wasm.__wbg_get_tablecolumns_deleted_columns(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {any}
     */
    get table_columns() {
        const ret = wasm.__wbg_get_tablecolumns_table_columns(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {any} arg0
     */
    set deleted_columns(arg0) {
        wasm.__wbg_set_tablecolumns_deleted_columns(this.__wbg_ptr, addHeapObject(arg0));
    }
    /**
     * @param {any} arg0
     */
    set table_columns(arg0) {
        wasm.__wbg_set_tablecolumns_table_columns(this.__wbg_ptr, addHeapObject(arg0));
    }
}
if (Symbol.dispose) TableColumns.prototype[Symbol.dispose] = TableColumns.prototype.free;

export class TableDeletionInfo {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableDeletionInfo.prototype);
        obj.__wbg_ptr = ptr;
        TableDeletionInfoFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableDeletionInfoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tabledeletioninfo_free(ptr, 0);
    }
    /**
     * `{ named: [{ id, name, is_public }], private_count }`.
     * @returns {any}
     */
    get dataset_usage_js() {
        const ret = wasm.tabledeletioninfo_dataset_usage_js(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {number}
     */
    get external_link_count_js() {
        const ret = wasm.tabledeletioninfo_external_link_count_js(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {any} value
     * @returns {TableDeletionInfo}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tabledeletioninfo_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableDeletionInfo.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @returns {string}
     */
    get table_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tabledeletioninfo_table_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tabledeletioninfo_table_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {TableUsageStatus}
     */
    get usage_status_js() {
        const ret = wasm.tabledeletioninfo_usage_status_js(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) TableDeletionInfo.prototype[Symbol.dispose] = TableDeletionInfo.prototype.free;

/**
 * @enum {0 | 1}
 */
export const TableDeletionType = Object.freeze({
    SoftDeleted: 0, "0": "SoftDeleted",
    ScheduledHardDeletion: 1, "1": "ScheduledHardDeletion",
});

/**
 * A struct that is used to hold general information about a table, that can be shown in the frontend
 */
export class TableDetails {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableDetails.prototype);
        obj.__wbg_ptr = ptr;
        TableDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableDetailsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tabledetails_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get active_rows() {
        const ret = wasm.__wbg_get_tabledetails_active_rows(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Live columns; the columns themselves are `ClientApp::get_table_columns`.
     * @returns {number}
     */
    get column_count() {
        const ret = wasm.__wbg_get_tabledetails_column_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string | undefined}
     */
    get connection_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_columnmodel_duration_display_unit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {bigint}
     */
    get created_at() {
        const ret = wasm.__wbg_get_tabledetails_created_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get created_by() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_created_by(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint | undefined}
     */
    get current_is_restored() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_current_is_restored(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * When this table will be permanently deleted (Unix timestamp in seconds)
     * Only set for tables in trash
     * @returns {bigint | undefined}
     */
    get expires_at() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_expires_at(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {boolean}
     */
    get has_active_commit() {
        const ret = wasm.__wbg_get_tabledetails_has_active_commit(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get hint_outdated() {
        const ret = wasm.__wbg_get_tabledetails_hint_outdated(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * One unnamed, untyped column and no rows: the table a new one starts as.
     * @returns {boolean}
     */
    get is_blank() {
        const ret = wasm.__wbg_get_tabledetails_is_blank(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_deleted() {
        const ret = wasm.__wbg_get_tabledetails_is_deleted(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    get is_empty() {
        const ret = wasm.__wbg_get_tabledetails_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    get item_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_item_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get n_views() {
        const ret = wasm.__wbg_get_tabledetails_n_views(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {bigint | undefined}
     */
    get parent_version() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_parent_version(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {TableSourceJS}
     */
    get source() {
        const ret = wasm.__wbg_get_tabledetails_source(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get table_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_table_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tabledetails_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get version() {
        const ret = wasm.__wbg_get_tabledetails_version(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @param {number} arg0
     */
    set active_rows(arg0) {
        wasm.__wbg_set_tabledetails_active_rows(this.__wbg_ptr, arg0);
    }
    /**
     * Live columns; the columns themselves are `ClientApp::get_table_columns`.
     * @param {number} arg0
     */
    set column_count(arg0) {
        wasm.__wbg_set_tabledetails_column_count(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set connection_id(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_columnmodel_duration_display_unit(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set created_at(arg0) {
        wasm.__wbg_set_tabledetails_created_at(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set created_by(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tabledetails_created_by(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint | null} [arg0]
     */
    set current_is_restored(arg0) {
        wasm.__wbg_set_tabledetails_current_is_restored(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
     * When this table will be permanently deleted (Unix timestamp in seconds)
     * Only set for tables in trash
     * @param {bigint | null} [arg0]
     */
    set expires_at(arg0) {
        wasm.__wbg_set_tabledetails_expires_at(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set has_active_commit(arg0) {
        wasm.__wbg_set_tabledetails_has_active_commit(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set hint_outdated(arg0) {
        wasm.__wbg_set_tabledetails_hint_outdated(this.__wbg_ptr, arg0);
    }
    /**
     * One unnamed, untyped column and no rows: the table a new one starts as.
     * @param {boolean} arg0
     */
    set is_blank(arg0) {
        wasm.__wbg_set_tabledetails_is_blank(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_deleted(arg0) {
        wasm.__wbg_set_tabledetails_is_deleted(this.__wbg_ptr, arg0);
    }
    /**
     * @param {boolean} arg0
     */
    set is_empty(arg0) {
        wasm.__wbg_set_tabledetails_is_empty(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set item_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tabledetails_item_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set n_views(arg0) {
        wasm.__wbg_set_tabledetails_n_views(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint | null} [arg0]
     */
    set parent_version(arg0) {
        wasm.__wbg_set_tabledetails_parent_version(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
     * @param {TableSourceJS} arg0
     */
    set source(arg0) {
        wasm.__wbg_set_tabledetails_source(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set table_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tabledetails_table_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set table_name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tabledetails_table_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set version(arg0) {
        wasm.__wbg_set_tabledetails_version(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) TableDetails.prototype[Symbol.dispose] = TableDetails.prototype.free;

export class TableDiffViewDetails {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableDiffViewDetails.prototype);
        obj.__wbg_ptr = ptr;
        TableDiffViewDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableDiffViewDetailsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablediffviewdetails_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get added_count() {
        const ret = wasm.__wbg_get_tablediffviewdetails_added_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get checkpoint_name_a() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_checkpoint_name_a(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get checkpoint_name_b() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_checkpoint_name_b(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get column_count() {
        const ret = wasm.__wbg_get_tablediffviewdetails_column_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {bigint}
     */
    get created_at() {
        const ret = wasm.__wbg_get_columnmodel_created_at(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get deleted_count() {
        const ret = wasm.__wbg_get_tablediffviewdetails_deleted_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get modified_count() {
        const ret = wasm.__wbg_get_tablediffviewdetails_modified_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get schema_added_columns() {
        const ret = wasm.__wbg_get_tablediffviewdetails_schema_added_columns(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * JSON-serialized SchemaDiff with full column names
     * @returns {string}
     */
    get schema_changes_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_schema_changes_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get schema_modified_columns() {
        const ret = wasm.__wbg_get_tablediffviewdetails_schema_modified_columns(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get schema_removed_columns() {
        const ret = wasm.__wbg_get_tablediffviewdetails_schema_removed_columns(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get source_table_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_source_table_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get source_table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_source_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    get total_changes() {
        const ret = wasm.__wbg_get_tablediffviewdetails_total_changes(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get version_a_label() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_version_a_label(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get version_a() {
        const ret = wasm.__wbg_get_tablediffviewdetails_version_a(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    get version_b_label() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablediffviewdetails_version_b_label(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get version_b() {
        const ret = wasm.__wbg_get_tablediffviewdetails_version_b(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {bigint}
     */
    get version_timestamp_a() {
        const ret = wasm.__wbg_get_tablediffviewdetails_version_timestamp_a(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {bigint}
     */
    get version_timestamp_b() {
        const ret = wasm.__wbg_get_tablediffviewdetails_version_timestamp_b(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set added_count(arg0) {
        wasm.__wbg_set_tablediffviewdetails_added_count(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set checkpoint_name_a(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_checkpoint_name_a(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set checkpoint_name_b(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_checkpoint_name_b(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set column_count(arg0) {
        wasm.__wbg_set_tablediffviewdetails_column_count(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set created_at(arg0) {
        wasm.__wbg_set_columnmodel_created_at(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set deleted_count(arg0) {
        wasm.__wbg_set_tablediffviewdetails_deleted_count(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set modified_count(arg0) {
        wasm.__wbg_set_tablediffviewdetails_modified_count(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set schema_added_columns(arg0) {
        wasm.__wbg_set_tablediffviewdetails_schema_added_columns(this.__wbg_ptr, arg0);
    }
    /**
     * JSON-serialized SchemaDiff with full column names
     * @param {string} arg0
     */
    set schema_changes_json(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_schema_changes_json(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set schema_modified_columns(arg0) {
        wasm.__wbg_set_tablediffviewdetails_schema_modified_columns(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set schema_removed_columns(arg0) {
        wasm.__wbg_set_tablediffviewdetails_schema_removed_columns(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set source_table_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_source_table_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set source_table_name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_source_table_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number} arg0
     */
    set total_changes(arg0) {
        wasm.__wbg_set_tablediffviewdetails_total_changes(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set version_a_label(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_version_a_label(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set version_a(arg0) {
        wasm.__wbg_set_columnmodel_last_modified(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set version_b_label(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablediffviewdetails_version_b_label(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set version_b(arg0) {
        wasm.__wbg_set_tablediffviewdetails_version_b(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set version_timestamp_a(arg0) {
        wasm.__wbg_set_tablediffviewdetails_version_timestamp_a(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set version_timestamp_b(arg0) {
        wasm.__wbg_set_tablediffviewdetails_version_timestamp_b(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) TableDiffViewDetails.prototype[Symbol.dispose] = TableDiffViewDetails.prototype.free;

export class TableInfo {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableInfoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableinfo_free(ptr, 0);
    }
    /**
     * Server-computed per-user affordance booleans. Always populated by
     * `common_api_helpers::hydrate_table_affordances` (or
     * `TableAffordances::denied()` if the user has no permissions). React
     * reads these instead of doing client-side
     * `isTableLockedToParent(source)` checks on the WASM-exported
     * `TableSource`.
     * @returns {TableAffordances}
     */
    get affordances() {
        const ret = wasm.__wbg_get_tableinfo_affordances(this.__wbg_ptr);
        return TableAffordances.__wrap(ret);
    }
    /**
     * @returns {boolean}
     */
    get conditional_import() {
        const ret = wasm.__wbg_get_tableinfo_conditional_import(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `true` when the table has a released checkpoint set. Table-level
     * state (not a per-user affordance), so it lives here next to
     * `latest_version` rather than in `TableAffordances`. The client
     * combines it with `affordances.can_import` to pick the import mode:
     * `can_import && has_release` → direct import;
     * `can_import && !has_release` → pending-release import (the import is
     * recorded and materializes on the source's first release);
     * `!can_import && conditional_import` → request-to-owner (unchanged).
     * @returns {boolean}
     */
    get has_release() {
        const ret = wasm.__wbg_get_tableinfo_has_release(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {bigint}
     */
    get latest_version() {
        const ret = wasm.__wbg_get_tableinfo_latest_version(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    get model_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableinfo_model_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableinfo_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableinfo_table_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Server-computed per-user affordance booleans. Always populated by
     * `common_api_helpers::hydrate_table_affordances` (or
     * `TableAffordances::denied()` if the user has no permissions). React
     * reads these instead of doing client-side
     * `isTableLockedToParent(source)` checks on the WASM-exported
     * `TableSource`.
     * @param {TableAffordances} arg0
     */
    set affordances(arg0) {
        _assertClass(arg0, TableAffordances);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_tableinfo_affordances(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {boolean} arg0
     */
    set conditional_import(arg0) {
        wasm.__wbg_set_tableinfo_conditional_import(this.__wbg_ptr, arg0);
    }
    /**
     * `true` when the table has a released checkpoint set. Table-level
     * state (not a per-user affordance), so it lives here next to
     * `latest_version` rather than in `TableAffordances`. The client
     * combines it with `affordances.can_import` to pick the import mode:
     * `can_import && has_release` → direct import;
     * `can_import && !has_release` → pending-release import (the import is
     * recorded and materializes on the source's first release);
     * `!can_import && conditional_import` → request-to-owner (unchanged).
     * @param {boolean} arg0
     */
    set has_release(arg0) {
        wasm.__wbg_set_tableinfo_has_release(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set latest_version(arg0) {
        wasm.__wbg_set_tableinfo_latest_version(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set model_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableinfo_model_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableinfo_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set table_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableinfo_table_id(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) TableInfo.prototype[Symbol.dispose] = TableInfo.prototype.free;

export class TableLink {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableLink.prototype);
        obj.__wbg_ptr = ptr;
        TableLinkFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableLinkFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablelink_free(ptr, 0);
    }
}
if (Symbol.dispose) TableLink.prototype[Symbol.dispose] = TableLink.prototype.free;

export class TableLinkJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableLinkJS.prototype);
        obj.__wbg_ptr = ptr;
        TableLinkJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableLinkJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablelinkjs_free(ptr, 0);
    }
    /**
     * @param {string} source_table_id
     * @returns {TableLinkJS}
     */
    directed_from(source_table_id) {
        const ptr0 = passStringToWasm0(source_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.tablelinkjs_directed_from(this.__wbg_ptr, ptr0, len0);
        return TableLinkJS.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    get first_column_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_column_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * All column ids on the first endpoint, in pair order.
     * @returns {string[]}
     */
    get first_column_ids_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_column_ids_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Primary (first) column display name. Single-column convenience —
     * composite-aware UI should use `first_column_names_js`.
     * @returns {string}
     */
    get first_column_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_column_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * All column display names on the first endpoint, in pair order.
     * @returns {string[]}
     */
    get first_column_names_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_column_names_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get first_join_part_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_join_part_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get first_table_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_table_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get first_table_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_first_table_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} source_table_id
     * @param {number} target_alias
     * @returns {LinkDisplayJS}
     */
    format_display(source_table_id, target_alias) {
        const ptr0 = passStringToWasm0(source_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.tablelinkjs_format_display(this.__wbg_ptr, ptr0, len0, target_alias);
        return LinkDisplayJS.__wrap(ret);
    }
    /**
     * @param {any} value
     * @returns {TableLinkJS}
     */
    static from_js_value(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_from_js_value(retptr, addHeapObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableLinkJS.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} source_table_id
     * @returns {string}
     */
    get_target_table_id(source_table_id) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(source_table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.tablelinkjs_get_target_table_id(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred2_0 = r0;
            deferred2_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get made_by_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_made_by_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Number of column pairs in this link (1 for a single-column link).
     * @returns {number}
     */
    get pair_count_js() {
        const ret = wasm.tablelinkjs_pair_count_js(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    get second_column_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_column_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * All column ids on the second endpoint, in pair order.
     * @returns {string[]}
     */
    get second_column_ids_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_column_ids_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get second_column_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_column_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * All column display names on the second endpoint, in pair order.
     * @returns {string[]}
     */
    get second_column_names_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_column_names_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get second_join_part_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_join_part_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get second_table_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_table_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get second_table_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_second_table_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_link_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinkjs_table_link_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_js_value() {
        const ret = wasm.tablelinkjs_to_js_value(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) TableLinkJS.prototype[Symbol.dispose] = TableLinkJS.prototype.free;

export class TableLinksGroupedJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableLinksGroupedJS.prototype);
        obj.__wbg_ptr = ptr;
        TableLinksGroupedJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableLinksGroupedJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablelinksgroupedjs_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get broken_count_js() {
        const ret = wasm.tablelinksgroupedjs_broken_count_js(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {TableLinkJS[]}
     */
    get links() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinksgroupedjs_links(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get table_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinksgroupedjs_table_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinksgroupedjs_table_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {TableSourceJS | undefined}
     */
    get table_source_js() {
        const ret = wasm.tablelinksgroupedjs_table_source_js(this.__wbg_ptr);
        return ret === 14 ? undefined : ret;
    }
    /**
     * @returns {string}
     */
    get table_status_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablelinksgroupedjs_table_status_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) TableLinksGroupedJS.prototype[Symbol.dispose] = TableLinksGroupedJS.prototype.free;

export class TableMetadataJS {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableMetadataJS.prototype);
        obj.__wbg_ptr = ptr;
        TableMetadataJSFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableMetadataJSFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablemetadatajs_free(ptr, 0);
    }
    /**
     * @returns {TableColumnMetadataJS[]}
     */
    get columns() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tablemetadatajs_columns(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_modeldetails_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get version() {
        const ret = wasm.__wbg_get_tablemetadatajs_version(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @param {TableColumnMetadataJS[]} arg0
     */
    set columns(arg0) {
        const ptr0 = passArrayJsValueToWasm0(arg0, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tablemetadatajs_columns(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_modeldetails_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set version(arg0) {
        wasm.__wbg_set_columnmodel_created_at(this.__wbg_ptr, arg0);
    }
    /**
     * @param {any} value
     * @returns {TableMetadataJS}
     */
    static from_js_value(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tablemetadatajs_from_js_value(retptr, addHeapObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableMetadataJS.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} id
     * @param {bigint} version
     * @param {TableColumnMetadataJS[]} columns
     */
    constructor(id, version, columns) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(columns, wasm.__wbindgen_export);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.tablemetadatajs_new(ptr0, len0, version, ptr1, len1);
        this.__wbg_ptr = ret >>> 0;
        TableMetadataJSFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {any}
     */
    to_js_value() {
        const ret = wasm.tablemetadatajs_to_js_value(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) TableMetadataJS.prototype[Symbol.dispose] = TableMetadataJS.prototype.free;

export class TableNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablenotification_free(ptr, 0);
    }
}
if (Symbol.dispose) TableNotification.prototype[Symbol.dispose] = TableNotification.prototype.free;

export class TableOwnershipTransfer {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableOwnershipTransfer.prototype);
        obj.__wbg_ptr = ptr;
        TableOwnershipTransferFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableOwnershipTransferFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableownershiptransfer_free(ptr, 0);
    }
    /**
     * @param {string} table_id
     * @param {string} from_model
     * @param {string} to_model
     * @returns {TableOwnershipTransfer}
     */
    static new_js(table_id, from_model, to_model) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(table_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(from_model, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(to_model, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.tableownershiptransfer_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TableOwnershipTransfer.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.tableownershiptransfer_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) TableOwnershipTransfer.prototype[Symbol.dispose] = TableOwnershipTransfer.prototype.free;

export class TableOwnershipTransferRequestNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableOwnershipTransferRequestNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableownershiptransferrequestnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) TableOwnershipTransferRequestNotification.prototype[Symbol.dispose] = TableOwnershipTransferRequestNotification.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3}
 */
export const TableRelation = Object.freeze({
    SharedWith: 0, "0": "SharedWith",
    SharedWithReshare: 1, "1": "SharedWithReshare",
    ParentModelOwner: 2, "2": "ParentModelOwner",
    ImportedInModel: 3, "3": "ImportedInModel",
});

export class TableRequestNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableRequestNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablerequestnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) TableRequestNotification.prototype[Symbol.dispose] = TableRequestNotification.prototype.free;

export class TableScheduledForDeletionNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableScheduledForDeletionNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablescheduledfordeletionnotification_free(ptr, 0);
    }
}
if (Symbol.dispose) TableScheduledForDeletionNotification.prototype[Symbol.dispose] = TableScheduledForDeletionNotification.prototype.free;

export class TableSharedNotification {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableSharedNotificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tablesharednotification_free(ptr, 0);
    }
}
if (Symbol.dispose) TableSharedNotification.prototype[Symbol.dispose] = TableSharedNotification.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13}
 */
export const TableSourceJS = Object.freeze({
    GoogleSheet: 0, "0": "GoogleSheet",
    Imported: 1, "1": "Imported",
    ImportedInactive: 2, "2": "ImportedInactive",
    ImportedWaitingForApproval: 3, "3": "ImportedWaitingForApproval",
    Owned: 4, "4": "Owned",
    ImportedTombstoned: 5, "5": "ImportedTombstoned",
    ImportedAccessLost: 6, "6": "ImportedAccessLost",
    ImportedPendingRelease: 7, "7": "ImportedPendingRelease",
    Postgres: 8, "8": "Postgres",
    Supabase: 9, "9": "Supabase",
    Bucket: 10, "10": "Bucket",
    LocalSqliteDatabase: 11, "11": "LocalSqliteDatabase",
    RecipeResult: 12, "12": "RecipeResult",
    App: 13, "13": "App",
});

/**
 * @enum {0 | 1 | 2}
 */
export const TableUsageStatus = Object.freeze({
    Critical: 0, "0": "Critical",
    Moderate: 1, "1": "Moderate",
    Low: 2, "2": "Low",
});

/**
 * A view's columns in its order, and the table's columns it does not show.
 */
export class TableViewColumns {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableViewColumns.prototype);
        obj.__wbg_ptr = ptr;
        TableViewColumnsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableViewColumnsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableviewcolumns_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    get table_columns() {
        const ret = wasm.__wbg_get_tablecolumns_deleted_columns(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {any}
     */
    get view_columns() {
        const ret = wasm.__wbg_get_tablecolumns_table_columns(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {any} arg0
     */
    set table_columns(arg0) {
        wasm.__wbg_set_tablecolumns_deleted_columns(this.__wbg_ptr, addHeapObject(arg0));
    }
    /**
     * @param {any} arg0
     */
    set view_columns(arg0) {
        wasm.__wbg_set_tablecolumns_table_columns(this.__wbg_ptr, addHeapObject(arg0));
    }
}
if (Symbol.dispose) TableViewColumns.prototype[Symbol.dispose] = TableViewColumns.prototype.free;

/**
 * A struct that is used to hold general information about a table view, that can be shown in the frontend
 */
export class TableViewDetails {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TableViewDetails.prototype);
        obj.__wbg_ptr = ptr;
        TableViewDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TableViewDetailsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tableviewdetails_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get active_rows() {
        const ret = wasm.__wbg_get_tablediffviewdetails_modified_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Columns the view shows; the columns themselves are `ClientApp::get_table_view_columns`.
     * @returns {number}
     */
    get column_count() {
        const ret = wasm.__wbg_get_tablediffviewdetails_total_changes(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {bigint}
     */
    get created_at() {
        const ret = wasm.__wbg_get_tablediffviewdetails_version_timestamp_b(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    get created_by() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_created_by(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Filter | undefined}
     */
    get filter() {
        const ret = wasm.__wbg_get_tableviewdetails_filter(this.__wbg_ptr);
        return ret === 0 ? undefined : Filter.__wrap(ret);
    }
    /**
     * @returns {boolean}
     */
    get hint_outdated() {
        const ret = wasm.__wbg_get_tableviewdetails_hint_outdated(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * One unnamed, untyped column and no rows: the table a new one starts as.
     * @returns {boolean}
     */
    get is_blank() {
        const ret = wasm.__wbg_get_tableviewdetails_is_blank(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    get order() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_order(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {TableSourceJS}
     */
    get source() {
        const ret = wasm.__wbg_get_tableviewdetails_source(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string | undefined}
     */
    get staged_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_staged_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string}
     */
    get table_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_table_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get table_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_table_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get table_version() {
        const ret = wasm.__wbg_get_tableviewdetails_table_version(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {string}
     */
    get view_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_view_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get view_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_tableviewdetails_view_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {number} arg0
     */
    set active_rows(arg0) {
        wasm.__wbg_set_tablediffviewdetails_modified_count(this.__wbg_ptr, arg0);
    }
    /**
     * Columns the view shows; the columns themselves are `ClientApp::get_table_view_columns`.
     * @param {number} arg0
     */
    set column_count(arg0) {
        wasm.__wbg_set_tablediffviewdetails_total_changes(this.__wbg_ptr, arg0);
    }
    /**
     * @param {bigint} arg0
     */
    set created_at(arg0) {
        wasm.__wbg_set_tablediffviewdetails_version_timestamp_b(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set created_by(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_created_by(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {Filter | null} [arg0]
     */
    set filter(arg0) {
        let ptr0 = 0;
        if (!isLikeNone(arg0)) {
            _assertClass(arg0, Filter);
            ptr0 = arg0.__destroy_into_raw();
        }
        wasm.__wbg_set_tableviewdetails_filter(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {boolean} arg0
     */
    set hint_outdated(arg0) {
        wasm.__wbg_set_tableviewdetails_hint_outdated(this.__wbg_ptr, arg0);
    }
    /**
     * One unnamed, untyped column and no rows: the table a new one starts as.
     * @param {boolean} arg0
     */
    set is_blank(arg0) {
        wasm.__wbg_set_tableviewdetails_is_blank(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set order(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_order(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {TableSourceJS} arg0
     */
    set source(arg0) {
        wasm.__wbg_set_tableviewdetails_source(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string | null} [arg0]
     */
    set staged_name(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_staged_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set table_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_table_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set table_name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_table_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {bigint} arg0
     */
    set table_version(arg0) {
        wasm.__wbg_set_tableviewdetails_table_version(this.__wbg_ptr, arg0);
    }
    /**
     * @param {string} arg0
     */
    set view_id(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_view_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {string} arg0
     */
    set view_name(arg0) {
        const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_tableviewdetails_view_name(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */
    display_name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tableviewdetails_display_name(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) TableViewDetails.prototype[Symbol.dispose] = TableViewDetails.prototype.free;

/**
 * @enum {0 | 1}
 */
export const TokenScope = Object.freeze({
    /**
     * Allows only viewing the table,
     */
    Read: 0, "0": "Read",
    /**
     * Allows editing the table.
     */
    Write: 1, "1": "Write",
});

export class TrashModel {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TrashModel.prototype);
        obj.__wbg_ptr = ptr;
        TrashModelFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TrashModelFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_trashmodel_free(ptr, 0);
    }
    /**
     * @returns {string | undefined}
     */
    get color_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_color_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {any} value
     * @returns {TrashModel}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TrashModel.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @returns {number | undefined}
     */
    get icon_js() {
        const ret = wasm.trashmodel_icon_js(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * @returns {string}
     */
    get model_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_model_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    get model_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_model_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */
    get scheduled_deletion_date_js() {
        const ret = wasm.trashmodel_scheduled_deletion_date_js(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {TableDeletionInfo[]}
     */
    get tables_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_tables_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_export4(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get tables_scheduled_for_deletion_count() {
        const ret = wasm.trashmodel_tables_scheduled_for_deletion_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string | undefined}
     */
    get via_space_id_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_via_space_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string | undefined}
     */
    get via_space_name_js() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.trashmodel_via_space_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_export4(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) TrashModel.prototype[Symbol.dispose] = TrashModel.prototype.free;

/**
 * HTTP request body for updating notification status.
 * Does not include `client_id` — the authenticated session provides it.
 */
export class UpdateNotificationBody {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UpdateNotificationBody.prototype);
        obj.__wbg_ptr = ptr;
        UpdateNotificationBodyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UpdateNotificationBodyFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_updatenotificationbody_free(ptr, 0);
    }
    /**
     * @param {string} notification_id
     * @param {NotificationStatus} status
     * @returns {UpdateNotificationBody}
     */
    static new_js(notification_id, status) {
        const ptr0 = passStringToWasm0(notification_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.updatenotificationbody_new_js(ptr0, len0, status);
        return UpdateNotificationBody.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    notification_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.notificationpreferences_user_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {NotificationStatus}
     */
    status_js() {
        const ret = wasm.updatenotificationbody_status_js(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.updatenotificationbody_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) UpdateNotificationBody.prototype[Symbol.dispose] = UpdateNotificationBody.prototype.free;

/**
 * HTTP request body for notification preferences.
 * Does not include `user_id` — the authenticated session provides it.
 */
export class UpdatePreferencesBody {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UpdatePreferencesBody.prototype);
        obj.__wbg_ptr = ptr;
        UpdatePreferencesBodyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UpdatePreferencesBodyFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_updatepreferencesbody_free(ptr, 0);
    }
    /**
     * @param {boolean} in_email_notification
     * @param {boolean} enabled
     * @returns {UpdatePreferencesBody}
     */
    static new_js(in_email_notification, enabled) {
        const ret = wasm.updatepreferencesbody_new_js(in_email_notification, enabled);
        return UpdatePreferencesBody.__wrap(ret);
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.updatepreferencesbody_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) UpdatePreferencesBody.prototype[Symbol.dispose] = UpdatePreferencesBody.prototype.free;

export class UserAccess {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UserAccess.prototype);
        obj.__wbg_ptr = ptr;
        UserAccessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UserAccessFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_useraccess_free(ptr, 0);
    }
    /**
     * @param {any} value
     * @returns {UserAccess}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useraccess_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UserAccess.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @returns {boolean}
     */
    is_pending_js() {
        const ret = wasm.useraccess_is_pending_js(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    permission_display_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useraccess_permission_display_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    permission_or_role_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useraccess_permission_or_role_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    resource_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useraccess_resource_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.useraccess_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {UserIdentification}
     */
    user_js() {
        const ret = wasm.useraccess_user_js(this.__wbg_ptr);
        return UserIdentification.__wrap(ret);
    }
}
if (Symbol.dispose) UserAccess.prototype[Symbol.dispose] = UserAccess.prototype.free;

export class UserIdentification {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UserIdentification.prototype);
        obj.__wbg_ptr = ptr;
        UserIdentificationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UserIdentificationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_useridentification_free(ptr, 0);
    }
    /**
     * @param {any} value
     * @returns {UserIdentification}
     */
    static from_js(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_from_js(retptr, addBorrowedObject(value));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UserIdentification.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} user_id
     * @param {string} user_name
     * @param {string} user_email
     * @param {string} user_icon
     * @param {string} user_color
     * @returns {UserIdentification}
     */
    static new_js(user_id, user_name, user_email, user_icon, user_color) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(user_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(user_email, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            const ptr3 = passStringToWasm0(user_icon, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len3 = WASM_VECTOR_LEN;
            const ptr4 = passStringToWasm0(user_color, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len4 = WASM_VECTOR_LEN;
            wasm.useridentification_new_js(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UserIdentification.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    to_json() {
        const ret = wasm.useridentification_to_json(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {string}
     */
    user_color_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_user_color_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    user_email_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_user_email_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    user_icon_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_user_icon_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    user_id_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_user_id_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    user_name_js() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.useridentification_user_name_js(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) UserIdentification.prototype[Symbol.dispose] = UserIdentification.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3}
 */
export const UserModelRole = Object.freeze({
    Viewer: 0, "0": "Viewer",
    Collaborator: 1, "1": "Collaborator",
    Owner: 2, "2": "Owner",
    None: 3, "3": "None",
});

export class UserResourcePermissions {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UserResourcePermissionsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_userresourcepermissions_free(ptr, 0);
    }
}
if (Symbol.dispose) UserResourcePermissions.prototype[Symbol.dispose] = UserResourcePermissions.prototype.free;

/**
 * The server's pair-derived link-authority rule (`common_core::table::link_authority::link_verdict`).
 * @param {boolean} first_can_edit
 * @param {boolean} first_is_catalog_member
 * @param {boolean} first_is_recipe_result
 * @param {boolean} second_can_edit
 * @param {boolean} second_is_catalog_member
 * @param {boolean} second_is_recipe_result
 * @param {boolean} is_catalog_manager
 * @returns {boolean}
 */
export function can_mutate_link(first_can_edit, first_is_catalog_member, first_is_recipe_result, second_can_edit, second_is_catalog_member, second_is_recipe_result, is_catalog_manager) {
    const ret = wasm.can_mutate_link(first_can_edit, first_is_catalog_member, first_is_recipe_result, second_can_edit, second_is_catalog_member, second_is_recipe_result, is_catalog_manager);
    return ret !== 0;
}

/**
 * @param {PhysicalKind} source
 * @param {PhysicalKind} target
 * @returns {CastCompatibility}
 */
export function cast_compatibility(source, target) {
    const ret = wasm.cast_compatibility(source, target);
    return ret;
}

export function clear_websocket() {
    wasm.clear_websocket();
}

/**
 * @param {PhysicalKind} data_type
 * @returns {string}
 */
export function data_type_display(data_type) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.data_type_display(retptr, data_type);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Derive the user-facing [`SemanticType`] from a physical `PhysicalKind`. The
 * single source of truth for the Layer-A label, shared by the server and (via
 * wasm) the client type picker / column chip. Total.
 * @param {PhysicalKind} data_type
 * @returns {SemanticType}
 */
export function data_type_semantic(data_type) {
    const ret = wasm.data_type_semantic(data_type);
    return ret;
}

/**
 * @param {PhysicalKind} datatype
 * @returns {string}
 */
export function datatype_display(datatype) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.data_type_display(retptr, datatype);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {PhysicalKind} data_type
 * @returns {any[]}
 */
export function get_operators_for_type(data_type) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.get_operators_for_type(retptr, data_type);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
        wasm.__wbindgen_export4(r0, r1 * 4, 4);
        return v1;
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * The kind an untyped (ND) column self-types to when `input` commits — i.e.
 * `parse_initial`'s verdict without the value. `ND` for empty input.
 *
 * The one source for the magic bar's inferred-type chip. Walking a candidate
 * list for the first `parse_to_target` success cannot substitute: `ListString`
 * and `String` both accept any non-empty input, so the walk reports whichever
 * the list happens to order first, not what the value is.
 * @param {string} input
 * @returns {PhysicalKind}
 */
export function infer_initial_data_type(input) {
    const ptr0 = passStringToWasm0(input, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.infer_initial_data_type(ptr0, len0);
    return ret;
}

/**
 * @param {FilterOperator} op
 * @returns {boolean}
 */
export function is_array_operator(op) {
    const ret = wasm.is_array_operator(op);
    return ret !== 0;
}

/**
 * @param {PhysicalKind} data_type
 * @returns {boolean}
 */
export function is_data_type_numeric(data_type) {
    const ret = wasm.is_data_type_numeric(data_type);
    return ret !== 0;
}

/**
 * True for any temporal column — the timestamp *family* plus `Date`. The
 * column-statistics entry gate is `numeric || temporal`; `is_timestamp_family`
 * alone excludes `Date`, so the stats view needs this wider predicate.
 * @param {PhysicalKind} datatype
 * @returns {boolean}
 */
export function is_data_type_temporal(datatype) {
    const ret = wasm.is_data_type_temporal(datatype);
    return ret !== 0;
}

/**
 * @param {PhysicalKind} data_type
 * @returns {boolean}
 */
export function is_data_type_unsigned(data_type) {
    const ret = wasm.is_data_type_unsigned(data_type);
    return ret !== 0;
}

/**
 * @param {FilterOperator} op
 * @returns {boolean}
 */
export function is_null_operator(op) {
    const ret = wasm.is_null_operator(op);
    return ret !== 0;
}

/**
 * @param {SemanticType} semantic_type
 * @returns {boolean}
 */
export function is_semantic_number(semantic_type) {
    const ret = wasm.is_semantic_number(semantic_type);
    return ret !== 0;
}

/**
 * @param {SemanticType} semantic_type
 * @returns {boolean}
 */
export function is_semantic_text(semantic_type) {
    const ret = wasm.is_semantic_text(semantic_type);
    return ret !== 0;
}

/**
 * True for the three timestamp precision variants — the timestamp
 * *family*. Used by editor routing + chip rendering so a single check
 * covers any current or future precision variant. `Date` is a separate
 * family (no time-of-day component).
 * @param {PhysicalKind} datatype
 * @returns {boolean}
 */
export function is_timestamp_family(datatype) {
    const ret = wasm.is_timestamp_family(datatype);
    return ret !== 0;
}

/**
 * Display-string variant of `is_timestamp_family`. The Rust→JS edit
 * overlay (`EditOverlayKind::CellValue.column_data_type`) carries the
 * `Display` form of `PhysicalKind` over the wire, not the enum value —
 * so the MagicBar router can't call the enum-based helper directly.
 * Centralizing the match here keeps adding a new precision variant a
 * single-file change.
 * @param {string} display
 * @returns {boolean}
 */
export function is_timestamp_family_display(display) {
    const ptr0 = passStringToWasm0(display, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_timestamp_family_display(ptr0, len0);
    return ret !== 0;
}

/**
 * Same resolver the server's `create_link` validation runs, so the picker and the 400 can't
 * disagree. Membership is single-pair only: a dialog with a pair already staged offers Equality.
 * @param {PhysicalKind} first
 * @param {PhysicalKind} second
 * @returns {LinkPairKind}
 */
export function link_pair_kind(first, second) {
    const ret = wasm.link_pair_kind(first, second);
    return ret;
}

/**
 * @returns {number}
 */
export function max_categories() {
    const ret = wasm.max_categories();
    return ret >>> 0;
}

/**
 * @returns {number}
 */
export function max_category_label_chars() {
    const ret = wasm.max_category_label_chars();
    return ret >>> 0;
}

/**
 * @param {FilterOperator} op
 * @param {PhysicalKind} data_type
 * @returns {string}
 */
export function operator_display(op, data_type) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.operator_display(retptr, op, data_type);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {FilterGroupBuilder} filter_builder
 * @param {any} available_tables_js
 */
export function populateFilterDisplayNames(filter_builder, available_tables_js) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(filter_builder, FilterGroupBuilder);
        wasm.populateFilterDisplayNames(retptr, filter_builder.__wbg_ptr, addHeapObject(available_tables_js));
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        if (r1) {
            throw takeObject(r0);
        }
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * @param {SemanticType} semantic_type
 * @returns {string}
 */
export function semantic_type_display(semantic_type) {
    let deferred1_0;
    let deferred1_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.semantic_type_display(retptr, semantic_type);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        deferred1_0 = r0;
        deferred1_1 = r1;
        return getStringFromWasm0(r0, r1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_export4(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {WebSocket} ws
 */
export function set_websocket(ws) {
    try {
        wasm.set_websocket(addBorrowedObject(ws));
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {PhysicalKind} data_type
 * @param {FilterOperator} op
 * @returns {boolean}
 */
export function supports_case_sensitivity(data_type, op) {
    const ret = wasm.supports_case_sensitivity(data_type, op);
    return ret !== 0;
}

/**
 * Single source of truth for the future UI's distinct / primary-key-member
 * toggle visibility. Mirrors `PhysicalKind::supports_distinct_intent`.
 * @param {PhysicalKind} data_type
 * @returns {boolean}
 */
export function supports_distinct_intent(data_type) {
    const ret = wasm.supports_distinct_intent(data_type);
    return ret !== 0;
}

/**
 * Single source of truth for the React UI's "Extract Unique Tuples"
 * section-level menu enable rule (multi-column, N ≥ 2). Mirrors
 * `PhysicalKind::supports_extract_unique_tuple_member`.
 * @param {PhysicalKind} data_type
 * @returns {boolean}
 */
export function supports_extract_unique_tuple_member(data_type) {
    const ret = wasm.supports_extract_unique_tuple_member(data_type);
    return ret !== 0;
}

/**
 * Single source of truth for the React UI's "Extract Unique Values"
 * per-row menu visibility. Mirrors `PhysicalKind::supports_extract_unique_values`.
 * @param {PhysicalKind} data_type
 * @returns {boolean}
 */
export function supports_extract_unique_values(data_type) {
    const ret = wasm.supports_extract_unique_values(data_type);
    return ret !== 0;
}
import * as import1 from "../react-client/src/exports.tsx"
import * as import2 from "../react-client/src/exports.tsx"
import * as import3 from "../react-client/src/exports.tsx"
import * as import4 from "../react-client/src/exports.tsx"
import * as import5 from "../react-client/src/exports.tsx"
import * as import6 from "../react-client/src/exports.tsx"
import * as import7 from "../react-client/src/exports.tsx"
import * as import8 from "../react-client/src/exports.tsx"
import * as import9 from "../react-client/src/exports.tsx"
import * as import10 from "../react-client/src/exports.tsx"

function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_8c4e43fe74559d73: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return addHeapObject(ret);
        },
        __wbg_Number_04624de7d0e8332d: function(arg0) {
            const ret = Number(getObject(arg0));
            return ret;
        },
        __wbg_String_8f0eb39a4a4c2f66: function(arg0, arg1) {
            const ret = String(getObject(arg1));
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_bigint_get_as_i64_8fcf4ce7f1ca72a2: function(arg0, arg1) {
            const v = getObject(arg1);
            const ret = typeof(v) === 'bigint' ? v : undefined;
            getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_boolean_get_bbbb1c18aa2f5e25: function(arg0) {
            const v = getObject(arg0);
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_0bc8482c6e3508ae: function(arg0, arg1) {
            const ret = debugString(getObject(arg1));
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_in_47fa6863be6f2f25: function(arg0, arg1) {
            const ret = getObject(arg0) in getObject(arg1);
            return ret;
        },
        __wbg___wbindgen_is_bigint_31b12575b56f32fc: function(arg0) {
            const ret = typeof(getObject(arg0)) === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_0095a73b8b156f76: function(arg0) {
            const ret = typeof(getObject(arg0)) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_null_ac34f5003991759a: function(arg0) {
            const ret = getObject(arg0) === null;
            return ret;
        },
        __wbg___wbindgen_is_object_5ae8e5880f2c1fbd: function(arg0) {
            const val = getObject(arg0);
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_cd444516edc5b180: function(arg0) {
            const ret = typeof(getObject(arg0)) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_9e4d92534c42d778: function(arg0) {
            const ret = getObject(arg0) === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_eq_11888390b0186270: function(arg0, arg1) {
            const ret = getObject(arg0) === getObject(arg1);
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_9dd77d8cd6671811: function(arg0, arg1) {
            const ret = getObject(arg0) == getObject(arg1);
            return ret;
        },
        __wbg___wbindgen_memory_bd1fbcf21fbef3c8: function() {
            const ret = wasm.memory;
            return addHeapObject(ret);
        },
        __wbg___wbindgen_number_get_8ff4255516ccad3e: function(arg0, arg1) {
            const obj = getObject(arg1);
            const ret = typeof(obj) === 'number' ? obj : undefined;
            getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_72fb696202c56729: function(arg0, arg1) {
            const obj = getObject(arg1);
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_be289d5034ed271b: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg__wbg_cb_unref_d9b87ff7982e3b21: function(arg0) {
            getObject(arg0)._wbg_cb_unref();
        },
        __wbg_altKey_73c1173ba53073d5: function(arg0) {
            const ret = getObject(arg0).altKey;
            return ret;
        },
        __wbg_arc_60bf829e1bd2add5: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
            getObject(arg0).arc(arg1, arg2, arg3, arg4, arg5);
        }, arguments); },
        __wbg_arc_ea6972b72d1eaabc: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
            getObject(arg0).arc(arg1, arg2, arg3, arg4, arg5);
        }, arguments); },
        __wbg_beginPath_9873f939d695759c: function(arg0) {
            getObject(arg0).beginPath();
        },
        __wbg_beginPath_a2e4cce64f4c5081: function(arg0) {
            getObject(arg0).beginPath();
        },
        __wbg_call_389efe28435a9388: function() { return handleError(function (arg0, arg1) {
            const ret = getObject(arg0).call(getObject(arg1));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_call_4708e0c13bdc8e95: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_clearRect_1eed255045515c55: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).clearRect(arg1, arg2, arg3, arg4);
        },
        __wbg_clearRect_516db3d97419eda1: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).clearRect(arg1, arg2, arg3, arg4);
        },
        __wbg_clip_ba921f2227ceeb97: function(arg0) {
            getObject(arg0).clip();
        },
        __wbg_clip_f2700ac6171df6c4: function(arg0) {
            getObject(arg0).clip();
        },
        __wbg_closePath_0da49bed205c580f: function(arg0) {
            getObject(arg0).closePath();
        },
        __wbg_closePath_de4e48859360b1b1: function(arg0) {
            getObject(arg0).closePath();
        },
        __wbg_code_dee0dae4730408e1: function(arg0, arg1) {
            const ret = getObject(arg1).code;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_contextStale_81444fef7fee39c3: function(arg0, arg1) {
            contextStale(getStringFromWasm0(arg0, arg1));
        },
        __wbg_ctrlKey_09a1b54d77dea92b: function(arg0) {
            const ret = getObject(arg0).ctrlKey;
            return ret;
        },
        __wbg_ctrlKey_96ff94f8b18636a3: function(arg0) {
            const ret = getObject(arg0).ctrlKey;
            return ret;
        },
        __wbg_data_5330da50312d0bc1: function(arg0) {
            const ret = getObject(arg0).data;
            return addHeapObject(ret);
        },
        __wbg_delement_new: function(arg0) {
            const ret = DElement.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_deltaMode_a1d1df711e44cefc: function(arg0) {
            const ret = getObject(arg0).deltaMode;
            return ret;
        },
        __wbg_deltaX_f0ca9116db5f7bc1: function(arg0) {
            const ret = getObject(arg0).deltaX;
            return ret;
        },
        __wbg_deltaY_eb94120160ac821c: function(arg0) {
            const ret = getObject(arg0).deltaY;
            return ret;
        },
        __wbg_displayitemjs_new: function(arg0) {
            const ret = DisplayItemJS.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_document_ee35a3d3ae34ef6c: function(arg0) {
            const ret = getObject(arg0).document;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_done_57b39ecd9addfe81: function(arg0) {
            const ret = getObject(arg0).done;
            return ret;
        },
        __wbg_drawImage_1d179f24c5f5719a: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            getObject(arg0).drawImage(getObject(arg1), arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9);
        }, arguments); },
        __wbg_entries_58c7934c745daac7: function(arg0) {
            const ret = Object.entries(getObject(arg0));
            return addHeapObject(ret);
        },
        __wbg_error_9a7fe3f932034cde: function(arg0) {
            console.error(getObject(arg0));
        },
        __wbg_fetchViewForClipboard_1c7d96845d1484a7: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10, arg11, arg12) {
            let v0;
            if (arg11 !== 0) {
                v0 = getStringFromWasm0(arg11, arg12).slice();
                wasm.__wbindgen_export4(arg11, arg12 * 1, 1);
            }
            fetchViewForClipboard(getStringFromWasm0(arg0, arg1), arg2 !== 0, getStringFromWasm0(arg3, arg4), getStringFromWasm0(arg5, arg6), getStringFromWasm0(arg7, arg8), getStringFromWasm0(arg9, arg10), v0);
        },
        __wbg_fillRect_43db352efd893b23: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).fillRect(arg1, arg2, arg3, arg4);
        },
        __wbg_fillRect_d44afec47e3a3fab: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).fillRect(arg1, arg2, arg3, arg4);
        },
        __wbg_fillText_4a931850b976cc62: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).fillText(getStringFromWasm0(arg1, arg2), arg3, arg4);
        }, arguments); },
        __wbg_fillText_763df1c02ddc76e5: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).fillText(getStringFromWasm0(arg1, arg2), arg3, arg4);
        }, arguments); },
        __wbg_fill_1eb35c386c8676aa: function(arg0) {
            getObject(arg0).fill();
        },
        __wbg_fill_6f22ceed79b2a0fa: function(arg0, arg1) {
            getObject(arg0).fill(getObject(arg1));
        },
        __wbg_fill_8ac490b6b4c50288: function(arg0) {
            getObject(arg0).fill();
        },
        __wbg_font_11f8c901210364b6: function(arg0, arg1) {
            const ret = getObject(arg1).font;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_font_d818c85541f22c18: function(arg0, arg1) {
            const ret = getObject(arg1).font;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getContext_2966500392030d63: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = getObject(arg0).getContext(getStringFromWasm0(arg1, arg2));
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        }, arguments); },
        __wbg_getContext_2a5764d48600bc43: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = getObject(arg0).getContext(getStringFromWasm0(arg1, arg2));
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        }, arguments); },
        __wbg_getElementById_e34377b79d7285f6: function(arg0, arg1, arg2) {
            const ret = getObject(arg0).getElementById(getStringFromWasm0(arg1, arg2));
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_getRandomValues_cfa3e51efd7b03ad: function() { return handleError(function (arg0, arg1) {
            globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
        }, arguments); },
        __wbg_getSavedViewport_86534de28ac6b6cf: function(arg0, arg1) {
            const ret = getSavedViewport(getStringFromWasm0(arg0, arg1));
            return addHeapObject(ret);
        },
        __wbg_getTime_1e3cd1391c5c3995: function(arg0) {
            const ret = getObject(arg0).getTime();
            return ret;
        },
        __wbg_get_9b94d73e6221f75c: function(arg0, arg1) {
            const ret = getObject(arg0)[arg1 >>> 0];
            return addHeapObject(ret);
        },
        __wbg_get_b3ed3ad4be2bc8ac: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(getObject(arg0), getObject(arg1));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_get_with_ref_key_1dc361bd10053bfe: function(arg0, arg1) {
            const ret = getObject(arg0)[getObject(arg1)];
            return addHeapObject(ret);
        },
        __wbg_height_38750dc6de41ee75: function(arg0) {
            const ret = getObject(arg0).height;
            return ret;
        },
        __wbg_height_9a49d61734f6cf36: function(arg0) {
            const ret = getObject(arg0).height;
            return ret;
        },
        __wbg_importGraphTable_4d5102d6d310afbd: function(arg0, arg1) {
            importGraphTable(getStringFromWasm0(arg0, arg1));
        },
        __wbg_instanceof_ArrayBuffer_c367199e2fa2aa04: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_CanvasRenderingContext2d_4bb052fd1c3d134d: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof CanvasRenderingContext2D;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_HtmlCanvasElement_3f2f6e1edb1c9792: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof HTMLCanvasElement;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Map_53af74335dec57f4: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof Map;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_OffscreenCanvasRenderingContext2d_27cac106c839cd78: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof OffscreenCanvasRenderingContext2D;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_9b9075935c74707c: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Window_ed49b2db8df90359: function(arg0) {
            let result;
            try {
                result = getObject(arg0) instanceof Window;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_d314bb98fcf08331: function(arg0) {
            const ret = Array.isArray(getObject(arg0));
            return ret;
        },
        __wbg_isSafeInteger_bfbc7332a9768d2a: function(arg0) {
            const ret = Number.isSafeInteger(getObject(arg0));
            return ret;
        },
        __wbg_iterator_6ff6560ca1568e55: function() {
            const ret = Symbol.iterator;
            return addHeapObject(ret);
        },
        __wbg_key_d41e8e825e6bb0e9: function(arg0, arg1) {
            const ret = getObject(arg1).key;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_length_32ed9a279acd054c: function(arg0) {
            const ret = getObject(arg0).length;
            return ret;
        },
        __wbg_length_35a7bace40f36eac: function(arg0) {
            const ret = getObject(arg0).length;
            return ret;
        },
        __wbg_lineTo_c584cff6c760c4a5: function(arg0, arg1, arg2) {
            getObject(arg0).lineTo(arg1, arg2);
        },
        __wbg_lineTo_eeee9227253007c5: function(arg0, arg1, arg2) {
            getObject(arg0).lineTo(arg1, arg2);
        },
        __wbg_linksCreate_5a09a429099d5188: function(arg0, arg1) {
            linksCreate(getStringFromWasm0(arg0, arg1));
        },
        __wbg_linksDelete_ad8a30a334054c30: function(arg0, arg1) {
            linksDelete(getStringFromWasm0(arg0, arg1));
        },
        __wbg_linksFetchForTable_0a0e03194b9594e9: function(arg0, arg1) {
            linksFetchForTable(getStringFromWasm0(arg0, arg1));
        },
        __wbg_linksFetchForTables_c120be999c2887f6: function(arg0, arg1) {
            linksFetchForTables(getStringFromWasm0(arg0, arg1));
        },
        __wbg_location_df7ca06c93e51763: function(arg0) {
            const ret = getObject(arg0).location;
            return addHeapObject(ret);
        },
        __wbg_log_6b5ca2e6124b2808: function(arg0) {
            console.log(getObject(arg0));
        },
        __wbg_measureText_366067c23e41e0ad: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = getObject(arg0).measureText(getStringFromWasm0(arg1, arg2));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_measureText_9d64a92333bd05ee: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = getObject(arg0).measureText(getStringFromWasm0(arg1, arg2));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_metaKey_374999c340f70626: function(arg0) {
            const ret = getObject(arg0).metaKey;
            return ret;
        },
        __wbg_metaKey_67113fb40365d736: function(arg0) {
            const ret = getObject(arg0).metaKey;
            return ret;
        },
        __wbg_moveTo_e9190fc700d55b40: function(arg0, arg1, arg2) {
            getObject(arg0).moveTo(arg1, arg2);
        },
        __wbg_moveTo_f235d9d627cd5c99: function(arg0, arg1, arg2) {
            getObject(arg0).moveTo(arg1, arg2);
        },
        __wbg_movementX_ff6524e06bc35b6a: function(arg0) {
            const ret = getObject(arg0).movementX;
            return ret;
        },
        __wbg_movementY_4cec81d9850ad239: function(arg0) {
            const ret = getObject(arg0).movementY;
            return ret;
        },
        __wbg_new_0_73afc35eb544e539: function() {
            const ret = new Date();
            return addHeapObject(ret);
        },
        __wbg_new_1eea5ab661db13e0: function() { return handleError(function (arg0, arg1) {
            const ret = new OffscreenCanvas(arg0 >>> 0, arg1 >>> 0);
            return addHeapObject(ret);
        }, arguments); },
        __wbg_new_361308b2356cecd0: function() {
            const ret = new Object();
            return addHeapObject(ret);
        },
        __wbg_new_3eb36ae241fe6f44: function() {
            const ret = new Array();
            return addHeapObject(ret);
        },
        __wbg_new_b5d9e2fb389fef91: function(arg0, arg1) {
            try {
                var state0 = {a: arg0, b: arg1};
                var cb0 = (arg0, arg1) => {
                    const a = state0.a;
                    state0.a = 0;
                    try {
                        return __wasm_bindgen_func_elem_38428(a, state0.b, arg0, arg1);
                    } finally {
                        state0.a = a;
                    }
                };
                const ret = new Promise(cb0);
                return addHeapObject(ret);
            } finally {
                state0.a = state0.b = 0;
            }
        },
        __wbg_new_dca287b076112a51: function() {
            const ret = new Map();
            return addHeapObject(ret);
        },
        __wbg_new_dd2b680c8bf6ae29: function(arg0) {
            const ret = new Uint8Array(getObject(arg0));
            return addHeapObject(ret);
        },
        __wbg_new_no_args_1c7c842f08d00ebb: function(arg0, arg1) {
            const ret = new Function(getStringFromWasm0(arg0, arg1));
            return addHeapObject(ret);
        },
        __wbg_new_with_path_string_507d0c4f9ef70125: function() { return handleError(function (arg0, arg1) {
            const ret = new Path2D(getStringFromWasm0(arg0, arg1));
            return addHeapObject(ret);
        }, arguments); },
        __wbg_next_3482f54c49e8af19: function() { return handleError(function (arg0) {
            const ret = getObject(arg0).next();
            return addHeapObject(ret);
        }, arguments); },
        __wbg_next_418f80d8f5303233: function(arg0) {
            const ret = getObject(arg0).next;
            return addHeapObject(ret);
        },
        __wbg_notification_new: function(arg0) {
            const ret = Notification.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_now_79ff468e8684c80c: function() { return handleError(function () {
            const ret = Date.now();
            return ret;
        }, arguments); },
        __wbg_now_a3af9a2f4bbaa4d1: function() {
            const ret = Date.now();
            return ret;
        },
        __wbg_now_ebffdf7e580f210d: function(arg0) {
            const ret = getObject(arg0).now();
            return ret;
        },
        __wbg_offsetX_b76b9bb1f9235de9: function(arg0) {
            const ret = getObject(arg0).offsetX;
            return ret;
        },
        __wbg_offsetY_db5c1ddb866e1b82: function(arg0) {
            const ret = getObject(arg0).offsetY;
            return ret;
        },
        __wbg_onFollowStateChanged_d619edeed8fa7388: function(arg0, arg1) {
            onFollowStateChanged(getStringFromWasm0(arg0, arg1));
        },
        __wbg_onParentModelUpdate_60cd99d243bb7681: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8) {
            onParentModelUpdate(getStringFromWasm0(arg0, arg1), getStringFromWasm0(arg2, arg3), getStringFromWasm0(arg4, arg5), arg6 === 0 ? undefined : getStringFromWasm0(arg6, arg7), arg8 === 0xFFFFFF ? undefined : arg8);
        },
        __wbg_onSessionActive_1a62749b52a8a391: function(arg0, arg1) {
            onSessionActive(getStringFromWasm0(arg0, arg1));
        },
        __wbg_onSessionAway_e7a6b828b727ea15: function(arg0, arg1) {
            onSessionAway(getStringFromWasm0(arg0, arg1));
        },
        __wbg_performance_06f12ba62483475d: function(arg0) {
            const ret = getObject(arg0).performance;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_preventDefault_cdcfcd7e301b9702: function(arg0) {
            getObject(arg0).preventDefault();
        },
        __wbg_prototypesetcall_bdcdcc5842e4d77d: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), getObject(arg2));
        },
        __wbg_push_8ffdcb2063340ba5: function(arg0, arg1) {
            const ret = getObject(arg0).push(getObject(arg1));
            return ret;
        },
        __wbg_putIntoClipboard_9bdc041aee400c6c: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            putIntoClipboard(getStringFromWasm0(arg0, arg1), arg2 === 0 ? undefined : getStringFromWasm0(arg2, arg3), getStringFromWasm0(arg4, arg5), arg6 !== 0);
        },
        __wbg_quadraticCurveTo_b39b7adc73767cc0: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).quadraticCurveTo(arg1, arg2, arg3, arg4);
        },
        __wbg_quadraticCurveTo_e8e68a70d5753814: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).quadraticCurveTo(arg1, arg2, arg3, arg4);
        },
        __wbg_queueMicrotask_0aa0a927f78f5d98: function(arg0) {
            const ret = getObject(arg0).queueMicrotask;
            return addHeapObject(ret);
        },
        __wbg_queueMicrotask_5bb536982f78a56f: function(arg0) {
            queueMicrotask(getObject(arg0));
        },
        __wbg_rect_2e9c872527ce75b8: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).rect(arg1, arg2, arg3, arg4);
        },
        __wbg_rect_967665357db991e9: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).rect(arg1, arg2, arg3, arg4);
        },
        __wbg_reload_c8ca3f3b07f9e534: function() { return handleError(function (arg0) {
            getObject(arg0).reload();
        }, arguments); },
        __wbg_repeat_375aae5c5c6a0258: function(arg0) {
            const ret = getObject(arg0).repeat;
            return ret;
        },
        __wbg_requestRowGraphReexpand_6a8be74423992b57: function(arg0) {
            requestRowGraphReexpand(takeObject(arg0));
        },
        __wbg_resolve_002c4b7d9d8f6b64: function(arg0) {
            const ret = Promise.resolve(getObject(arg0));
            return addHeapObject(ret);
        },
        __wbg_restore_0d233789d098ba64: function(arg0) {
            getObject(arg0).restore();
        },
        __wbg_restore_3045f393c0c9d938: function(arg0) {
            getObject(arg0).restore();
        },
        __wbg_saveViewport_d8a7a6aaac2e22ab: function(arg0, arg1, arg2, arg3, arg4) {
            saveViewport(getStringFromWasm0(arg0, arg1), arg2, arg3, arg4);
        },
        __wbg_save_2770d66611203fce: function(arg0) {
            getObject(arg0).save();
        },
        __wbg_save_e0cc2e58b36d33c9: function(arg0) {
            getObject(arg0).save();
        },
        __wbg_scale_036d793f5ad12baa: function() { return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).scale(arg1, arg2);
        }, arguments); },
        __wbg_scale_543277ecf8cf836b: function() { return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).scale(arg1, arg2);
        }, arguments); },
        __wbg_send_542f95dea2df7994: function() { return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).send(getArrayU8FromWasm0(arg1, arg2));
        }, arguments); },
        __wbg_setCanvasCommitState_aface52e837a149e: function(arg0, arg1, arg2, arg3) {
            setCanvasCommitState(getStringFromWasm0(arg0, arg1), __wbindgen_enum_CommitBadgeJS[arg2], arg3 !== 0);
        },
        __wbg_setCanvasFocusPattern_bb07f116f8d5236f: function(arg0) {
            setCanvasFocusPattern(__wbindgen_enum_FocusPatternJS[arg0]);
        },
        __wbg_setCanvasFocus_6d04b3e0a11441d2: function(arg0) {
            setCanvasFocus(takeObject(arg0));
        },
        __wbg_setCanvasInput_207eec7a031e23be: function(arg0) {
            setCanvasInput(takeObject(arg0));
        },
        __wbg_setCanvasMode_4be0277da47225ad: function(arg0) {
            setCanvasMode(__wbindgen_enum_CanvasModeJS[arg0]);
        },
        __wbg_setCellActionIcon_86e3af3d7b0133a9: function(arg0) {
            setCellActionIcon(takeObject(arg0));
        },
        __wbg_setCursorMode_49bc3b5a93835ee9: function(arg0) {
            setCursorMode(__wbindgen_enum_CursorModeJS[arg0]);
        },
        __wbg_setFocusedCell_78f443c9af9e81b6: function(arg0) {
            setFocusedCell(takeObject(arg0));
        },
        __wbg_setFormulaPeek_c82c3e83002a0fd2: function(arg0) {
            setFormulaPeek(takeObject(arg0));
        },
        __wbg_setGraphExternal_7f4d337f57fd9ff7: function(arg0) {
            setGraphExternal(takeObject(arg0));
        },
        __wbg_setGraphOutsideTable_629ef7488b610b9d: function(arg0) {
            setGraphOutsideTable(takeObject(arg0));
        },
        __wbg_setLineDash_0571bd4648dc2689: function() { return handleError(function (arg0, arg1) {
            getObject(arg0).setLineDash(getObject(arg1));
        }, arguments); },
        __wbg_setLineDash_ecf27050368658c9: function() { return handleError(function (arg0, arg1) {
            getObject(arg0).setLineDash(getObject(arg1));
        }, arguments); },
        __wbg_setNewRowCount_da627d26d7ec3c6b: function(arg0) {
            setNewRowCount(arg0 >>> 0);
        },
        __wbg_setOrnamentHint_db896f532fd4c5ea: function(arg0) {
            setOrnamentHint(takeObject(arg0));
        },
        __wbg_setOverflowIcon_2c4779aefccac64a: function(arg0) {
            setOverflowIcon(takeObject(arg0));
        },
        __wbg_setPresenceHint_99cc7c974f7d5300: function(arg0) {
            setPresenceHint(takeObject(arg0));
        },
        __wbg_setProperty_cbb25c4e74285b39: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).setProperty(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
        }, arguments); },
        __wbg_setRowGraphOverlay_67737910562754c9: function(arg0) {
            setRowGraphOverlay(takeObject(arg0));
        },
        __wbg_setRowGraph_b206c582d1b1a02b: function(arg0, arg1) {
            setRowGraph(arg0 >>> 0, arg1 >>> 0);
        },
        __wbg_setSelectedRowCount_dc1b201afd36ce13: function(arg0) {
            setSelectedRowCount(arg0 >>> 0);
        },
        __wbg_setSelectedRow_eaa4df6c608f09b9: function(arg0) {
            setSelectedRow(takeObject(arg0));
        },
        __wbg_setTransform_96b561b274a594ca: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            getObject(arg0).setTransform(arg1, arg2, arg3, arg4, arg5, arg6);
        }, arguments); },
        __wbg_setTransform_9d508c83354fc805: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            getObject(arg0).setTransform(arg1, arg2, arg3, arg4, arg5, arg6);
        }, arguments); },
        __wbg_setZoomRange_0f3ced00bc6e48ca: function(arg0, arg1) {
            setZoomRange(arg0 !== 0, arg1 !== 0);
        },
        __wbg_set_1eb0999cf5d27fc8: function(arg0, arg1, arg2) {
            const ret = getObject(arg0).set(getObject(arg1), getObject(arg2));
            return addHeapObject(ret);
        },
        __wbg_set_3f1d0b984ed272ed: function(arg0, arg1, arg2) {
            getObject(arg0)[takeObject(arg1)] = takeObject(arg2);
        },
        __wbg_set_f43e577aea94465b: function(arg0, arg1, arg2) {
            getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
        },
        __wbg_set_fillStyle_783d3f7489475421: function(arg0, arg1, arg2) {
            getObject(arg0).fillStyle = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_fillStyle_fe482c9f0fcd72ec: function(arg0, arg1, arg2) {
            getObject(arg0).fillStyle = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_font_575685c8f7e56957: function(arg0, arg1, arg2) {
            getObject(arg0).font = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_font_829585bbfa0b84f5: function(arg0, arg1, arg2) {
            getObject(arg0).font = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_globalAlpha_7e6e710a76571ad9: function(arg0, arg1) {
            getObject(arg0).globalAlpha = arg1;
        },
        __wbg_set_globalAlpha_c32898c5532572f4: function(arg0, arg1) {
            getObject(arg0).globalAlpha = arg1;
        },
        __wbg_set_height_b386c0f603610637: function(arg0, arg1) {
            getObject(arg0).height = arg1 >>> 0;
        },
        __wbg_set_height_f21f985387070100: function(arg0, arg1) {
            getObject(arg0).height = arg1 >>> 0;
        },
        __wbg_set_lineJoin_19f52a8c2823283d: function(arg0, arg1, arg2) {
            getObject(arg0).lineJoin = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_lineJoin_9b9f1aaa283be35a: function(arg0, arg1, arg2) {
            getObject(arg0).lineJoin = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_lineWidth_89fa506592f5b994: function(arg0, arg1) {
            getObject(arg0).lineWidth = arg1;
        },
        __wbg_set_lineWidth_dfaf61147c216518: function(arg0, arg1) {
            getObject(arg0).lineWidth = arg1;
        },
        __wbg_set_strokeStyle_087121ed5350b038: function(arg0, arg1, arg2) {
            getObject(arg0).strokeStyle = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_strokeStyle_dc48a0e81b97ed80: function(arg0, arg1, arg2) {
            getObject(arg0).strokeStyle = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_textAlign_a96acf129ddd372c: function(arg0, arg1, arg2) {
            getObject(arg0).textAlign = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_textAlign_cdfa5b9f1c14f5c6: function(arg0, arg1, arg2) {
            getObject(arg0).textAlign = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_textBaseline_61df3e72c1d316b7: function(arg0, arg1, arg2) {
            getObject(arg0).textBaseline = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_textBaseline_c7ec6538cc52b073: function(arg0, arg1, arg2) {
            getObject(arg0).textBaseline = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_width_7f07715a20503914: function(arg0, arg1) {
            getObject(arg0).width = arg1 >>> 0;
        },
        __wbg_set_width_d60bc4f2f20c56a4: function(arg0, arg1) {
            getObject(arg0).width = arg1 >>> 0;
        },
        __wbg_shiftKey_5558a3288542c985: function(arg0) {
            const ret = getObject(arg0).shiftKey;
            return ret;
        },
        __wbg_shiftKey_564be91ec842bcc4: function(arg0) {
            const ret = getObject(arg0).shiftKey;
            return ret;
        },
        __wbg_showConflictDialog_cd5f26be2d14fd57: function(arg0) {
            showConflictDialog(takeObject(arg0));
        },
        __wbg_showNotification_f753760f84f42b67: function(arg0) {
            showNotification(takeObject(arg0));
        },
        __wbg_showTypeChangeConfirm_f81c67b9be660b3a: function(arg0) {
            showTypeChangeConfirm(takeObject(arg0));
        },
        __wbg_static_accessor_GLOBAL_12837167ad935116: function() {
            const ret = typeof global === 'undefined' ? null : global;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_static_accessor_GLOBAL_THIS_e628e89ab3b1c95f: function() {
            const ret = typeof globalThis === 'undefined' ? null : globalThis;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_static_accessor_SELF_a621d3dfbb60d0ce: function() {
            const ret = typeof self === 'undefined' ? null : self;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_static_accessor_WINDOW_f8727f0cf888e0bd: function() {
            const ret = typeof window === 'undefined' ? null : window;
            return isLikeNone(ret) ? 0 : addHeapObject(ret);
        },
        __wbg_strokeRect_4da24de25ed7fbaf: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).strokeRect(arg1, arg2, arg3, arg4);
        },
        __wbg_strokeRect_da9a301c5f321d60: function(arg0, arg1, arg2, arg3, arg4) {
            getObject(arg0).strokeRect(arg1, arg2, arg3, arg4);
        },
        __wbg_stroke_240ea7f2407d73c0: function(arg0) {
            getObject(arg0).stroke();
        },
        __wbg_stroke_8b312cfadb48613c: function(arg0) {
            getObject(arg0).stroke();
        },
        __wbg_style_0b7c9bd318f8b807: function(arg0) {
            const ret = getObject(arg0).style;
            return addHeapObject(ret);
        },
        __wbg_tablecolumnmetadatajs_new: function(arg0) {
            const ret = TableColumnMetadataJS.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_tablecolumnmetadatajs_unwrap: function(arg0) {
            const ret = TableColumnMetadataJS.__unwrap(getObject(arg0));
            return ret;
        },
        __wbg_tabledeletioninfo_new: function(arg0) {
            const ret = TableDeletionInfo.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_tabledetails_new: function(arg0) {
            const ret = TableDetails.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_tablelinkjs_new: function(arg0) {
            const ret = TableLinkJS.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_tablelinksgroupedjs_new: function(arg0) {
            const ret = TableLinksGroupedJS.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_tablemetadatajs_new: function(arg0) {
            const ret = TableMetadataJS.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_then_b9e7b3b5f1a9e1b5: function(arg0, arg1) {
            const ret = getObject(arg0).then(getObject(arg1));
            return addHeapObject(ret);
        },
        __wbg_translate_3aa10730376a8c06: function() { return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).translate(arg1, arg2);
        }, arguments); },
        __wbg_useSendClientDataRequest_d13a44d470553eca: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            let v0;
            if (arg4 !== 0) {
                v0 = getStringFromWasm0(arg4, arg5).slice();
                wasm.__wbindgen_export4(arg4, arg5 * 1, 1);
            }
            useSendClientDataRequest(getStringFromWasm0(arg0, arg1), getStringFromWasm0(arg2, arg3), v0);
        },
        __wbg_useSetColumnSelection_3e7b0367602be915: function(arg0) {
            useSetColumnSelection(takeObject(arg0));
        },
        __wbg_useUpdateActiveUsers_7d109a041d6f72ee: function() {
            const ret = useUpdateActiveUsers();
            return addHeapObject(ret);
        },
        __wbg_useUpdateTableDeletionState_7a17e12e35f7cab5: function(arg0, arg1, arg2, arg3) {
            useUpdateTableDeletionState(getStringFromWasm0(arg0, arg1), arg2 !== 0, arg3 !== 0);
        },
        __wbg_useraccess_new: function(arg0) {
            const ret = UserAccess.__wrap(arg0);
            return addHeapObject(ret);
        },
        __wbg_value_0546255b415e96c1: function(arg0) {
            const ret = getObject(arg0).value;
            return addHeapObject(ret);
        },
        __wbg_warn_f7ae1b2e66ccb930: function(arg0) {
            console.warn(getObject(arg0));
        },
        __wbg_width_5f66bde2e810fbde: function(arg0) {
            const ret = getObject(arg0).width;
            return ret;
        },
        __wbg_width_9bbf873307a2ac4e: function(arg0) {
            const ret = getObject(arg0).width;
            return ret;
        },
        __wbg_width_f12394c19964e4bb: function(arg0) {
            const ret = getObject(arg0).width;
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { dtor_idx: 633, function: Function { arguments: [Externref], shim_idx: 634, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm.__wasm_bindgen_func_elem_4869, __wasm_bindgen_func_elem_4874);
            return addHeapObject(ret);
        },
        __wbindgen_cast_0000000000000002: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return addHeapObject(ret);
        },
        __wbindgen_cast_0000000000000003: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return addHeapObject(ret);
        },
        __wbindgen_cast_0000000000000004: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return addHeapObject(ret);
        },
        __wbindgen_cast_0000000000000005: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return addHeapObject(ret);
        },
        __wbindgen_object_clone_ref: function(arg0) {
            const ret = getObject(arg0);
            return addHeapObject(ret);
        },
        __wbindgen_object_drop_ref: function(arg0) {
            takeObject(arg0);
        },
    };
    return {
        __proto__: null,
        "./target_wasm_bg.js": import0,
        "../react-client/src/exports.tsx": import1,
        "../react-client/src/exports.tsx": import2,
        "../react-client/src/exports.tsx": import3,
        "../react-client/src/exports.tsx": import4,
        "../react-client/src/exports.tsx": import5,
        "../react-client/src/exports.tsx": import6,
        "../react-client/src/exports.tsx": import7,
        "../react-client/src/exports.tsx": import8,
        "../react-client/src/exports.tsx": import9,
        "../react-client/src/exports.tsx": import10,
    };
}

function __wasm_bindgen_func_elem_4874(arg0, arg1, arg2) {
    wasm.__wasm_bindgen_func_elem_4874(arg0, arg1, addHeapObject(arg2));
}

function __wasm_bindgen_func_elem_38428(arg0, arg1, arg2, arg3) {
    wasm.__wasm_bindgen_func_elem_38428(arg0, arg1, addHeapObject(arg2), addHeapObject(arg3));
}


const __wbindgen_enum_CanvasModeJS = ["tabular", "graph", "rowGraph"];


const __wbindgen_enum_CommitBadgeJS = ["hidden", "conflict", "pauseAuto", "commit"];


const __wbindgen_enum_CursorModeJS = ["select", "pan"];


const __wbindgen_enum_FocusPatternJS = ["singleColumn", "multiColumn", "rowSelection", "singleCell", "multiCell", "noFocus"];
const AccessRevokedFromTableNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_accessrevokedfromtablenotification_free(ptr >>> 0, 1));
const AddCheckpointAliasFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_addcheckpointalias_free(ptr >>> 0, 1));
const AvailableTableForFilterJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_availabletableforfilterjs_free(ptr >>> 0, 1));
const BucketSourceInfoJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bucketsourceinfojs_free(ptr >>> 0, 1));
const CanvasLocationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_canvaslocation_free(ptr >>> 0, 1));
const CheckpointFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_checkpoint_free(ptr >>> 0, 1));
const ClearTableReleaseRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cleartablereleaserequest_free(ptr >>> 0, 1));
const ClientAppFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_clientapp_free(ptr >>> 0, 1));
const ColumnIDFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_columnid_free(ptr >>> 0, 1));
const ColumnModelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_columnmodel_free(ptr >>> 0, 1));
const CreateCheckpointRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_createcheckpointrequest_free(ptr >>> 0, 1));
const DElementFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_delement_free(ptr >>> 0, 1));
const DeleteCheckpointRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_deletecheckpointrequest_free(ptr >>> 0, 1));
const DisplayConditionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_displaycondition_free(ptr >>> 0, 1));
const DisplayGroupFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_displaygroup_free(ptr >>> 0, 1));
const DisplayItemJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_displayitemjs_free(ptr >>> 0, 1));
const DisplayStructureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_displaystructure_free(ptr >>> 0, 1));
const EnsureCheckpointRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ensurecheckpointrequest_free(ptr >>> 0, 1));
const FilterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filter_free(ptr >>> 0, 1));
const FilterConditionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filtercondition_free(ptr >>> 0, 1));
const FilterConditionBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filterconditionbuilder_free(ptr >>> 0, 1));
const FilterGroupFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filtergroup_free(ptr >>> 0, 1));
const FilterGroupBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filtergroupbuilder_free(ptr >>> 0, 1));
const GetStorageProfileResponseFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_getstorageprofileresponse_free(ptr >>> 0, 1));
const GoogleSheetFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_googlesheet_free(ptr >>> 0, 1));
const ImportedTableFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_importedtable_free(ptr >>> 0, 1));
const LinkDisplayJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_linkdisplayjs_free(ptr >>> 0, 1));
const LocalSqliteDatabaseFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_localsqlitedatabase_free(ptr >>> 0, 1));
const LocalSqliteSourceInfoJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_localsqlitesourceinfojs_free(ptr >>> 0, 1));
const ModelActionsNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_modelactionsnotification_free(ptr >>> 0, 1));
const ModelDeletionAnalysisFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_modeldeletionanalysis_free(ptr >>> 0, 1));
const ModelDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_modeldetails_free(ptr >>> 0, 1));
const ModelIDFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_modelid_free(ptr >>> 0, 1));
const ModelNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_modelnotification_free(ptr >>> 0, 1));
const NotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_notification_free(ptr >>> 0, 1));
const NotificationPreferencesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_notificationpreferences_free(ptr >>> 0, 1));
const OrgActionNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_orgactionnotification_free(ptr >>> 0, 1));
const OrgMembershipNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_orgmembershipnotification_free(ptr >>> 0, 1));
const OrgNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_orgnotification_free(ptr >>> 0, 1));
const PersonalAccessTokenFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_personalaccesstoken_free(ptr >>> 0, 1));
const PostgresDatabaseFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_postgresdatabase_free(ptr >>> 0, 1));
const RemoveCheckpointAliasFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_removecheckpointalias_free(ptr >>> 0, 1));
const RevokeAccessRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_revokeaccessrequest_free(ptr >>> 0, 1));
const SendInEmailDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sendinemaildetails_free(ptr >>> 0, 1));
const SetCheckpointAliasAsDefaultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_setcheckpointaliasasdefault_free(ptr >>> 0, 1));
const SetTableReleaseRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_settablereleaserequest_free(ptr >>> 0, 1));
const ShareModelRequestFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sharemodelrequest_free(ptr >>> 0, 1));
const SharedAccessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sharedaccess_free(ptr >>> 0, 1));
const SpaceAccessNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_spaceaccessnotification_free(ptr >>> 0, 1));
const SpaceActionNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_spaceactionnotification_free(ptr >>> 0, 1));
const StorageResponseFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_storageresponse_free(ptr >>> 0, 1));
const StreamedDataResponseHeaderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_streameddataresponseheader_free(ptr >>> 0, 1));
const TableAffordancesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableaffordances_free(ptr >>> 0, 1));
const TableColumnMetadataJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablecolumnmetadatajs_free(ptr >>> 0, 1));
const TableColumnRefFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablecolumnref_free(ptr >>> 0, 1));
const TableColumnsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablecolumns_free(ptr >>> 0, 1));
const TableDeletionInfoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tabledeletioninfo_free(ptr >>> 0, 1));
const TableDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tabledetails_free(ptr >>> 0, 1));
const TableDiffViewDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablediffviewdetails_free(ptr >>> 0, 1));
const TableInfoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableinfo_free(ptr >>> 0, 1));
const TableLinkFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablelink_free(ptr >>> 0, 1));
const TableLinkJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablelinkjs_free(ptr >>> 0, 1));
const TableLinksGroupedJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablelinksgroupedjs_free(ptr >>> 0, 1));
const TableMetadataJSFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablemetadatajs_free(ptr >>> 0, 1));
const TableNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablenotification_free(ptr >>> 0, 1));
const TableOwnershipTransferFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableownershiptransfer_free(ptr >>> 0, 1));
const TableOwnershipTransferRequestNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableownershiptransferrequestnotification_free(ptr >>> 0, 1));
const TableRequestNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablerequestnotification_free(ptr >>> 0, 1));
const TableScheduledForDeletionNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablescheduledfordeletionnotification_free(ptr >>> 0, 1));
const TableSharedNotificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tablesharednotification_free(ptr >>> 0, 1));
const TableViewColumnsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableviewcolumns_free(ptr >>> 0, 1));
const TableViewDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tableviewdetails_free(ptr >>> 0, 1));
const TrashModelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_trashmodel_free(ptr >>> 0, 1));
const UpdateNotificationBodyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_updatenotificationbody_free(ptr >>> 0, 1));
const UpdatePreferencesBodyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_updatepreferencesbody_free(ptr >>> 0, 1));
const UserAccessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_useraccess_free(ptr >>> 0, 1));
const UserIdentificationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_useridentification_free(ptr >>> 0, 1));
const UserResourcePermissionsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_userresourcepermissions_free(ptr >>> 0, 1));

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function addBorrowedObject(obj) {
    if (stack_pointer == 1) throw new Error('out of js stack');
    heap[--stack_pointer] = obj;
    return stack_pointer;
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => state.dtor(state.a, state.b));

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat64ArrayMemory0 = null;
function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getObject(idx) { return heap[idx]; }

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_export3(addHeapObject(e));
    }
}

let heap = new Array(128).fill(undefined);
heap.push(undefined, null, true, false);

let heap_next = heap.length;

function isLikeNone(x) {
    return x === undefined || x === null;
}

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            state.dtor(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getDataViewMemory0();
    for (let i = 0; i < array.length; i++) {
        mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let stack_pointer = 128;

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedFloat64ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('target_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
